/* eslint-disable prettier/prettier */
module.exports = {
  app: "App",
  news: "Notizie",
  component: "Componente",
  download: "Scarica",
  downloading: "Scaricamento in corso",
  unableToDownload: "Impossibile scaricare",
  features: "Funzionalità",
  applications: "Applicazioni",
  dashboard: "Pannello",
  customers: "Clienti",
  warehouses: "Magazzini",
  management: "Gestione",
  carriers: "Vettori",
  operations: "Operazioni",
  warehousing: "Magazzinaggio",
  quote: "Preventivo",
  business: "Azienda",
  invoices: "Fatture",
  prepayments: "Acconti",
  billsToPay: "Fatture da Pagare",
  modules: "Moduli",
  agency: "Agenzia",
  pages: "Pagine",
  gallery: "Galleria",
  pricing: "Prezzi",
  privacyPolicy: "Politica sulla Privacy",
  feedback: "Feedback",
  report: "Rapporto",
  faqS: "FAQ",
  advanceComponent: "Componente avanzato",
  blank: "Vuoto",
  session: "Sessione",
  login: "Accesso",
  reset: "Reimposta",
  register: "Registrati",
  lockScreen: "Schermata di Blocco",
  forgotPassword: "Password Dimenticata",
  forgotYourPassword: "Hai dimenticato la password?",
  letsGetYouBackIn: "Riconnettiti",
  recoverPassword: "Recupera password",
  dontWorryJustEnterYourEmailAddressBelowAndWellAssistYou:
    "Non preoccuparti! Inserisci il tuo indirizzo email qui sotto e ti aiuteremo.",
  withInstructionsToResetYourPassword: "con le istruzioni per reimpostare la password",
  checkYourEmail: "Controlla la tua email",
  emailNotReceived: "Email non ricevuta?",
  resend: "Reinvia",
  uiComponents: "Componenti UI",
  alerts: "Avvisi",
  appBar: "Barra dell'App",
  avatars: "Avatar",
  buttons: "Pulsanti",
  bottomNavigations: "Navigazione inferiore",
  badges: "Badge",
  cards: "Schede",
  cardsMasonry: "Schede Masonry",
  chip: "Chip",
  dialog: "Dialogo",
  dividers: "Divisori",
  drawers: "Cassetti",
  draft: "Bozza",
  totalQuotes: "Totale Preventivi",
  inspect: "Ispeziona",
  expansionPanel: "Pannello di espansione",
  gridList: "Lista a Griglia",
  list: "Lista",
  menu: "Menu",
  popOverTooltip: "Pop Over e ToolTip",
  progress: "Avanzamento",
  snackbar: "Snackbar",
  selectionControls: "Controlli di selezione",
  dateTimePicker: "Selettore Data e Ora",
  tabs: "Schede",
  stepper: "Stepper",
  notification: "Notifica",
  notifications: "Notifiche",
  sweetAlert: "Avviso Animato",
  autoComplete: "Completamento automatico",
  aboutUs: "Chi Siamo",
  widgets: "Widget",
  forms: "Moduli",
  formElements: "Elementi Modulo",
  textField: "Campo di testo",
  selectList: "Lista di selezione",
  charts: "Grafici",
  reCharts: "Grafici Re",
  reactChartjs2: "React Chartjs 2",
  icons: "Icone",
  themifyIcons: "Icone Themify",
  simpleLineIcons: "Icone Linee Semplici",
  materialIcons: "Icone Material",
  tables: "Tabelle",
  basic: "Base",
  dataTable: "Tabella Dati",
  responsive: "Responsivo",
  maps: "Mappe",
  googleMaps: "Google Maps",
  leafletMaps: "Mappe Leaflet",
  inbox: "Posta in Arrivo",
  users: "Utenti",
  userProfile1: "Profilo Utente 1",
  userProfile2: "Profilo Utente 2",
  userManagement: "Gestione Utenti",
  userList: "Lista Utenti",
  calendar: "Calendario",
  cultures: "Culture",
  selectable: "Selezionabile",
  customRendering: "Rendering personalizzato",
  chat: "Chat",
  todo: "Da fare",
  editor: "Editor",
  wysiwygEditor: "Editor WYSIWYG",
  quillEditor: "Editor Quill",
  dragAndDrop: "Trascina e Rilascia",
  reactDragula: "React Dragula",
  reactDnd: "React Dnd",
  ecommerce: "Commercio elettronico",
  shopList: "Lista Negozio",
  shopGrid: "Griglia Negozio",
  invoice: "Fattura",
  crm: "CRM",
  ratings: "Valutazioni",
  number: "Numero",
  welcomeBack: "Bentornato!",
  pleaseCreateANewPasswordForYourAccount: "Crea una nuova password per il tuo account",
  emailOrUsername: "Email o nome utente",
  rememberMe: "Ricordami",
  notRegisteredYet: "Non ancora registrato?",
  clickToResend: "Clicca per reinviare",
  clickHere: "clicca qui.",
  youWillBeRedirectedToTheSignInPageIfYouAreNotRedirectedAutomatically:
    "Verrai reindirizzato alla pagina di accesso. Se non vieni reindirizzato automaticamente, ",
  createAnAccount: "Crea un account",
  web: "Web",
  done: "Fatto",
  inProgress: "In corso",
  waiting: "In attesa",
  subscribed: "Abbonato",
  searchItem: "Cerca Articolo",
  startDate: "Inizio Data",
  endDate: "End Data",
  password: "Password",
  newPassword: "Nuovo password",
  createNewPassword: "Crea nuovo password",
  filters: "Filtri",
  private: "Privato",
  corporate: "Aziendale",
  name: "Nome",
  volume: "Volume",
  sidebarOverlay: "Overlay barra laterale",
  appSettings: "App Impostazioni",
  sidebarImage: "Immagine barra laterale",
  miniSidebar: "Barra laterale mini",
  boxLayout: "Layout scatola",
  rtlLayout: "Layout RTL",
  darkMode: "Dark Modalità",
  light: "Leggero",
  dark: "Scuro",
  refresh: "Aggiorna",
  refreshing: "Aggiornamento",
  record: "Record",
  play: "Riproduci",
  start: "Inizio",
  cancel: "Annulla",
  copy: "Copia",
  send: "Invia",
  add: "Aggiungi",
  update: "Aggiorna",
  confirm: "Conferma",
  delete: "Elimina",
  yes: "Sì",
  no: "No",
  addNewContact: "Aggiungi nuovo contatto",
  editAContact: "Modifica a contatto",
  addNewLocation: "Aggiungi nuovo location",
  editALocation: "Modifica a location",
  summary: "Riepilogo",
  week: "Settimana",
  weekday: "Giorno feriale",
  month: "Mese",
  firstName: "First nome",
  lastName: "Last nome",
  address: "Indirizzo",
  description: "Descrizione",
  total: "Totale",
  selectRoom: "Seleziona Room",
  selectDescription: "Seleziona Description",
  addNew: "Aggiungi nuovo",
  revoke: "Revoca",
  assign: "Assegna",
  save: "Salva",
  saveComment: "Salva Comment",
  create: "Crea",
  savePublishTask: "Salva & Publish Attività",
  accept: "Accetta",
  accepted: "Accettato",
  complete: "Completa",
  back: "Indietro",
  ok: "Ok",
  next: "Avanti",
  saveChanges: "Salva Changes",
  cancelChanges: "Annulla Changes",
  more: "Altro",
  remove: "Rimuovi",
  changePhoto: "Change foto",
  booking: "Prenotazione",
  enterBooking: "Inserisci prenotazione",
  user: "Utente",
  promo: "Promozione",
  themeColor: "Theme Colore",
  selectProject: "Seleziona Project",
  shop: "Negozio",
  cart: "Carrello",
  checkout: "Pagamento",
  product: "Prodotto",
  removeProduct: "Rimuovi Prodotto",
  noItemFound: "Nessun articolo trovato",
  saas: "SAAS",
  multilevel: "Multilivello",
  level1: "Livello 1",
  level2: "Livello 2",
  imageCropper: "Ritaglio immagine",
  videoPlayer: "Lettore video",
  dropzone: "Area di rilascio",
  cropImage: "Ritaglia immagine",
  preview: "Anteprima",
  projects: "Progetti",
  projectDetail: "Dettaglio progetto",
  clients: "clienti",
  shipments: "Spedizioni",
  editShipment: "Modifica Spedizione",
  viewShipment: "Visualizza Spedizione",
  newShipment: "Nuovo Spedizione",
  loadBy: "Carica entro",
  createShipment: "Crea Spedizione",
  products: "Prodotti",
  latestScan: "Ultima scansione",
  dateOfLoading: "Data of caricamento",
  editProduct: "Modifica Prodotto",
  newProduct: "Nuovo Prodotto",
  noProductsToShow: "No Prodotti to mostra",
  theProductWasRemovedSuccesfully: "Il prodotto è stato rimosso con successo",
  containers: "Contenitori",
  settings: "Impostazioni",
  cartonQuantity: "Carton Quantità",
  palletQuantity: "Pallet Quantità",
  despatches: "Spedizioni",
  edit: "Modifica",
  details: "Dettagli",
  detail: "Dettaglio",
  locations: "Posizioni",
  comments: "Commenti",
  estimatedDates: "Date stimate",
  destinationWh: "Magazzino destinazione",
  vessel: "Nave",
  vesselName: "Vessel Nome",
  travel: "Viaggio",
  container: "Contenitore",
  containerType: "Contenitore Tipo",
  selectContainerType: "Seleziona Contenitore Tipo",
  shipmentType: "Spedizione Tipo",
  containerNumbers: "Contenitore Numbers",
  grossWeight: "Gross peso",
  inputWeight: "Input Peso",
  project: "Progetto",
  totalQuantity: "Totale Quantità",
  totalPallets: "Totale Pallets",
  eta: "ETA",
  etaFinalPort: "ETA porto finale",
  etaWarehouse: "ETA Magazzino",
  pickUpDate: "Pick up Data",
  scanDate: "Scan Data",
  departureDate: "Data of Departure",
  arrivalAtDestination: "Data of Consegna",
  hawb: "HAWB",
  flightNumber: "Flight Numero",
  airline: "Compagnia aerea",
  etaUnpackData: "Dati ETA disimballaggio",
  actualDates: "Date effettive",
  agent: "Agente",
  agentId: "ID agente",
  agentParentCode: "ID agente padre",
  email: "Email",
  businessAddress: "Business Indirizzo",
  businessContacts: "Business Contatti",
  businessName: "Business Nome",
  businessNumber: "Business numero",
  businessRegistration: "Registrazione aziendale",
  businessRegistrationNumber: "Business Registration Numero",
  mainEmailAddress: "Main email indirizzo",
  website: "Sito web",
  bodyType: "Tipo corpo",
  fuelType: "Fuel Tipo",
  condition: "Condizione",
  engine: "Motore",
  ownership: "Proprietà",
  branch: "Filiale",
  fleetStatus: "Flotta Stato",
  dryStandard: "Secco Standard",
  dryHigh: "Secco Alto",
  tank: "Cisterna",
  open: "Apri",
  openTop: "Apri Top",
  openTopHigh: "Apri Top High",
  flat: "Fisso",
  flatStandard: "Fisso Standard",
  flatHigh: "Fisso Alto",
  reeferStandard: "Reefer Standard",
  reeferHigh: "Reefer Alto",
  po: "N. OA",
  sku: "SKU",
  itemRemovedSuccessfully: "Articolo rimosso con successo!",
  import: "Importa",
  export: "Esporta",
  importCsvFile: "Importa file CSV",
  printDeliveryDocket: "Stampa Consegna Docket",
  despatch: "Spedizione",
  qtyOfCartonsDespatched: "Qtà cartoni spediti",
  qtyOfPalletsDespatched: "Qtà pallet spediti",
  ofDespatches: "N. di spedizioni",
  ofOrdersDespatched: "# of Ordini Despatched",
  stockOnHand: "Scorte disponibili",
  stockOnHandDetailed: "Scorte disponibili - Dettaglio",
  crossDockStatus: "Cross-Dock Stato",
  packing: "Imballaggio",
  addMaterial: "Aggiungi Materiale",
  fillAllFieldsToSave: "Compila tutti i campi per salvare",
  addItem: "Aggiungi articolo",
  instructionStatus: "Istruzione stato",
  selectWhen: "Seleziona quando",
  addInstruction: "Aggiungi Istruzione",
  availableInstructions: "Disponibile Istruzioni",
  remark: "Osservazione",
  inputYourRemarkAndPressEnter: "Inserisci il tuo commento e premi invio",
  uplift: "Ritiro",
  coordinator: "Coordinatore",
  selectedInstructions: "selezionato istruzioni",
  selectAStatus: "Seleziona a stato",
  applyChooseLocations: "Applica & choose locations",
  filterConditions: "Filtra Conditions",
  filterLocations: "Filtra Locations",
  conditions: "Condizioni",
  typeOfPacking: "Tipo of Packing",
  itemStatus: "Articolo Stato",
  itemNumber: "Articolo Numero",
  width: "Larghezza",
  length: "Lunghezza",
  leader: "Responsabile",
  searchLeader: "Cerca responsabile",
  staffs: "Personale",
  searchForStaff: "Cerca for personale",
  fleets: "Flotte",
  searchForFleet: "Cerca per flotta",
  height: "Altezza",
  cartonPerPallet: "Cartone per pallet",
  palletHeight: "Altezza pallet",
  heightWithPallet: "Altezza con pallet",
  heightIncPallet: "Altezza inc. pallet",
  ti: "Ti",
  hi: "Ciao",
  selectProductsBelowToAddThem: "Seleziona i prodotti qui sotto per aggiungerli",
  productSkuSearch: "Prodotto (SKU) Cerca",
  productName: "Prodotto Nome",
  shippingItem: "Shipping Articolo",
  truckTransport: "Camion/Trasporto",
  customerName: "Cliente nome",
  addNewProject: "Aggiungi Nuovo Project",
  projectName: "Project Nome",
  projectCustomer: "Project Cliente",
  importFiles: "Importa File",
  fileHistory: "File Cronologia",
  projectCreatedWithSuccess: "Progetto creato con successo!",
  uploadNewFile: "Carica Nuovo File",
  imapHost: "Host IMAP",
  imapPort: "Porta IMAP",
  emailUser: "Email Utente",
  emailPassword: "Password email",
  useTls: "Usa TLS",
  addNewComment: "Aggiungi nuovo comment",
  typeYourCommentHere: "Scrivi il tuo commento qui",
  order: "Ordine",
  origin: "Origine",
  destination: "Destinazione",
  type: "Tipo",
  dateCreated: "Data creato",
  dateUpdated: "Data aggiornato",
  buyerName: "Buyer nome",
  shipVia: "Spedisci tramite",
  shipTo: "Spedisci a",
  incoterm: "Incoterm",
  createNewSupplier: "Crea nuovo fornitore",
  fulfilled: "Evaso",
  quantityOrdered: "Quantità ordered",
  quantityRequested: "Quantità requested",
  quantityFullfilled: "Quantità fullfilled",
  variation: "Variazione",
  switchToActualInventory: "Switch to Actual Inventario",
  switchToQuotedInventory: "Switch to Quoted Inventario",
  switchToEstimatedInventory: "Switch to Estimated Inventario",
  searchByNameOrEmail: "Cerca by nome or email",
  supplierDetails: "Fornitore Dettagli",
  supplier: "Fornitore",
  supplierName: "Fornitore nome",
  supplierCode: "Fornitore Codice",
  address1: "Indirizzo 1",
  address2: "Indirizzo 2",
  suburbTown: "Quartiere/Città",
  streetNumber: "Street Numero",
  postalCode: "Postal Codice",
  state: "Stato",
  country: "Paese",
  contactName: "Contatto Nome",
  locationStatus: "Location stato",
  filterByShipment: "Filtra per n° Spedizione",
  noInformationToBeShown: "Nessuna informazione da mostrare.",
  loadingShipments: "Caricamento Spedizioni",
  loadingDispatches: "Caricamento Dispatches",
  loadingSuppliers: "Caricamento Fornitori...",
  loadingNotifications: "Caricamento Notifiche",
  task: "Attività",
  usedBy: "Utilizzato da",
  fleetNumber: "Flotta numero",
  make: "Marca",
  model: "Modello",
  body: "Corpo",
  position: "Posizione",
  username: "Nome utente",
  location: "Posizione",
  mainContact: "Main Contatto",
  role: "Ruolo",
  rooms: "Stanze",
  fullName: "Full nome",
  symbol: "Simbolo",
  decimalPoints: "Punti decimali",
  lastUpdate: "Last Aggiorna",
  lastModified: "Ultima modifica",
  flatFee: "Tariffa fissa",
  hourlyFee: "Tariffa oraria",
  halfHourFee: "Tariffa mezz'ora",
  triggers: "Trigger",
  tasksType: "Attività Tipo",
  jobsType: "Jobs Tipo",
  branches: "Filiali",
  updated: "Aggiornato",
  color: "Colore",
  icon: "Icona",
  packaging: "Imballaggio",
  configuration: "Configurazione",
  currency: "Valuta",
  currencies: "Valute",
  measurements: "Misurazioni",
  addCustomCurrency: "Aggiungi custom currency",
  displayUnit: "Unità di visualizzazione",
  languages: "Lingue",
  prefix: "Prefisso",
  language: "Lingua",
  room: "Stanza",
  types: "Tipi",
  descriptiveSymbol: "Simbolo descrittivo",
  descriptiveSymbols: "Simboli descrittivi",
  exceptionSymbol: "SIMBOLO ECCEZIONE",
  exceptionSymbols: "Simboli eccezione",
  locationSymbol: "SIMBOLO POSIZIONE",
  locationSymbols: "Simboli posizione",
  photoIsMandatory: "La foto è obbligatoria",
  selectTheRoom: "Seleziona la stanza",
  editRoom: "Modifica room",
  addNewType: "Aggiungi nuovo tipo",
  editType: "Modifica tipo",
  addNewDescriptiveSymbol: "Aggiungi nuovo descriptive symbol",
  selectSymbol: "Seleziona Symbol",
  editDescriptiveSymbol: "Modifica descriptive symbol",
  addNewExceptionSymbol: "Aggiungi nuovo exception symbol",
  editExceptionSymbol: "Modifica exception symbol",
  addNewLocationSymbol: "Aggiungi nuovo location symbol",
  editLocationSymbol: "Modifica location symbol",
  addNewOne: "Aggiungi uno nuovo",
  createFleet: "Crea Flotta",
  editFleet: "Modifica Flotta",
  viewFleet: "Visualizza Flotta",
  editThisFleet: "Modifica questa flotta",
  addANewFleet: "Aggiungi a nuovo flotta",
  viewThisFleet: "Visualizza questa flotta",
  vinNumber: "Vin Numero",
  year: "Anno",
  engineType: "Engine tipo",
  plateNumber: "Plate numero",
  addCondition: "Aggiungi Condition",
  typeMode: "Tipo Modalità",
  warehouse: "Magazzino",
  searchForWarehouse: "Cerca for magazzino",
  searchForBranch: "Cerca filiale",
  capacity: "Capacità",
  capacityOfEachLiftvan: "Capacità di ogni Liftvan",
  volumeCapacityM3: "Capacità volume (m³)",
  weightCapacityKG: "Peso Capacity (Kg)",
  outOfService: "Fuori servizio",
  serialNumber: "Serial Numero",
  inputSerialNumber: "Inserisci numero di serie",
  mechanicalElectricalChecklist: "Checklist meccanica ed elettrica",
  hasTheMEChecklistBeenDoneOnThisItem: "La checklist M&E è stata compilata per questo articolo?",
  isItWorking: "Funziona?",
  userDetails: "Dettagli Utente",
  permissions: "Permessi",
  placeName: "Nome luogo",
  local: "Locale",
  companyId: "ID Azienda",
  suppliers: "Fornitori",
  newSupplier: "Nuovo Fornitore",
  viewSupplier: "Visualizza Fornitore",
  editSupplier: "Modifica Fornitore",
  printSupplier: "Stampa Fornitore",
  editPlace: "Modifica Luogo",
  newPlace: "Nuovo Luogo",
  newUser: "Nuovo Utente",
  createdAt: "Creato il",
  voyage: "Viaggio",
  voyageNumber: "Numero Viaggio",
  voyageStatus: "Stato Viaggio",
  voyageInformation: "Informazioni sul viaggio",
  containerNumber: "Numero Contenitore",
  inputContainer: "Inserisci Contenitore",
  inputShipment: "Inserisci Spedizione",
  internalReference: "Riferimento interno",
  exportShipment: "Esporta Spedizione",
  eventProductUpdate: "Aggiornamento prodotto evento",
  importProductsEvents: "Importa eventi prodotti",
  view: "Visualizza",
  close: "Chiudi",
  closed: "Chiuso",
  closedForInvoicing: "Chiuso per fatturazione",
  closedForReceiving: "Chiuso per ricezione",
  createNetwork: "Crea rete",
  createCustomer: "Crea cliente",
  createAgent: "Crea agente",
  createSupplier: "Crea fornitore",
  linkAccounts: "Collega account",
  understood: "Capito",
  productEvents: "Eventi Prodotto",
  birthDate: "Data di nascita",
  emergencyName: "Nome di emergenza",
  emergencyPhone: "Telefono di emergenza",
  emergencyRelationship: "Relazione di emergenza",
  gender: "Genere",
  skills: "Competenze",
  residencyStatus: "Stato di residenza",
  certificates: "Certificati",
  addressLine1: "Riga indirizzo 1",
  addressLine2: "Riga indirizzo 2",
  suburb: "Quartiere",
  staffStatus: "Stato Personale",
  staffMnt: "Personale - MNT",
  editStaff: "Modifica Personale",
  newStaff: "Nuovo Personale",
  saveAsUser: "Salva come Utente",
  yourPasswordMustBeAtLeast12CharactersLong: "La password deve essere di almeno 12 caratteri",
  yourPasswordMustContainAtLeastOneSpecialCharacter:
    "La password deve contenere almeno un carattere speciale",
  pleaseEnterYourPassword: "Inserisci la tua password",
  yourPasswordMustBeAtMaximumOf30CharactersLong:
    "La password non deve superare i 30 caratteri",
  pleaseEnterAValidPhoneNumber: "Inserisci un numero di telefono valido",
  phoneNumber: "Numero di telefono",
  pleaseEnterALastName: "Inserisci un cognome",
  yourLastNameMustBeAtLeast4CharactersLong: "Il cognome deve essere di almeno 4 caratteri",
  pleaseEnterAFirstName: "Inserisci un nome",
  yourFirstNameMustBeAtLeast4CharactersLong: "Il nome deve essere di almeno 4 caratteri",
  pleaseEnterAName: "Inserisci un nome",
  yourNameMustBeAtLeast4CharactersLong: "Il nome deve essere di almeno 4 caratteri",
  yourRegistrationNumberMustBeAtLeast4CharactersLong:
    "Il numero di registrazione deve essere di almeno 4 caratteri",
  pleaseEnterAPhoneNumber: "Inserisci un numero di telefono",
  yourPhoneMustBeAtLeast6CharactersLong: "Il telefono deve essere di almeno 6 caratteri",
  yourWebMustBeAtLeast4CharactersLong: "Il sito web deve essere di almeno 4 caratteri",
  pleaseEnterAAddressLine: "Inserisci una riga di indirizzo",
  yourAddressLineMustBeAtLeast4CharactersLong:
    "La riga dell'indirizzo deve essere di almeno 4 caratteri",
  pleaseEnterASuburb: "Inserisci un quartiere",
  yourSuburbMustBeAtLeast4CharactersLong: "Il quartiere deve essere di almeno 4 caratteri",
  pleaseEnterAStateNumber: "Inserisci un numero di stato/regione",
  yourStateMustBeAtLeast3CharactersLong: "Lo stato/regione deve essere di almeno 3 caratteri",
  pleaseEnterAPostalCodeNumber: "Inserisci un codice postale",
  yourPostalCodeMustBeAtLeast4CharactersLong: "Il codice postale deve essere di almeno 4 caratteri",
  pleaseEnterACountry: "Inserisci un paese",
  yourCountryMustBeAtLeast4CharactersLong: "Il paese deve essere di almeno 4 caratteri",
  newItemSType: "Tipo del nuovo articolo",
  editItemSType: "Modifica tipo articolo",
  newItemSDescription: "Descrizione del nuovo articolo",
  editItemSDescription: "Modifica descrizione articolo",
  network: "Rete",
  anErrorOccurredTryAgain: "Si è verificato un errore, riprova",
  operationPerformedSuccessfully: "Operazione eseguita con successo",
  resendWelcomeEmail: "Reinvia email di benvenuto",
  resendWelcomeEmailConfirmation: "Inviare un'email di benvenuto a [name]?",
  welcomeEmailSentSuccessfully: "Email di benvenuto inviata con successo",
  labelCreated: "Etichetta Creata",
  sunday: "Domenica",
  monday: "Lunedì",
  tuesday: "Martedì",
  wednesday: "Mercoledì",
  thursday: "Giovedì",
  friday: "Venerdì",
  saturday: "Sabato",
  january: "Gennaio",
  february: "Febbraio",
  march: "Marzo",
  april: "Aprile",
  may: "Maggio",
  june: "Giugno",
  july: "Luglio",
  august: "Agosto",
  september: "Settembre",
  october: "Ottobre",
  november: "Novembre",
  december: "Dicembre",
  customerSTimeZone: "Cliente’s time zone",
  startTime: "Ora Inizio",
  endTime: "Ora Fine",
  whatsapp: "WhatsApp",
  sms: "SMS",
  originAddress: "Indirizzo di Origine",
  destinationAddress: "Destination Indirizzo",
  active: "Attivo",
  Active: "Attivo",
  disabled: "Disabilitato",
  sendToAmos: "Invia to AMOS",
  printReports: "Stampa rapporti",
  cancelOrder: "Annulla ordine",
  cancelQuote: "Annulla quote",
  inactive: "Inattivo",
  Inactive: "Inattivo",
  invertStatuses: "Inverti stati",
  filterByStatus: "Filtra per stato",
  activeInactive: "Attivo / Inactive",
  selectType: "Seleziona tipo",
  selectStatus: "Seleziona stato",
  userCode: "Utente codice",
  enterUserCode: "Inserisci utente codice",
  emailAddress: "Email Indirizzo",
  mobileNumber: "Mobile numero",
  contactType: "Contatto tipo",
  enterHere: "Inserisci qui",
  dateOfBirth: "Data of birth",
  typeOfUser: "Tipo of utente",
  thisUserIsALeader: "Questo utente è un responsabile",
  checkThisBoxIfTheUserAboveIsAlsoALeader: "Seleziona questa casella se l'utente sopra è anche un responsabile",
  useEmailAddress: "Use email indirizzo",
  citySuburb: "Città / Quartiere",
  postcode: "CAP",
  countryOrRegion: "Paese or Region",
  timezone: "Fuso orario",
  enterFirstName: "Inserisci nome",
  enterLastName: "Inserisci cognome",
  dateNumberFormat: "Data / numero format",
  defaultCurrency: "Valuta predefinita",
  userInactive: "Utente Inactive",
  roles: "Ruoli",
  communications: "Comunicazioni",
  communicationSubscriptions: "Sottoscrizioni comunicazioni",
  searchByEnter: "Cerca premendo Invio",
  approve: "Approva",
  decline: "Rifiuta",
  activeNetwork: "Attivo Network",
  invites: "Inviti",
  reject: "Rifiuta",
  approved: "Approvato",
  waitingForApproval: "In attesa di approvazione",
  sendToReview: "Invia to review",
  automaticallyInvitationSentBy: "Invito inviato automaticamente da",
  importerExporter: "Importatore ed esportatore",
  newRole: "Nuovo Ruolo",
  editRole: "Modifica Ruolo",
  continue: "Continua",
  saveWithoutAssigning: "Salva without assigning",
  saveAndAssign: "Salva and assegna",
  createRole: "Crea ruolo",
  createRoom: "Crea room",
  updateRole: "Aggiorna ruolo",
  assignUser: "Assegna utente",
  productSIsRequired: "Prodotto/i obbligatorio/i!",
  roleName: "Ruolo nome",
  roleDescriptionOptional: "Ruolo description (opzionale)",
  quoteAssignedTo: "Quote assegnato to",
  manager: "Responsabile",
  searchForManager: "Cerca responsabile",
  youMustEnterAnEntityName: "*Devi inserire un nome entità",
  youMustEnterAnAddress: "*Devi inserire un indirizzo",
  youMustEnterASuburbTown: "*Devi inserire un quartiere/città",
  youMustEnterAState: "*Devi inserire uno stato/regione",
  youMustEnterACountry: "*Devi inserire un paese",
  youMustEnterAPostalcode: "*Devi inserire un codice postale",
  youMustEnterARegistrationNumber: "*Devi inserire un numero di registrazione",
  youMustEnterABillingEmail: "*Devi inserire un'email di fatturazione",
  youMustEnterAMobile: "*Devi inserire un cellulare",
  youMustEnterATimezone: "*Devi inserire un fuso orario",
  youMustEnterAConsultant: "*Devi inserire un consulente",
  youMustEnterAContactPerson: "*Devi inserire una persona di contatto",
  youMustEnterAFirstName: "*Devi inserire un nome",
  youMustEnterALastName: "*Devi inserire un cognome",
  youMustEnterAnEmail: "*Devi inserire un'email",
  youMustEnterAName: "*Devi inserire un nome",
  youMustEnterAPhoneNumber: "*Devi inserire un numero di telefono",
  youMustEnterAParentCode: "*Devi inserire un numero ID padre",
  youMustEnterALocationName: "*Devi inserire un nome posizione",
  youMustEnterAStatus: "*Devi inserire uno stato",
  youMustEnterAnEstablishedYear: "*Devi inserire un anno di fondazione",
  youMustEnterASince: "*Devi inserire una data di inizio",
  youMustEnterAnEntityLegalName: "*Devi inserire una ragione sociale",
  youMustEnterAWebsite: "*Devi inserire un sito web",
  youMustEnterAContactName: "*Devi inserire un nome contatto",
  youMustEnterAContactType: "*Devi inserire un tipo di contatto",
  startTypingToSearchDots: "Inizio typing to cerca...",
  established: "Fondato",
  establishedYear: "Anno di fondazione",
  since: "Da",
  entity: "Entità",
  entityLegalName: "Entity legal nome",
  mobile: "Cellulare",
  customerDetails: "Cliente Dettagli",
  editCustomer: "Modifica cliente",
  useTheSameAddressForPostalAddress: "Utilizzare lo stesso indirizzo come indirizzo postale?",
  registrationNumber: "Registration numero",
  addAnotherContact: "Aggiungi another contatto",
  includeInEmail: "Includi nell'email",
  consultant: "Consulente",
  searchConsultant: "Cerca Consultant",
  searchWarehouse: "Cerca Magazzino",
  searchTimezone: "Cerca Timezone",
  billingEmail: "Email fatturazione",
  postalAddress: "Postal Indirizzo",
  contact: "Contatto",
  contactPerson: "Contatto person",
  invalidLink: "Link non valido",
  closeWindow: "Chiudi window",
  youHaventAcceptedTheInvitation: "Non hai accettato l'invito",
  thisLinkIsNotValidPleaseCheckIfYouHaveAccessedTheCorrectLink:
    "Questo link non è valido. Verifica di aver aperto il link corretto.",
  youCanSafelyCloseThisWindowNowIfYouNeedAnyFurtherAssistanceFeelFreeToReachOutHaveAGreatDay:
    "Ora puoi chiudere questa finestra in sicurezza. Se hai bisogno di ulteriore assistenza, non esitare a contattarci. Buona giornata!",
  enterLocationName: "Inserisci location nome",
  enterWebsite: "Inserisci website",
  enterRegistrationNumber: "Inserisci registration numero",
  primaryContact: "Primary Contatto",
  createLocation: "Crea Location",
  viewLocation: "Visualizza Location",
  editLocation: "Modifica Location",
  jobType: "Job tipo",
  warehouseOrigin: "Magazzino Origin",
  warehouseDestination: "Magazzino Destination",
  tag: "Tag",
  billingAs: "Fatturazione come:",
  leadSourceFrom: "Fonte prospect da",
  moveCoordinator: "Sposta coordinator",
  inventoryQuoted: "Inventario quoted",
  inventoryLeader: "Responsabile inventario",
  inventoryActual: "Inventario actual",
  myDetails: "My dettagli",
  orderDetails: "Ordine dettagli",
  actualAsQuoted: "Effettivo come preventivato",
  movingFrom: "Trasferimento da",
  movingTo: "Trasferimento a",
  itemQuantity: "Articolo quantità",
  inventories: "Inventari",
  originContact: "Origin contatto",
  destinationContact: "Destination contatto",
  seeAccessChecklist: "Vedi checklist di accesso",
  pickupAccessDetails: "Pickup Access Dettagli",
  deliveryAccessDetails: "Consegna Access Dettagli",
  noContactsAdded: "No contatti aggiunto",
  complement: "Complemento",
  street: "Strada",
  typeOfBuilding: "Tipo of building",
  loadingDockHeight: "Caricamento dock height",
  liftAvailable: "Lift disponibile",
  accessInstructions: "Access istruzioni",
  navigationNotes: "Note di navigazione",
  createYourShipeeziAccount: "Crea il tuo account Shipeezi",
  createAccount: "Crea il tuo account",
  haveAnAccountSignIn: "Hai un account? Accedi",
  mode: "Modalità",
  service: "Servizio",
  editOrder: "Modifica Ordine",
  newOrder: "Nuovo Ordine",
  weight: "Peso",
  truckType: "Truck tipo",
  carrier: "Vettore",
  truckBookingNumber: "Truck Prenotazione Numero",
  trackingNumber: "Tracciamento numero",
  palletsPerTruck: "Pallet per camion",
  deliveryDate: "Consegna Data",
  proposedDeliveryDate: "Proposed Consegna Data",
  bookingDetails: "Prenotazione Dettagli",
  deliveryAddress: "Consegna Indirizzo",
  deliveryAddressLine: "Consegna Indirizzo Line",
  deliveryAddressSuburb: "Consegna Indirizzo Suburb",
  receiver: "Ricevente",
  senderAddress: "Sender Indirizzo",
  senderAddressLine: "Sender Indirizzo Line",
  senderAddressSuburb: "Sender Indirizzo Suburb",
  palletsQty: "Qtà pallet",
  cartonQty: "Qtà cartoni",
  despatchDate: "Despatch Data",
  pleaseEnterAYourFirstName: "*Inserisci il tuo nome.",
  pleaseEnterAYourLastName: "*Inserisci il tuo cognome.",
  pleaseEnterAYourEmailAddress: "*Inserisci il tuo indirizzo email.",
  pleaseEnterAPassword: "*Inserisci una password.",
  pleaseConfirmAPassword: "*Conferma la password.",
  pleaseEnterAUsername: "*Inserisci un nome utente.",
  pleaseEnterAMobilePhone: "*Inserisci un numero di cellulare.",
  atLeastOnePhotoIsRequired: "*È richiesta almeno una foto",
  atLeastOneProductIsRequired: "È richiesto almeno un prodotto",
  thisEmailIsInvalid: "*Questa email non è valida",
  thisFieldIsRequired: "Questo campo è obbligatorio",
  selectAnAccessRule: "Seleziona an access rule",
  youNeedToSelectAtLeastOneBranch: "*Devi selezionare almeno una filiale",
  youNeedToSelectAtLeastOneSection: "*Devi selezionare almeno una sezione",
  youNeedToSelectAtLeastOneContact: "*Devi selezionare almeno un contatto",
  youMustEnterACustomer: "*Devi inserire un cliente",
  youMustEnterAEmail: "*Devi inserire un'email",
  youMustEnterAnMobile: "*Devi inserire un cellulare",
  youMustHaveAtLeastOneLocation: "*Devi avere almeno una sede",
  youMustHaveAtLeastOnePrimaryLocation: "*Devi avere almeno una sede principale",
  pleaseEnterAValidEmail: "*Inserisci un'email valida",
  quoted: "Preventivato",
  actual: "Effettivo",
  totalItems: "Totale articoli",
  registered: "Registrato",
  loaded: "Caricato",
  taken: "Preso",
  delivered: "Consegnato",
  void: "Annulla",
  disposal: "Smaltimento",
  missing: "Mancante",
  missingShipment: "Spedizione mancante",
  shipped: "Spedito",
  packed: "Imballato",
  uplifted: "Ritirato",
  bol: "BoL",
  selectNewStatusForItem: "Seleziona nuovo stato for articolo",
  item: "Articolo",
  items: "Articoli",
  packer: "Imballatore",
  selectPacker: "Seleziona Packer",
  selectNewStatusForItems: "Seleziona nuovo stato for articoli",
  newStatus: "Nuovo stato",
  changeItemsStatus: "Change articoli stato",
  addNewItem: "Aggiungi nuovo articolo",
  createNewItem: "Crea nuovo articolo",
  addNewRoom: "Aggiungi Nuovo Room",
  editItem: "Modifica Articolo",
  viewItem: "Visualizza Articolo",
  createNewOne: "Crea + Nuovo One",
  comment: "Commento",
  createNewComment: "Crea nuovo comment",
  newComment: "Nuovo comment",
  commentBy: "Commento di",
  hideCommentHistory: "Nascondi comment cronologia",
  seeCommentHistory: "See comment cronologia",
  copyInfoFromPickup: "Copia informazioni dal ritiro",
  copyInfoFromDelivery: "Copia informazioni dalla consegna",
  pickup: "ritiro",
  pickUp: "Ritiro",
  delivery: "Consegna",
  switchToManual: "Switch to Manual Indirizzo entry",
  switchToGoogle: "Passa all'inserimento Google Maps",
  addAnotherAddress: "Aggiungi another indirizzo",
  selectATask: "Seleziona a attività",
  enterADateInField: "Inserisci una data nel campo",
  theSurveyDateMustBeGreaterThanTheCurrentDate:
    "La data del sopralluogo deve essere successiva alla data corrente",
  time: "Ora",
  date: "Data",
  addATask: "Aggiungi a attività",
  enterOnTheVideoSurvey: "Accedi al video sopralluogo",
  startVideoSurvey: "Avvia video sopralluogo",
  scheduleAVideoSurvey: "Programma a Video Survey",
  thisDateIsInvalid: "Questa data non è valida",
  notAvailable: "Non disponibile",
  addATaskHomeSurveyOrVideoSurveyToCreateAQuote:
    "Aggiungi un'attività Sopralluogo a domicilio o Video sopralluogo per creare un preventivo",
  pickupAccess: "Accesso ritiro",
  deliveryAccess: "Consegna Access",
  switchToPickupAccess: "Passa all'accesso per il ritiro",
  switchToDeliveryAccess: "Switch to consegna access",
  duplicate: "Duplica",
  willTheEntryOfTheHouseBeObstructed: "L'ingresso della casa sarà ostruito?",
  driveway: "Vialetto",
  steep: "Ripido",
  long: "Lungo",
  whatIsTheLengthM: "Qual è la Lunghezza(m)?",
  residence: "Residenza",
  residenceType: "Residence tipo",
  house: "House",
  apartment: "Appartamento",
  level: "Livello",
  howManyLevels: "Quanti livelli?",
  groundFloor: "Piano terra",
  split: "Dividi",
  multiStorey: "Più piani",
  steps: "Passaggi",
  notAuthorizedByCustomer: "Non autorizzato dal cliente",
  photos: "Foto",
  addPhoto: "Aggiungi foto",
  hasLift: "Ha ascensore?",
  lift: "Ascensore",
  internal: "Interno",
  external: "Esterno",
  streetAccess: "Accesso stradale",
  wide: "Largo",
  narrow: "Stretto",
  step: "Passaggio",
  normal: "Normale",
  permitRequired: "Permit obbligatorio",
  oneWay: "Solo andata",
  culDeSac: "Vicolo cieco",
  roundabout: "Rotonda",
  speedHumps: "Dossi",
  noThroughRoad: "Strada senza uscita",
  road: "Strada",
  sea: "Mare",
  air: "Aereo",
  ferry: "Traghetto",
  storage: "Deposito",
  other: "Altro",
  parking: "Parcheggio",
  parkingType: "Parking tipo",
  carry: "Trasporto",
  carryM: "Trasporto(m)",
  treesPowerline: "Alberi/Linea elettrica",
  overhanging: "Sporgente",
  low: "Basso",
  action: "Azione",
  vehicleSize: "Vehicle dimensione",
  small: "Piccolo",
  rigid: "Rigido",
  semi: "Semi",
  isFerryRequired: "È necessario il traghetto?",
  saveAComment: "Salva a comment",
  createComment: "Crea comment",
  saveABookmark: "Salva a bookmark",
  takeAScreenshot: "Cattura una schermata",
  accessDetailsDescribedAboveAreAccurateToTheBestOfMyKnowledge:
    "I dettagli di accesso descritti sopra sono accurati al meglio delle mie conoscenze.",
  specialInstructions: "Special Istruzioni",
  itemInstructionStatus: "Articolo instruction stato",
  deleteAddress: "Elimina indirizzo",
  thereAreItemsOrMaterialsRegisteredWithThisAddressIfYouDeleteThisAddressNowAllItemsWillBeRegisteredWithTheMainDeliveryAddressWouldYouLikeToDoThat:
    "Ci sono articoli o materiali registrati con questo indirizzo. Se elimini questo indirizzo ora, tutti gli articoli saranno registrati con l'indirizzo di consegna principale. Vuoi procedere?",
  inventory: "Inventario",
  itemDetails: "Articolo dettagli",
  materialDetails: "Materiale - Dettagli",
  addAnother: "Aggiungi Another",
  fileIsTooBigMax2Mb: "Il file è troppo grande (Max 2MB)",
  thisFileExtensionIsNotAllowed: "Questa estensione file non è consentita",
  fileIsTooBigMax8Mb: "Il file è troppo grande (Max 8MB)",
  fileAlreadyExistsInThisFolder: "Il file esiste già in questa cartella",
  anotherFolderWithThisNameAlreadyExists: "Un'altra cartella con questo nome esiste già",
  newFolder: "Nuovo Folder",
  upload: "Carica",
  uploading: "Caricamento",
  uploadingYourContent: "Caricamento del tuo contenuto",
  share: "Condividi",
  shared: "Condiviso",
  unshare: "Annulla condivisione",
  notBeingShared: "Non condiviso",
  stopSharing: "Ferma sharing",
  cancelRequest: "Annulla request",
  requestDocument: "Request documento",
  empty: "Vuoto",
  file: "File",
  files: "File",
  folder: "Cartella",
  rename: "Rinomina",
  currentStock: "Scorte attuali",
  theFolderNameIsRequired: "Il nome della cartella è obbligatorio",
  theFileNameIsRequired: "Il nome del file è obbligatorio",
  accessChecklistSummary: "Access Checklist Riepilogo",
  selectAnOption: "Seleziona un'opzione",
  searchTask: "Cerca Attività",
  anErrorOccuredTryAgain: "Si è verificato un errore, riprova.",
  secondContact: "Second Contatto",
  pleaseSelectAQuoteType: "Seleziona un tipo di preventivo",
  pleaseFillAReference: "Inserisci un riferimento",
  pleaseSelectAStatus: "Seleziona uno stato",
  pleaseSelectAConsultant: "Seleziona un consulente",
  pleaseSelectAManager: "Seleziona un responsabile",
  pleaseSelectAMode: "Seleziona una modalità",
  pleaseFillPickUpCustomerFields: "Compila i campi del cliente di ritiro",
  pleaseFillPickUpAddressFields: "Compila i campi dell'indirizzo di ritiro",
  pleaseFillDeliveryCustomerFields: "Compila i campi del cliente di consegna",
  pleaseFillDeliveryAddressFields: "Compila i campi dell'indirizzo di consegna",
  pleaseCheckTheAccessDetailsDescribedOnPickupAccess:
    "Verifica i dettagli di accesso descritti nell'accesso per il ritiro",
  customRange: "Intervallo personalizzato",
  summaryFromSales: "Riepilogo vendite",
  toAddAnOrderClickOnTheButtonBelow: "Per aggiungere un ordine, clicca sul pulsante qui sotto.",
  addOrderToAShipment: "Aggiungi ordine to a spedizione",
  addOrder: "Aggiungi Ordine",
  addOrders: "Aggiungi Ordini",
  changeOrderToAShipment: "Change ordine to a spedizione",
  selectShipmentsBelowToAddThem: "Seleziona le spedizioni qui sotto per aggiungerle.",
  matchOrigin: "Corrispondenza origine",
  matchDestination: "Corrispondenza destinazione",
  notSent: "Non inviato",
  shipmentOrigin: "Origine Spedizione",
  shipmentDestination: "Destinazione Spedizione",
  portName: "Nome Porto",
  airportName: "Nome Aeroporto",
  recordDeleted: "Registro eliminato",
  noVideoRecorded: "Nessun video registrato",
  noCommentsRegistered: "Nessun commento registrato",
  noScreenshotsRegistered: "Nessuna schermata registrata",
  noBookmarksRegistered: "Nessun segnalibro registrato",
  videoSurvey: "Video Sopralluogo",
  videos: "Video",
  communication: "Comunicazione",
  document: "Documento",
  documents: "Documenti",
  documentSharing: "Condivisione documenti",
  documentsForThisBooking: "Documenti per questa prenotazione",
  map: "Mappa",
  costing: "Costi",
  addProduct: "Aggiungi Prodotto",
  addProducts: "Aggiungi Prodotti",
  addProductToCarton: "Aggiungi prodotto al cartone",
  sendEmail: "Invia Email",
  sendSMS: "Invia SMS",
  attachmentFailedPleaseTryAgainLater: "Allegato non riuscito. Riprova più tardi!",
  clickToViewJson: "Clicca per visualizzare JSON",
  closeJsonFile: "Chiudi file JSON",
  invalidEmailFormat: "Formato email non valido",
  emailSuccessfullySent: "Email inviata con successo!",
  somethingWentWrongPleaseTryAgain: "Qualcosa è andato storto. Riprova!",
  typeTheEmailAddressEnter: "Digita l'indirizzo email + Invio",
  addGroupCosting: "Aggiungi costo gruppo",
  deleteConfirmation: "Conferma Eliminazione",
  areYouSureYouWantToRemoveThisItem: "Sei sicuro di voler rimuovere questo articolo?",
  selectAtLeastOneItemToChangeStatus: "Seleziona almeno un articolo per cambiare stato",
  anItemWasAddToTheSelectedRoom: "Un articolo è stato aggiunto alla stanza selezionata",
  aRoomHasBeenAddedToTheInventory: "Una stanza è stata aggiunta all'inventario",
  anItemWasUpdatedAtTheSelectedRoom: "Un articolo è stato aggiornato nella stanza selezionata",
  anItemWasRemovedFromTheSelectedRoom: "Un articolo è stato rimosso dalla stanza selezionata",
  couldNotFindItemToDuplicate: "Impossibile trovare l'articolo da duplicare",
  emailSentSuccesfuly: "Email inviata con successo!",
  smsSentSuccesfuly: "SMS inviato con successo!",
  couldNotSendEmail: "Impossibile inviare l'email",
  ifAMatchingAccountWasFoundAnEmailWasSentTo:
    "Se è stato trovato un account corrispondente, è stata inviata un'email a",
  toAllowYouToResetYourPassword: "per consentirti di reimpostare la password.",
  isAnUser: "È un utente",
  isNotAnUser: "Non è un utente",
  allContacts: "Tutti i contatti",
  seeAllOfYourBusinessContacts: "Vedi tutti i tuoi contatti aziendali",
  editContact: "Modifica contatto",
  addContact: "Aggiungi contatto",
  addLocation: "Aggiungi sede",
  addContactUser: "Aggiungi utente contatto",
  editContactUser: "Modifica utente contatto",
  viewAllContacts: "Visualizza tutti i contatti",
  registerAsAnUser: "Registrati come utente",
  editThisBusinessContact: "Modifica questo contatto aziendale",
  contactDetails: "Dettagli contatto",
  pleaseEnterARegistrationNumber: "Inserisci un numero di registrazione",
  otherDetails: "Altri dettagli",
  shipeeziNetwork: "Rete Shipeezi",
  agentIsConnectedToTheShipeezisNetwork: "L'agente è connesso alla rete Shipeezi",
  inviteToNetwork: "Invita nella rete",
  actions: "Azioni",
  sortBy: "Ordina per",
  inactiveCompany: "Azienda inattiva",
  billing: "Fatturazione",
  primary: "Principale",
  secondary: "Secondario",
  general: "Generale",
  generalPhoto: "Foto Generale",
  overview: "Panoramica",
  manageUsers: "Gestisci utenti",
  monthlyPayment: "Pagamento mensile",
  addSeats: "Aggiungi posti",
  currentPlan: "Piano attuale",
  changePlan: "Cambia piano",
  lastPaidInvoice: "Ultima fattura pagata",
  billingDetails: "Dettagli fatturazione",
  editPaymentDetails: "Modifica dettagli pagamento",
  cardHolder: "Titolare carta",
  creditCardNumber: "Numero carta di credito",
  cvv: "CVV",
  expDate: "Data di scadenza",
  billingAddress: "Indirizzo di fatturazione",
  people: "Persone",
  resources: "Risorse",
  configurations: "Configurazioni",
  preferences: "Preferenze",
  orderType: "Tipo di Ordine",
  leadSource: "Fonte prospect",
  statuses: "Stati",
  integrations: "Integrazioni",
  apiAllied: "API Allied",
  history: "Cronologia",
  checklistForms: "Checklist e Moduli",
  fleet: "Flotta",
  equimpent: "Attrezzatura",
  staff: "Personale",
  itemList: "Lista Articoli",
  packagingType: "Tipo di imballaggio",
  modeType: "Tipo di modalità",
  exceptionCodes: "Codici eccezione",
  exceptionLocationCode: "Codice posizione eccezione",
  materials: "Materiali",
  instructions: "Istruzioni",
  itemDestination: "Destinazione articolo",
  automation: "Automazione",
  access: "Accesso",
  iso174511: "ISO17451-1:2016 - Certificato",
  createNewUser: "Crea nuovo utente",
  createNewRole: "Crea nuovo ruolo",
  createNewCustomer: "Crea nuovo cliente",
  deleteCustomer: "Elimina cliente",
  deleteAgent: "Elimina agente",
  deleteSelected: "Elimina selezionati",
  typePressEnter: "Digita + Premi invio",
  createUser: "Crea utente",
  viewUser: "Visualizza utente",
  viewUsers: "Visualizza utenti",
  editUser: "Modifica utente",
  useCompanyAddress: "Use azienda indirizzo",
  timezoneIsUpdatedAutomaticallyToMatchYourComputerTimezone:
    "Il fuso orario viene aggiornato automaticamente per corrispondere al fuso orario del computer",
  inactiveUser: "Inactive utente",
  activeUser: "Attivo utente",
  logUserOut: "Disconnetti utente",
  searchAndSelectTheRoleTo: "Cerca e seleziona il ruolo per",
  assignUsers: "Assegna utenti",
  searchAndSelectUsersTo: "Cerca and seleziona utenti to",
  viewRole: "Visualizza ruolo",
  editThisRole: "Modifica questo ruolo",
  viewThisRole: "Visualizza questo ruolo",
  setPermissions: "Set permessi",
  addANewItem: "Aggiungi a nuovo articolo",
  viewAnItem: "Visualizza un articolo",
  editAnItem: "Modifica un articolo",
  editLocationForCustomer: "Modifica location for cliente",
  createNewLocationForCustomer: "Crea nuovo location for cliente",
  viewLocationForCustomer: "Visualizza location for cliente",
  editOrderType: "Modifica tipo ordine",
  createNewOrderType: "Crea nuovo ordine tipo",
  editLeadSource: "Modifica lead source",
  createNewLeadSource: "Crea nuovo lead source",
  leadSourceStatus: "Lead source stato",
  editStatus: "Modifica stato",
  createNewStatus: "Crea nuovo stato",
  itemName: "Articolo Nome",
  itemCode: "Articolo Codice",
  itemVolume: "Articolo Volume",
  itemWeight: "Articolo Peso",
  photosAreMandatory: "Le foto sono obbligatorie",
  brandIsMandatory: "Il marchio è obbligatorio",
  commentIsMandatory: "Il commento è obbligatorio",
  mEChecklistIsMandatory: "La checklist M&E è obbligatoria",
  inactiveItem: "Inactive articolo",
  roomName: "Room Nome",
  roomCode: "Room Codice",
  inactiveLocation: "Posizione inattiva",
  editPackagingType: "Modifica Packaging Tipo",
  createPackagingType: "Crea Packaging Tipo",
  packagingTypeName: "Packaging tipo nome",
  packagingTypeCode: "Packaging tipo codice",
  yourComment: "Il tuo commento",
  packagingTypeStatus: "Packaging Tipo stato",
  reason: "Motivo",
  code: "Codice",
  enterTypeOfContact: "Inserisci tipo of contatto",
  dimensions: "Dimensioni",
  couldnTSubscribeShipment: "Couldn't subscribe spedizione",
  couldnTRetrieveShipmentStatus: "Couldn't retrieve spedizione stato",
  voyageStatusUpdated: "Stato viaggio aggiornato",
  pod: "Pod",
  pressEnterToAdd: "Press inserisci to aggiungi",
  inputYourComments: "Inserisci i tuoi commenti",
  portOfDestination: "Porto di scarico (PoD)",
  placeOfDestination: "Luogo di destinazione",
  containerGateInAtPol: "Contenitore gate in at POL",
  containerGateInPort: "Contenitore gate in port",
  nextPort: "Avanti Port",
  containerLoadedAtFirstPolPortOfLoad: "Contenitore loaded at first POL (Port of Load)",
  containerGateOutAtPodPortOfDischarge: "Uscita contenitore al POD (Porto di Scarico)",
  originPort: "Porto origine",
  finalDestinationPort: "Porto destinazione finale",
  estimatedArrival: "Arrivo stimato",
  actualArrival: "Arrivo effettivo",
  carrierEstimatedArrival: "Vettore Estimated Arrival",
  carrierActualArrival: "Vettore Actual Arrival",
  arrivalAtPort: "Arrivo al porto",
  departureAtPort: "Partenza dal porto",
  predictiveArrivalAt: "Arrivo previsto a",
  arrivalAt: "Arrivo a",
  editCurrency: "Modifica Currency",
  createCurrency: "Crea Currency",
  editItemInstruction: "Modifica Articolo Istruzione",
  createItemInstruction: "Crea Articolo Istruzione",
  addANewCurrency: "Aggiungi a nuovo currency",
  australianDollar: "Dollaro australiano",
  a: "A$",
  currencyView: "Currency Visualizza",
  currencyStatus: "Currency stato",
  editLanguage: "Modifica Language",
  actualStatus: "Actual Stato",
  createNewLanguage: "Crea nuovo language",
  baseLanguage: "Lingua base",
  en: "EN",
  measurementStatus: "Measurement stato",
  flag: "Segnalazione",
  where: "Dove",
  usage: "Utilizzo",
  filteringBy: "Filtro per ",
  editModeType: "Modifica Modalità Tipo",
  createModeType: "Crea Modalità Tipo",
  editThisModeType: "Modifica questo tipo di modalità",
  addNewModeType: "Aggiungi nuovo modalità tipo",
  modeTypeStatus: "Modalità tipo stato",
  needAddAHomeOrVideoSurvey: "È necessario aggiungere un sopralluogo a domicilio o video",
  quotedInventory: "Quoted inventario",
  chooseADestination: "Scegli una destinazione",
  aMaterialWasAddToTheSelectedRoom: "Un materiale è stato aggiunto alla stanza selezionata",
  pressEnterToSaveOrEscToCancel: "Press inserisci to salva or ESC to annulla",
  youHaveToChooseAQuoteModeToAddAnItem: "Devi scegliere una modalità preventivo per aggiungere un articolo",
  youHaveToChooseAQuoteModeToAddAMaterial: "Devi scegliere una modalità preventivo per aggiungere un materiale",
  youHaveToSelectARoomBeforeAddAMaterial: "Devi selezionare una stanza prima di aggiungere un materiale",
  aRoomWithThisNameAlreadyExists: "Una stanza con questo nome esiste già",
  youHaveToSelectARoomBeforeAddAnItem: "Devi selezionare una stanza prima di aggiungere un articolo",
  generateToken: "Genera token",
  copyToken: "Copia token",
  copiedSuccessfully: "Copiato con successo",
  unitQty: "Qtà unità",
  productQty: "Prodotto Qty",
  qtyStock: "Qtà (Stock)",
  qtyShipping: "Qtà (Spedizione)",
  latitude: "Latitudine",
  longitude: "Longitudine",
  vesselType: "Vessel Tipo",
  vesselPosition: "Posizione nave",
  speedKnots: "Velocità (Nodi)",
  editMeasurement: "Modifica Measurement",
  createMeasurement: "Crea Measurement",
  createNewStaff: "Crea nuovo personale",
  viewStaff: "Visualizza personale",
  male: "Maschio",
  female: "Femmina",
  createService: "Crea Service",
  editService: "Modifica service",
  viewService: "Visualizza service",
  serviceStatus: "Service stato",
  sellDescription: "Descrizione vendita",
  serviceDescription: "Descrizione servizio",
  sellType: "Sell tipo",
  m3Fee: "Tariffa M3",
  defaultPrice: "Default prezzo",
  serviceGroup: "Service gruppo",
  inputMessage: "Inserisci messaggio",
  viewChecklist: "Visualizza Checklist",
  editChecklist: "Modifica Checklist",
  createChecklist: "Crea Checklist",
  emptyList: "Lista vuota",
  addAll: "Aggiungi tutti",
  addType: "Aggiungi Tipo",
  addBranch: "Aggiungi filiale",
  jobTypeAlreadyExistInTheList: "Il tipo di lavoro esiste già nella lista",
  branchAlreadyExistInTheList: "La filiale esiste già nella lista",
  riskAssessment: "Valutazione del rischio",
  vehicleTrailer: "Veicolo/Rimorchio",
  required: "Obbligatorio",
  title: "Titolo",
  needAction: "Azione necessaria",
  answerAction: "Azione risposta",
  addNewQuestion: "Aggiungi nuovo question",
  trigger: "Trigger",
  addNewTrigger: "Aggiungi nuovo trigger",
  notes: "Note",
  taskTypeAlreadyExistInTheList: "Il tipo di attività esiste già nella lista",
  taskType: "Attività Tipo",
  questions: "Domande",
  appTriggers: "Trigger app",
  beforeStartTask: "Prima di iniziare l'attività",
  beforeContinueTask: "Prima di continuare l'attività",
  beforeFinishTask: "Prima di terminare l'attività",
  beforeAcceptTask: "Prima di accettare l'attività",
  text: "Testo",
  checkbox: "Casella di spunta",
  decimal: "Decimale",
  integer: "Intero",
  signature: "Firma",
  photo: "Foto",
  checkboxText: "Casella di spunta e testo",
  radioButton: "Pulsante radio",
  textarea: "Area di testo",
  radioButtonText: "Pulsante radio e testo",
  johnny: "Johnny",
  bravo: "Bravo",
  john: "John",
  sampleEmailCom: "sample@email.com",
  emergency: "Emergenza",
  pendingCustomerUpload: "In attesa del caricamento cliente",
  sharedWithCustomer: "Condiviso con il cliente",
  resendRequest: "Reinvia richiesta",
  uploadedByCustomer: "Caricato dal cliente",
  noDocumentsRequestedYet: "Nessun documento richiesto ancora",
  donTWorryIfAnyDocumentsAreRequestedByUsYouWillBeNotifiedAndWillBeAbleToManageThem:
    "Non preoccuparti, se vengono richiesti documenti da parte nostra, sarai avvisato e potrai gestirli.",
  oneOrMoreRequiredFieldsAreEmpty: "Uno o più campi obbligatori sono vuoti",
  noChangeHasBeenDetected: "Nessuna modifica rilevata",
  noCommentsBeTheFirstToComment: "Nessun commento! Sii il primo a commentare...",
  mainAddress: "Indirizzo principale",
  createANewBusinessContact: "Crea a nuovo business contatto",
  editABusinessContact: "Modifica a business contatto",
  includeInCommunications: "Includi nelle comunicazioni",
  thisUserNeedsToHaveSomeProjectSelected: "Questo utente deve avere almeno un progetto selezionato",
  thisUserNeedsToHaveSomeRoleSelected: "Questo utente deve avere almeno un ruolo selezionato",
  thePasswordDoesNotMatch: "Le password non corrispondono",
  selectPerformancePrediction: "Seleziona Performance Prediction",
  performancePrediction: "Previsione prestazioni",
  passwordAndConfirmPasswordMustBeTheSame: "Password e conferma password devono essere uguali",
  newPasswordAndConfirmPasswordMustBeTheSame: "Nuova password e conferma password devono essere uguali",
  hiThere: "Ciao!",
  pleaseFindTheJsonFileAttachedForShipmentS: "Trova il file JSON allegato per la/le spedizione/i",
  best: "Cordiali saluti, ",
  discard: "Scarta",
  discardChanges: "Scarta modifiche",
  areYouSureYouWantToDiscardAllChanges: "Sei sicuro di voler scartare tutte le modifiche?",
  thisActionIsPermanentAndCannotBeUndone: "Questa azione è permanente e non può essere annullata!",
  shipeeziAustralia: "Shipeezi Australia",
  supportShipeeziCom: "support@shipeezi.com",
  wwwShipeeziCom: "www.shipeezi.com",
  shipeeziKey: "Chiave Shipeezi",
  termsOfUsePrivacyPolicySecurityPolicy: "Condizioni d'uso, Politica sulla privacy, Politica sulla sicurezza",
  andSaasAgreement: " e Accordo SaaS ",
  agreed: "accettato",
  thisCurrencyIsAlreadyRelatedToACompanyThereforeYouCannotChangeHisStatus:
    "Questa valuta è già associata a un'azienda, pertanto non puoi modificarne lo stato.",
  select: "Seleziona",
  hello: "Ciao,",
  dateRange: "Data Range",
  viewToday: "Visualizza Today",
  activeQuotes: "Attivo Quotes",
  quotedVolume: "Volume preventivato",
  videoSurveys: "Video sopralluoghi",
  activeOrders: "Attivo Ordini",
  orderVolume: "Volume ordini",
  branchOrigin: "Filiale origin",
  branchDestination: "Filiale destination",
  material: "Materiale",
  accessStatus: "Access stato",
  instruction: "Istruzione",
  scheduleCreateSuccessfully: "Programma creato con successo",
  sendAutomaticalyASmsEmailInvite: "Invia automaticaly a SMS/Email invite",
  theEmailOrPhoneIsAlreadyInUseByAnotherCustomer:
    "L'email o il telefono è già in uso da un altro cliente",
  wouldYouLikeToSendTheDetailsOfTheCallToYourCustomerBy:
    "Vuoi inviare i dettagli della chiamata al tuo cliente tramite",
  assignRole: "Assegna Ruolo",
  duplicateRole: "Duplicate Ruolo",
  accessRule: "Regola di accesso",
  accessRules: "Regole di accesso",
  membersInGroup: "Membri in questo gruppo",
  showAll: "Mostra Tutti",
  enterNameForThisGroup: "Inserisci il nome per questo gruppo",
  describeThisGroupInFewWords: "Descrivi questo gruppo in poche parole",
  groupCreatedSuccessfully: "Gruppo '{{groupName}}' creato con successo",
  groupUpdatedSuccessfully: "Gruppo '{{groupName}}' aggiornato con successo",
  anErrorOccurredWhileUpdatingGroup:
    "Si è verificato un errore durante l'aggiornamento del gruppo '{{groupName}}'. Contatta il supporto Shipeezi per assistenza",
  thisIsADefaultSystemGroupThatCannotBeModifiedButYouCanAddOrRemoveMembersFromIt:
    "Questo è un gruppo di sistema predefinito che non può essere modificato, ma puoi aggiungere o rimuovere membri",
  kindlyResolveTheFormErrorsBeforeProceeding:
    "Risolvi gli errori del modulo prima di procedere...",
  theGroupNameAlreadyExistsPleaseChooseADifferentName:
    "Il nome del gruppo '{{groupName}}' esiste già. Scegli un nome diverso.",
  changeStatus: "Change Stato",
  purchase: "Acquisto",
  purchaseOrder: "Purchase Ordine",
  salesOrder: "Sales Ordine",
  asPlanned: "Come pianificato",
  potentialDelay: "Potenziale ritardo",
  delayed: "In ritardo",
  selectAVideoSurveyOfToday: "Seleziona a video survey of today",
  openVideoSurvey: "Apri Video Survey",
  searchOrAddAReference: "Cerca or aggiungi a riferimento",
  searchOriginAddress: "Cerca Origin Indirizzo",
  searchDestinationAddress: "Cerca Destination Indirizzo",
  searchOrAddACustomer: "Cerca or aggiungi a cliente",
  jobAlreadyExists: "Il lavoro esiste già",
  associateCustomer: "Associate Cliente",
  thereIsAlreadyACustomerWithThisEmailOrPhoneNumberDoYouWantToAssociateTheTask:
    "Esiste già un cliente con questa email o numero di telefono, vuoi associare l'attività?",
  associate: "Associa",
  phone: "Telefono",
  translation: "Traduzione",
  viewActivity: "Visualizza Activity",
  seeActivity: "Vedi attività",
  activity: "Attività",
  createItem: "Crea Articolo",
  folders: "cartelle",
  shipment: "Spedizione",
  quotes: "Preventivi",
  estimate: "Stima",
  loadingQuotes: "Caricamento Quotes",
  quotesWonVsLost: "Preventivi vinti vs persi",
  quotesWon: "preventivi vinti",
  quotesLost: "preventivi persi",
  won: "Vinto",
  lost: "Perso",
  lastUpdatedOn: "Ultimo aggiornamento",
  instructionsNotFound: "Istruzioni non trovate",
  quotesPerformed: "Preventivi effettuati",
  ordersByType: "Ordini per tipo",
  orders: "Ordini",
  loadingOrders: "Caricamento Ordini",
  itFeelsABitEmpty: "Sembra un po' vuoto",
  videoName: "Video Nome",
  fetchingVideo: "Recupero video",
  fetchDetails: "Fetch Dettagli",
  videoUploadInProgress: "Video carica in progress",
  noVideoAvailable: "No video disponibile",
  screenshots: "Schermate",
  imageOfAScreenshot: "Immagine di una schermata",
  fetchingScreenshots: "Recupero schermate",
  seeMore: "Vedi di più",
  noScreenshotAvailable: "No screenshot disponibile",
  fetchingComments: "Fetching Commenti",
  noCommentsAvailable: "Nessun commento disponibile",
  screenSharing: "Condivisione schermo",
  bookmarks: "Segnalibri",
  fetchingBookmarks: "Recupero segnalibri",
  noBookmarksAvailable: "No bookmarks disponibile",
  bookmarkSavedSuccessfully: "Segnalibro salvato con successo.",
  couldNotSaveBookmark: "Impossibile salvare il segnalibro",
  searchByCustomerNamePhoneNumberOrEmailAddress:
    "Cerca per nome cliente, numero di telefono o indirizzo email",
  searchManager: "Cerca responsabile",
  totalQty: "Totale Qty",
  totalVolume: "Totale Volume",
  totalWeight: "Totale Peso",
  contacts: "Contatti",
  createANewWarehouse: "Crea a nuovo magazzino",
  editWarehouse: "Modifica magazzino",
  createANewBranch: "Crea a nuovo filiale",
  editBranch: "Modifica filiale",
  viewBranch: "Visualizza filiale",
  viewWarehouse: "Visualizza magazzino",
  closeAllPanels: "Chiudi tutti i pannelli",
  collapseAllPanels: "Collapse tutti panels",
  expandAllPanels: "Expand tutti panels",
  expandAll: "Expand tutti",
  collapseAll: "Collapse tutti",
  tba: "TBA",
  editMaterial: "Modifica materiale",
  createANewMaterial: "Crea a nuovo materiale",
  materialStatus: "Materiale stato",
  isAnItem: "È un articolo?",
  editInstruction: "Modifica instruction",
  createInstruction: "Crea instruction",
  when: "Quando",
  editTaskType: "Modifica tipo attività",
  createTaskType: "Crea tipo attività",
  taskTypeStatus: "Attività tipo stato",
  isBookable: "È prenotabile?",
  isItBookable: "È prenotabile?",
  viewDestination: "Visualizza destination",
  editDestination: "Modifica destination",
  createDestination: "Crea destination",
  destinationStatus: "Destination stato",
  colorValueMustStartWithAndCannotBeAWhiteColor:
    "Il valore del colore deve iniziare con # e non può essere un colore bianco",
  automaticSequencing: "Sequenziamento automatico",
  nextNumber: "Avanti numero",
  changeStatuses: "Cambia stati",
  changeAllSelectedStatusesTo: "Change tutti selezionato statuses to",
  changeItemStatuses: "Cambia stati degli articoli",
  changeAllSelectedItemsStatusesTo: "Change tutti selezionato articoli statuses to",
  visibilityControlAndTransparencyOfYourShipments:
    "Visibilità, controllo e trasparenza delle tue spedizioni.",
  yourRequestHasExpiredMakeANewRecovery: "La tua richiesta è scaduta. Effettua un nuovo recupero",
  pleaseEnterAEmail: "Inserisci un'email.",
  resetPassword: "Reimposta password",
  pleaseCheckYourEmail: "Controlla la tua email.",
  yourPasswordHasBeenUpdated: "La tua password è stata aggiornata.",
  returnToLogin: "Torna all'accesso",
  backToLogin: "Indietro to login",
  didnTReceiveTheEmail: "Non hai ricevuto l'email? ",
  aPasswordResetMessageWasSentToYourEmailAddress:
    "Un messaggio di reimpostazione password è stato inviato al tuo indirizzo email.",
  enterTheEmailAddressAssociatedWithYourAccountAndWeLlSendYouALinkToResetYourPassword:
    "Inserisci l'indirizzo email associato al tuo account e ti invieremo un link per reimpostare la password.",
  createAccessOption: "Crea opzione di accesso",
  editAccessOption: "Modifica opzione di accesso",
  drivewayLength: "Lunghezza vialetto",
  carryDistance: "Distanza di trasporto",
  switchTo: "Passa a",
  questionFieldsAreRequired: "I campi domanda sono obbligatori.",
  triggerFieldTypeIsRequired: "Il tipo di campo trigger è obbligatorio.",
  valueOfEntryIsAlreadyInUsed: "Il valore inserito è già in uso",
  aRoleOfTypeSystemIsSelectedAndCannotBeChanged:
    "È selezionato un ruolo di tipo sistema e non può essere modificato",
  theDateIsWrong: "La data è errata",
  theUserMustBeAtLeast18YearsOldAndUnder100YearsOld:
    "L'utente deve avere almeno 18 anni e meno di 100 anni",
  approveQuote: "Approva preventivo",
  doYouReallyWantToApproveTheQuote: "Vuoi davvero approvare il preventivo?",
  areYouSureYouWantToDeliverThisOrder: "Sei sicuro di voler consegnare questo ordine?",
  areYouSureYouWantToCancelTheOrder: "Sei sicuro di voler annullare l'ordine",
  yesCancelOrder: "Sì, annulla ordine",
  areYouSureYouWantToCancelTheQuote: "Sei sicuro di voler annullare il preventivo",
  yesCancelQuote: "Sì, annulla preventivo",
  oops: "Ops!",
  youShouldCancelTheseTasksInYourAppBeforeContinue:
    "Devi annullare queste attività nella tua app prima di continuare.",
  itLooksLikeSomeTasksOfThisOrderAreInProgress:
    "Sembra che alcune attività di questo ordine siano in corso.",
  declineQuote: "Rifiuta quote",
  doYouReallyWantToDeclineTheQuote: "Vuoi davvero rifiutare il preventivo?",
  viewInCalendarMode: "Visualizza in calendario modalità",
  viewInGridMode: "Visualizza in grid modalità",
  removeAll: "Rimuovi tutti",
  roleNotFound: "Ruolo non trovato",
  userNotFound: "Utente non trovato",
  searchForRole: "Cerca for ruolo...",
  searchForUser: "Cerca for utente...",
  inbound: "In entrata",
  atPort: "Al porto",
  atDc: "Al centro distribuzione",
  ofTotalContainers: "Of totale contenitori",
  containerDistributionByDestination: "Contenitore Distribution By Destination",
  shareLink: "Condividi link",
  cameraOff: "Fotocamera spenta",
  video: "Video",
  microphone: "Microfono",
  joinNow: "Unisciti ora",
  youDidnTAddAnyItemsYet: "Non hai ancora aggiunto nessun articolo",
  copied: "Copiato",
  shareViaApp: "Condividi tramite App",
  shareViaLink: "Condividi tramite link",
  shareViaSms: "Condividi via SMS",
  shareViaWhatsapp: "Condividi via Whatsapp",
  openWhatsappToShare: "Apri Whatsapp to condividi",
  shareViaEMail: "Condividi via E-mail",
  shareTheVideoSurveyWithTheCustomer: "Condividi il video sopralluogo con il cliente",
  shareTheInventoryWithTheCustomer: "Condividi l'inventario con il cliente",
  shareTheEstimateWithTheCustomer: "Condividi la stima con il cliente",
  shareInventory: "Condividi inventario",
  shareEstimate: "Condividi stima",
  shareVideoSurvey: "Condividi video sopralluogo",
  inventoryUpdated: "Inventario aggiornato",
  youAreAboutToLeaveVideoSurveyAreYouSure: "Stai per abbandonare il video sopralluogo. Sei sicuro?",
  theCustomerWillBeForcedToLeaveToo: "Anche il cliente sarà costretto ad andarsene.",
  youHaveUnsavedChangesInTheInventory: "Hai modifiche non salvate nell'inventario.",
  audioDeviceTest: "Test dispositivo audio",
  recording: "Registrazione...",
  playing: "Riproduzione...",
  leave: "Esci",
  noIssuesDetected: "Nessun problema rilevato",
  inputDevice: "Dispositivo di input",
  inputLevel: "Livello di input",
  speaker: "Altoparlante",
  outputDevice: "Dispositivo di uscita",
  outputLevel: "Livello di uscita",
  connectivityAndBandwidthTest: "Test di connettività e larghezza di banda",
  taskTypeIsRequired: "Il tipo di attività è obbligatorio.",
  orderTypeIsRequired: "Il tipo di ordine è obbligatorio.",
  orderTypeStatus: "Stato tipo ordine",
  sequence: "Sequenza",
  poNumber: "Numero OA",
  despatchedQuantity: "Despatched Quantità",
  destinationDcCmlDc: "CD Destinazione (CD CML)",
  estimateClearedForPickUp: "Stima Cleared for Pick Up",
  estimateUnpackDate: "Data stimata di disimballaggio",
  actualArriveWh: "Arrivo effettivo magazzino",
  bookedFor: "Prenotato per",
  at: "a",
  contactEmailCom: "contatto@email.com",
  expectedCallQuality: "Qualità chiamata prevista:",
  deliverOrder: "Consegna ordine",
  generateReport: "Genera rapporto",
  generatePDFreports: "Genera rapporti PDF",
  hideSection: "Nascondi sezione",
  showSection: "Mostra sezione",
  online: "Online",
  offline: "Offline",
  collapse: "Comprimi",
  allow: "Consenti",
  notAllow: "Non consentire",
  allowCustomer: "Consenti al cliente",
  screenshotSavedSuccessfully: "Schermata salvata con successo",
  couldNotSaveScreenshot: "Impossibile salvare lo screenshot",
  couldNotRetrieveScreenshots: "Impossibile recuperare le schermate",
  loadingDespatches: "Caricamento Despatches",
  checklistStatus: "Checklist stato",
  warehouseStatus: "Stato magazzino",
  branchStatus: "Stato filiale",
  someRequiredInformationAreMissing: "Alcune informazioni obbligatorie mancano ",
  addAnExistentContact: "Aggiungi un contatto esistente",
  selectAContact: "Seleziona un contatto",
  hideInput: "Nascondi input",
  hideForm: "Nascondi modulo",
  createNewContact: "Crea nuovo contatto",
  loadingData: "Caricamento dati...",
  qty: "Qtà",
  isThisMaterialAnItem: "Questo materiale è un articolo?",
  automationAndControlForIncreasedSupplyChainVisibility:
    "Automazione e controllo per una maggiore visibilità della catena di approvvigionamento.",
  youHavenTAddedAnyItemsYet: "Non hai ancora aggiunto nessun articolo",
  youHavenTAddedAnyMaterialYet: "Non hai ancora aggiunto nessun materiale",
  prices: "Prezzi",
  createNewPrice: "Crea nuovo prezzo",
  price: "Prezzo",
  addNewGroup: "Aggiungi nuovo gruppo",
  DimensionFee: "Tariffa {dimension}",
  searchAgent: "Cerca agent",
  preferredUplift: "Ritiro preferito",
  accessRuleName: "Nome regola di accesso",
  addAccessRule: "Aggiungi Access Rule",
  groupName: "Nome gruppo",
  newGroup: "Nuovo gruppo",
  subTotal: "Subtotale",
  deleteThisLine: "Elimina questa riga",
  thereMustBeAtLeastOneServiceInAGroup: "Deve esserci almeno un servizio in un gruppo",
  deleteThisGroup: "Elimina questo gruppo",
  thereMustBeAtLeastOneGroupInAPrice: "Deve esserci almeno un gruppo in un prezzo",
  editGroupName: "Modifica nome gruppo",
  searchCurrency: "Cerca currency",
  searchService: "Cerca service",
  priceCreatedSuccessfully: "Prezzo creato con successo",
  groupAddedSuccessfully: "Gruppo aggiunto con successo",
  serviceAddedSuccessfully: "Servizio aggiunto con successo",
  pressToConfirmGroupNameChange: "Press to conferma gruppo nome change",
  pressToCancelGroupNameChange: "Press to annulla gruppo nome change",
  fillNameAndPressSaveOrEnter: "Fill nome and press salva or inserisci",
  addNewLine: "Aggiungi nuova riga",
  originCosts: "Origin costi",
  destinationCosts: "Destination costi",
  extras: "Extra",
  deleteThisPrice: "Elimina questo prezzo",
  agentSelected: "Agent selezionato",
  pricingListUpdatedOn: "Pricing list aggiornato on",
  noneAgentSelected: "Nessun agente selezionato",
  totalCosts: "Totale costi",
  manageNeverBeenEasier: "Gestire non è mai stato così facile",
  visibilityAtItsBest: "Visibilità al massimo",
  shipeeziIsTheEssentialToolForCompaniesOfAllSizesToConsolidateAutomateAndUncomplicateInformationAndShipmentFlowAcrossTheGlobe:
    "Shipeezi è lo strumento essenziale per le aziende di tutte le dimensioni per consolidare, automatizzare e semplificare il flusso di informazioni e spedizioni in tutto il mondo.",
  saveTimeAndMoney: "Salva time and money",
  withShipeeziVisibilityAndIncreasedControlIsDeliveredSavingMoreThan30InLogisticsCostsAnd60InTimeReporting:
    "Con Shipeezi, vengono garantiti visibilità e maggiore controllo, risparmiando oltre il 30% sui costi logistici e il 60% sui tempi di reportistica.",
  createYourAccount: "Crea il tuo account",
  youAreJustMomentsAwayOfHavingFullVisibilityAndControlOverYourShipments:
    "Sei a pochi passi dall'avere piena visibilità e controllo sulle tue spedizioni!",
  confirmPassword: "Conferma password",
  haveAnAccount: "Hai un account?",
  signIn: "Accedi",
  shipeezi: "© Shipeezi",
  termsOfUse: "Condizioni d'uso",
  passwordsDonTMatch: "*Le password non corrispondono",
  companyName: "Azienda nome",
  companyType: "Azienda tipo",
  selectCompanyType: "Seleziona azienda tipo",
  spShipper: "SP - Spedizioniere",
  fmFreightManager: "FM - Freight Responsabile",
  mvMoving: "MV - Trasloco",
  getEmailsFromShipeeziAboutProductUpdatesIndustryNewsAndEventsIfYouChangeYourMindYouCanUnsubscribeAtAnyTime:
    "Ricevi email da Shipeezi su aggiornamenti dei prodotti, notizie del settore ed eventi. Se cambi idea, puoi annullare l'iscrizione in qualsiasi momento.",
  byContinuingYouReAgreeingToShipeeziS: "Continuando, accetti le condizioni di Shipeezi",
  requestAccount: "Richiedi account",
  ourTeamWillGetInTouchWithYouAsSoonAsPossible:
    "Il nostro team ti contatterà il prima possibile.",
  thankYouForSignUpYouCanCheckYourEmailToProceed:
    "Grazie per la registrazione. Puoi controllare la tua email per procedere.",
  youWillReceiveAnEmailTo: "Riceverai un'email per",
  toConfirmYourSignUp: "per confermare la tua registrazione.",
  thereWasAnErrorCreatingTheAccount: "Si è verificato un errore durante la creazione dell'account",
  captcha: "Captcha",
  captchaExpired: "Captcha scaduto",
  and: "e",
  leaveVideoSurvey: "Abbandona video sopralluogo",
  wellDoneOnTheMeetingWith: "Ottimo lavoro per la riunione con",
  donTForgetWhatYouHaveAvailableFromThisMeeting:
    "Non dimenticare ciò che hai a disposizione da questo incontro.",
  didYouLeaveTheMeetingByMistake: "Hai abbandonato la riunione per errore? ",
  rejoinTheMeetingHere: "Riunisciti alla riunione qui",
  packingMaterial: "Packing Materiale",
  estimateQuote: "Stima quote",
  agents: "Agenti",
  editEstimate: "Modifica stima",
  charge: "Addebito",
  quantity: "Quantità",
  rate: "Tariffa",
  margin: "Margine",
  markUp: "Ricarico",
  discount: "Sconto",
  totalCost: "Totale costo",
  paymentMethod: "Metodo di pagamento",
  creditCard: "Carta di credito",
  credit_card: "Carta di credito",
  account: "Account",
  cash: "Contanti",
  goBackToApp: "Go indietro to app",
  closeTab: "Chiudi tab",
  openCommunication: "Apri communication",
  enableMicrophone: "Abilita microphone",
  disableMicrophone: "Disabilita microfono",
  enableCamera: "Abilita camera",
  disableCamera: "Disabilita fotocamera",
  shareScreen: "Condividi screen",
  stopSharingScreen: "Ferma Sharing Screen",
  cannotShareScreenWhenAnotherUserIsSharing: "Non è possibile condividere lo schermo quando un altro utente sta condividendo",
  screenSharingIsNotSupportedWithThisBrowser: "La condivisione dello schermo non è supportata con questo browser",
  emailConfirmationTimeHasExpired: "Il tempo di conferma email è scaduto",
  thereWasAnErrorConfirmingTheEmail: "Si è verificato un errore nella conferma dell'email",
  emailSuccessfullyConfirmed: "Email con successo confirmed",
  backToLoginPage: "Indietro to login page",
  goToShipeeziBlog: "Vai al blog Shipeezi",
  isNowVerified: "è ora verificato!",
  chooseAPassword: "Scegli una password",
  useLettersNumbersAndSymbolsForSafety: "Usa lettere, numeri e simboli per la sicurezza",
  confirmYourPassword: "Conferma la tua password",
  theSameOneFromAbove: "Lo stesso di sopra",
  youJustNeedToCreateAPasswordForYourAccount:
    "Devi semplicemente creare una password per il tuo account.",
  predictiveDeparture: "Partenza prevista:",
  departure: "Data of departure",
  arrival: "Arrivo",
  nextPortArrival: "Avanti port arrival:",
  decimalSeparator: "Separatore decimale",
  thousandSeparator: "Separatore migliaia",
  usePoint: "Usa il punto (.)",
  useComma: "Usa la virgola (,)",
  newService: "Nuovo service",
  createANewServiceOrGroup: "Crea a nuovo service or gruppo",
  createNewGroup: "Crea nuovo gruppo",
  inventoryList: "Inventario list",
  openLegacyVersion: "Apri legacy version",
  closeThisScreen: "Chiudi questa schermata",
  changeGroupStatus: "Cambia stato del gruppo",
  noAssociatedService: "Nessun servizio associato.",
  viewGroups: "Visualizza gruppi",
  groups: "Gruppi",
  seemsLikeYouDidnTCreateAnyGroup: "Sembra che tu non abbia creato nessun gruppo :(",
  searchGroups: "Cerca gruppi",
  groupCosting: "Costi gruppo",
  totalOfPrice: "Totale of Prezzo ",
  sent: "Inviato",
  group: "Gruppo",
  changeStatusTo: "Change stato to",
  totalOf: "Totale of",
  lastUpdated: "Last aggiornato",
  thisServiceCannotBeActivatedBecauseIsUnavailable:
    "Questo servizio non può essere attivato perché non è disponibile",
  thisServiceCannotBeEditedBecauseIsUnavailable:
    "Questo servizio non può essere modificato perché non è disponibile",
  loadingPrices: "Caricamento prezzi",
  updatePrices: "Aggiorna prezzi",
  reviewPrices: "Review prezzi",
  editFile: "Modifica file",
  uploadCsv: "Carica CSV",
  uploadCsvFile: "Carica file CSV",
  downloadTemplate: "Scarica il nostro modello CSV qui",
  clickToDownloadThePriceTemplateAndFillPrices:
    "Clicca per scaricare il modello prezzi e compilare i prezzi",
  noFilesUploaded: "No file caricato",
  noneDataHasFilled: "Nessun dato è stato compilato",
  fee: "Tariffa",
  thisServiceDoesNotExist: "Questo servizio non esiste",
  thereIsNoRelationshipBetweenThisServiceAndTheGroup:
    "Non c'è alcuna relazione tra questo servizio e il gruppo",
  thisGroupDoesNotExist: "Questo gruppo non esiste",
  thereIsNoRelationshipBetweenThisGroupAndTheService:
    "Non c'è alcuna relazione tra questo gruppo e il servizio",
  theValueOfThisFieldIsInvalid: "Il valore di questo campo non è valido",
  thisCurrencyDoesNotExist: "Questa valuta non esiste",
  nonGrouped: "Non raggruppato",
  wasEditedSuccessfully: "è stato modificato con successo!",
  thisRecordCannotBeEditedBecauseThereIsAnErrorInTheServiceOrGroup:
    "Questo record non può essere modificato perché c'è un errore nel servizio o nel gruppo",
  theseServicesWillNotBeUpdatedIfYouWouldLikeToCorrectThemYouShouldEditFile:
    "Questi servizi non saranno aggiornati. Se desideri correggerli, devi modificare il file.",
  thisCanBeCorrectedIfYouClickIn: "Può essere corretto cliccando su ",
  latestUpload: "Latest carica",
  youCanOnlyContinueAfterAllWarningsHaveBeenResolved:
    "Puoi continuare solo dopo aver risolto tutti gli avvisi",
  timeControl: "Controllo orario",
  arrivedAtTheResidence: "Arrivato alla residenza",
  breakFrom: "Pausa da",
  to: "A",
  leavingTheResidence: "Partenza dalla residenza",
  arrivedBackToTheWarehouse: "Arrived indietro to magazzino",
  timeSummary: "Time Riepilogo",
  transitTime: "Tempo di transito",
  breakTime: "Pausa",
  workTime: "Tempo di lavoro",
  totalTime: "Totale time",
  extraStaff: "Extra Personale",
  deleteSubscriber: "Elimina subscriber",
  whenYouDeleteANotification:
    "Quando elimini una notifica, il contatto associato non riceverà più avvisi.",
  wouldYouLikeToProceed: "Vuoi procedere?",
  pricesUpdatedSuccessfully: "Prezzi aggiornati con successo",
  weWillUpdateAllPricesDisregardingThoseMarkedWith:
    "Aggiorneremo tutti i prezzi, ignorando quelli contrassegnati con",
  ifYouWantToUpdateThesePricesYouShouldEditFile:
    "Se vuoi aggiornare questi prezzi, devi modificare il file",
  newMessage: "Nuovo Message!",
  oopsIncorrectCredentials: "Ops! Credenziali non corrette.",
  leaveWithoutSave: "Leave without salva",
  youHaveUnsavedChangesAreYouSureYouWantToLeave:
    "Hai modifiche non salvate. Sei sicuro di voler uscire?",
  youShouldSaveYourWorkBeforeLeaving: "Dovresti salvare il tuo lavoro prima di uscire.",
  doYouReallyWantToDeleteThisAgent: "Vuoi davvero eliminare questo agente",
  agentDetails: "Agent dettagli",
  toAllowYourPasswordReset: "per consentire il reimpostamento della password.",
  sorryTheLinkHasExpired: "Spiacenti, il link è scaduto.",
  theResetPasswordLinkHasExpiredYouCanRequestANewOneByClickingOnTheButtonBelow:
    "Il link di reimpostazione password è scaduto. Puoi richiederne uno nuovo cliccando sul pulsante qui sotto.",
  resetPasswordLink: "Reimposta password link",
  emailSuccessfullyResent: "Email con successo resent",
  anUnknownErrorHasOccurred: "Si è verificato un errore sconosciuto",
  emailOrUsernameIsRequired: "Email o nome utente obbligatorio",
  passwordIsRequired: "La password è obbligatoria",
  userLoggedIn: "Utente Logged In",
  thereWasAnErrorCapturingYourEmailToResend: "Si è verificato un errore nel recupero della tua email per il reinvio",
  theEmailConfirmationLinkHasExpiredYouCanRequestANewOneByClickingOnTheButtonBelow:
    "Il link di conferma email è scaduto. Puoi richiederne uno nuovo cliccando sul pulsante qui sotto.",
  resendConfirmationLink: "Reinvia link di conferma",
  thankYouForRequestingAnAccountWithShipeezi: "Grazie per aver richiesto un account con Shipeezi.",
  ourTeamWillBeInContactWithYouPriorToActivatingYourAccount:
    "Il nostro team ti contatterà prima di attivare il tuo account.",
  companyDetails: "Azienda Dettagli",
  uploadCentre: "Carica Centre",
  goBackToHomePage: "Go indietro to home page",
  goBackToLogin: "Go indietro to login",
  goBackToLoginPage: "Go indietro to login page",
  previous: "Precedente",
  skip: "Salta",
  downloadOurCsvTemplateHere: "Scarica il nostro modello CSV qui",
  addAdditionalUsers: "Aggiungi additional utenti",
  theContactDetailsUsedToRegisterHasBecomeAnAdminUserAlready:
    "I dati di contatto utilizzati per la registrazione appartengono già a un utente amministratore.",
  registeredUsers: "Registered utenti",
  addUser: "Aggiungi utente",
  aud: "AUD",
  youCanSelectToUploadYourOwnFilesInformationNowOrLaterIfYouPreferYouCanUseOurDefaultInformationTheseInformationIsInRegardsToYourInventoryItemsServicesFleetStaffAndSoOn:
    "Puoi scegliere di caricare i tuoi file (informazioni) ora o più tardi. Se preferisci, puoi usare le nostre informazioni predefinite. Queste informazioni riguardano i tuoi articoli di inventario, servizi, flotta, personale e altro.",
  uploadOwnList: "Carica il tuo elenco",
  useShipeeziSDefaultList: "Usa l'elenco predefinito di Shipeezi",
  inventoryListIso174511: "Elenco inventario certificato ISO17451-1:2016",
  usingShipeeziSDefault: "Utilizzo predefinito di Shipeezi",
  itemsRoomsPackagingTypeMethodOfPreparationModeTypeExceptionCodesExceptionLocationCodeItemInstructionsAndItemDestination:
    "Articoli, Stanze, Tipo di imballaggio, Metodo di preparazione, Tipo di modalità, Codici eccezione, Codice posizione eccezione, Istruzioni articolo e Destinazione articolo.",
  checklistForm: "Checklist e modulo",
  riskAssessmentTemplate: "Modello valutazione del rischio",
  usingShipeeziSSampleData: "Utilizzo dei dati di esempio di Shipeezi",
  listOfMaterials: "Elenco dei materiali",
  aFewCommonTypesOfPackingMaterialsWillBeLoaded:
    "Verranno caricati alcuni tipi comuni di materiali di imballaggio",
  services: "Servizi",
  oneServiceTypeWillBeCreated: "Verrà creato un tipo di servizio",
  oneStaffWillBeCreated: "Verrà creato un membro del personale",
  oneVehicleWillBeCreated: "Verrà creato un veicolo",
  theseInstructionsCanBeUsedInTheSalesAndOperationsAppForUpliftDeliveryOrMoveCoordinator:
    "Queste istruzioni possono essere utilizzate nell'app Vendite e Operazioni per il ritiro, la consegna o il coordinatore traslochi",
  usualAccessQuestionsWillBeCreatedHere: "Le domande di accesso standard verranno create qui",
  iso174511CertifiedItems:
    "Certificato ISO17451-1:2016: Articoli, Stanze, Tipo di imballaggio, Metodo di preparazione, Tipo di modalità, Codici eccezione, Codice posizione eccezione, Istruzioni articolo e Destinazione articolo.",
  csvUploaded: "CSV Caricato",
  asPerYourSelectionWeAreGoingToUploadTheStandardContentForTheFollowingSections:
    "In base alla tua selezione, caricheremo il contenuto standard per le seguenti sezioni:",
  youCanChooseFromTheListBelowWhichItemsYouWantToUploadAndWhichYouWantToUseShipeeziSDefault:
    "Puoi scegliere dall'elenco sottostante quali elementi vuoi caricare e quali vuoi usare come predefiniti di Shipeezi:",
  weAreLoadingTheUploadedContentPleaseWait: "Stiamo caricando il contenuto caricato, attendi",
  thisMightTakeAWhile: "Potrebbe richiedere un po' di tempo",
  ifThisIsTakingTooMuchLonger: "Se sta richiedendo troppo tempo,",
  tryAgainHere: "riprova qui",
  thankYouForCompleteThisProcess: "Grazie per aver completato il processo di configurazione rapida.",
  readyToStartUsingShipeezi: "Ready to inizio using Shipeezi?",
  getStarted: "Inizia",
  confirmationEmailHasBeenSucessfullyResent: "L'email di conferma è stata reinviata con successo!",
  confirmationEmailCouldNotBeenResent: "L'email di conferma non è stata reinviata!",
  resetUserPassword: "Reimposta password utente",
  businessLogo: "Logo aziendale",
  businessIcon: "Business Icona",
  addLogo: "Aggiungi Logo",
  choosePicture: "Scegli immagine",
  maxSize: "Max dimensione",
  formats: "Formati",
  crop: "Ritaglia",
  version: "Versione",
  profile: "Profilo",
  emailToResetPasswordSent: "Email per reimpostare la password inviata",
  "2Mb": "2 MB",
  maxFileSize: "Max file dimensione:",
  fileTypes: "Tipi di file:",
  accountDetails: "Account dettagli",
  csvTemplateIsInvalid: "Il modello CSV non è valido",
  line: "Riga",
  isRequired: "è obbligatorio",
  mustBeOneOfTheValidOptions: "deve essere una delle opzioni valide",
  mustBeFilledInWithXOrLeftEmpty: 'deve essere compilato con "x" o lasciato vuoto',
  mustBeANumber: "deve essere un numero",
  mustBeADateWithTheFormatDdMmYyyy: "deve essere una data con il formato gg/mm/aaaa",
  errorsFound: "Errori trovati",
  errorsFoundInYourFile: "Errori trovati nel tuo file",
  on: "Attivo",
  csvWeHaveFoundSomeErrorsYouShouldAdjustThoseLinesToProceed:
    "csv, abbiamo trovato alcuni errori. Devi correggere quelle righe per procedere:",
  donTKnowWhatSWrong: "Non sai cosa c'è che non va?",
  downloadOurTemplateHere: "Scarica il nostro modello qui",
  downloadOurTemplate: "Scarica il nostro modello",
  logout: "Esci",
  logOut: "Disconnetti",
  userProfile: "Utente profile",
  helpCenter: "Centro assistenza",
  dispatchFilters: "Filtri spedizione",
  allTasks: "Tutti attività",
  allTeams: "Tutti squadre",
  unpublishedTasks: "Unpublished attività",
  publishedTasks: "Pubblicato attività",
  teamsWithUnpublishedTasks: "Squadre con attività non pubblicate",
  teamsWithPublishedTasks: "Squadre con attività pubblicate",
  someChangesMayTakeSomeTimeToBeAppliedOnThisScreen:
    "Alcune modifiche possono richiedere del tempo per essere applicate su questa schermata",
  thisFleetIsUnavailableOnThisDate: "Questa flotta non è disponibile in questa data",
  thisMemberIsUnavailableOnThisDate: "Questo membro non è disponibile in questa data",
  theFilteredDataAffectsWhatYouSeeOnDispatch:
    "I dati filtrati influenzano ciò che vedi su « Spedizione »",
  termsAndConditions: "Termini e condizioni",
  currentlyViewing: "Attualmente visualizzando",
  changeTo: "Cambia in",
  switchingAccounts: "Cambio account.",
  unknown: "Sconosciuto",
  messageHasBeenSentSuccessfully: "Messaggio inviato con successo!",
  avatar: "Avatar",
  approvingCompany: "Approving azienda...",
  theCompanyHasBeenApproved: "L'azienda è stata approvata!",
  nowIsReadyToRockAndRoll: "è pronto per partire.",
  quoteType: "Quote Tipo",
  allProjects: "Tutti Projects",
  typeMobile: "Tipo Mobile",
  searchForTimezone: "Cerca for time zone",
  inviteUser: "Invite utente",
  userEmail: "Utente email",
  userAddedSuccessfully: "Utente aggiunto con successo",
  unableToRegisterAdditionalUser: "Unable to register additional utente",
  inviteSentSuccessfully: "Invite sent con successo!",
  saveAndInvite: "Salva and invite",
  createAndInvite: "Crea and invite",
  anEmailWasSentToUsernameWithYourRequest: "Un'email è stata inviata a *username* con la tua richiesta",
  companyInvitation: "Azienda invitation",
  inviteDeclined: "Invito rifiutato",
  youHaveBeenInvitedToBePartOf: "Sei stato invitato a far parte di ",
  youHaveBeenInvitedToBePartOfCompany: "Sei stato invitato a far parte dell'azienda",
  youCanAcceptOrDeclineTheInvitationAndWeWillNotifyTheCompanyAdministrator:
    "Puoi accettare o rifiutare l'invito e notificheremo l'amministratore dell'azienda.",
  weWillNotifyTheAdministrator: "Notificheremo l'amministratore.",
  weWillNotifyTheAdministratorFor: "Notificheremo l'amministratore per",
  youCanCloseThisWindow: "Puoi chiudere questa finestra",
  ifYouRejectedThisInvitationByMistakePleaseRequestANewInvite:
    "Se hai rifiutato questo invito per errore, richiedi un nuovo invito",
  here: "qui",
  yourInvitationExpired: "Il tuo invito è scaduto",
  companyUpdatedSuccessfully: "Azienda aggiornato con successo",
  termsAcceptedSuccessfully: "Terms accepted con successo",
  by: "per",
  entityName: "Entity nome",
  sorryTheLinkIsBroken: "Spiacenti, il link è danneggiato",
  theInviteLinkIsBroken: "Il link di invito è danneggiato.",
  theInviteLinkIsBrokenYouCanRequestANewOneByClickingOnTheButtonBelow:
    "Il link di invito è danneggiato. Puoi richiederne uno nuovo cliccando sul pulsante qui sotto.",
  resendInviteLink: "Reinvia link di invito",
  goBack: "Go indietro",
  theInviteLinkHasExpiredYouCanRequestANewOneByClickingOnTheButtonBelow:
    "Il link di invito è scaduto. Puoi richiederne uno nuovo cliccando sul pulsante qui sotto.",
  thisFieldIsAnInvalidUrl: "Questo campo è un URL non valido",
  thisFieldShouldHaveDigitsOnly: "Questo campo deve contenere solo cifre",
  validFormats: "Formati validi",
  typeOfInstruction: "Tipo of instruction",
  inputYourInstruction: "Inserisci la tua istruzione",
  asYouAddedAnItemThatDoesNotBelongToTheIso174511:
    "Poiché hai aggiunto un articolo che non appartiene alla norma ISO17451-1:2016, la tua lista di inventario non è conforme.",
  requestingNewInvite: "Requesting nuovo invite",
  youHaveAlreadyAcceptedThisInvitation: "Hai già accettato questo invito!",
  loadingInvitation: "Caricamento invitation...",
  userHasNotBeenInvited: "L'utente non è stato invitato",
  navigation: "Navigazione",
  someOfTheseEmailsProvidedIsInvalid: "Alcune delle email fornite non sono valide",
  isThisAnItemDestination: "Questa è una destinazione articolo?",
  ssccQty: "Qtà SSCC",
  etdAtOrigin: "ETD all'origine",
  etaAtDestination: "ETA alla destinazione",
  subjects: "Oggetti",
  favorites: "Preferiti",
  reports: "Rapporti",
  company: "Azienda",
  itFeelsEmptyRightNow: "Sembra vuoto al momento.",
  status: "Status",
  filter: "Filtra",
  reference: "Riferimento",
  referenceNumber: "Riferimento numero",
  customer: "Cliente",
  pdf: "PDF",
  csv: "CSV",
  exportAs: "Esporta come",
  tags: "Tag",
  nothingToShowHereYet: "Niente da mostrare qui per ora.",
  thisWarehouseDoesNotAllowStorageOfLooseItemsSelectAStorageBoxInstead:
    "Questo magazzino non consente lo stoccaggio di articoli sfusi. Seleziona invece una scatola di stoccaggio.",
  iConfirmThatAllTheDetailsAboveAreTrue: "Confermo che tutti i dettagli sopra indicati sono veritieri",
  notInformed: "Non informato",
  signHere: "Firma qui",
  expandAllTasks: "Expand tutti attività",
  hideAllTasks: "Nascondi tutte le attività",
  checkIfAnyOfTheTasksEligibleForReportGenerationUpliftDeliveryLocalHasBeenCompletedAndHasADate:
    "Verifica se una delle attività idonee alla generazione di rapporti (Ritiro, Consegna, Locale) è stata completata e ha una data",
  asn: "ASN",
  containerSize: "Dimensione contenitore",
  selectOne: "Seleziona uno",
  seal: "Sigillo",
  consignee: "Destinatario",
  consigneeCode: "Consignee codice",
  deliverToWarehouse: "Consegna al magazzino",
  serviceType: "Service tipo",
  shipTerms: "Condizioni di spedizione",
  mbl: "MBL",
  hbl: "HBL",
  loadingPort: "Caricamento Port",
  destinationPort: "Porto destinazione",
  dischargePort: "Porto di scarico",
  searchAddress: "Cerca indirizzo",
  shipperOriginAirport: "Aeroporto origine spedizioniere",
  receiverDestinationAirport: "Aeroporto destinazione ricevente",
  airports: "Aeroporti",
  ports: "Porti",
  roads: "Strade",
  scannedDate: "Scanned data",
  pickUpFromOrigin: "Ritiro dall'origine",
  ataAtOrigin: "ATA all'origine",
  ataAtDestination: "ATA alla destinazione",
  actualDeliveryDate: "Data di consegna effettiva",
  senderOriginRoad: "Strada origine mittente",
  receiverDestinationRoad: "Strada destinazione ricevente",
  roadName: "Nome strada",
  estimatedDeliveryDate: "Data di consegna stimata",
  noReportsAddedToFavorites: "No rapporti aggiunto to favorites",
  go: "Vai",
  itemInstructions: "Istruzioni articolo",
  chooseAnItemInstruction: "Scegli un'istruzione articolo",
  notHaveDatesYet: "Non ci sono ancora date",
  videoSurveyRecordDeleted: "Registrazione video sopralluogo eliminata",
  theVideoRecordedForThisSurveyWasDeletedAsTheStatusHasChangedTo:
    "Il video registrato per questo sopralluogo è stato eliminato poiché lo stato è cambiato in",
  youDoNotHaveAccessToThisRecordAnymore: "Non hai più accesso a questo record.",
  diary: "Diario",
  day: "Giorno",
  days: "Giorni",
  see: "Vedi",
  moreTasks: "più attività",
  sequenceMustBeAValidNumber: "*La sequenza deve essere un numero valido",
  sequenceMustBeAIntegerNumber: "*La sequenza deve essere un numero intero",
  sequenceMustBeGreaterThan0: "*La sequenza deve essere maggiore di 0",
  sequenceMustBeSmallerThan1000: "*La sequenza deve essere minore di 1000",
  noTasksRegisteredForTheDay: "Nessuna attività registrata per la giornata",
  startsAt: "Inizia alle: ",
  search: "Cerca",
  seeTaskOnOrder: "See attività on ordine",
  taskDetails: "Dettagli attività",
  storageBoxes: "Stoccaggio boxes",
  storageBoxTypes: "Stoccaggio box types",
  prepayment: "Acconto",
  noneInformationToShow: "None information to mostra",
  tasks: "Attività",
  assignTask: "Assegna attività",
  printJob: "Stampa job",
  cancelTask: "Annulla attività",
  yesCancelTask: "Sì, annulla attività",
  areYouSureYouWantToCancelThisTask: "Sei sicuro di voler annullare questa attività?",
  searchByFleet: "Cerca per flotta",
  searchByStaff: "Cerca per personale",
  searchByLeader: "Cerca per responsabile",
  searchByStorageBox: "Cerca by Stoccaggio Box",
  orderReference: "Ordine Riferimento",
  taskStartsAt: "Attività starts at",
  languageName: "Language nome",
  australianEnglishSystem: "Inglese australiano (Sistema)",
  thisIsTheName: "Questo è il nome",
  term: "Termine",
  createdBy: "Creato da",
  lengthM: "Lunghezza(m)",
  taskList: "Attività List",
  exception: "Codici eccezione",
  cancelled: "Annullato",
  labelTooltipRecording: "Registrazione",
  labelTooltipNotRecording: "Non registrando",
  youAreNotAllowedToEditThisQuote: "Non sei autorizzato a modificare questo preventivo",
  youAreNotAllowedToEditThisOrder: "Non sei autorizzato a modificare questo ordine",
  fileDownloadComplete: "Download file completato",
  scheduleNow: "Programma ora",
  videoSurveyUnavailable: "Video sopralluogo non disponibile",
  thisVideoSurveyHasBeenClosed: "Questo video sopralluogo è stato chiuso",
  pleaseScheduleAnotherSurveyToContinue: "Pianifica un altro sopralluogo per continuare",
  youCanScheduleAnotherVideoSurveyNowOrLater: "Puoi programmare un altro video sopralluogo ora o più tardi",
  theCustomerHasRemovedTheCallRecordingPermission:
    "Il cliente ha rimosso l'autorizzazione alla registrazione della chiamata",
  theCustomerAllowedTheRecordThisCallIsBeingRecordedFromNowOn:
    "Il cliente ha autorizzato la registrazione. Questa chiamata viene registrata da ora in poi.",
  recordingVS: "Registrazione",
  notRecording: "Non registrando",
  readyToShip: "Pronto per la spedizione",
  port: "Porto",
  deliverTo: "Consegna a",
  plane: "Aereo",
  journey: "Viaggio",
  airwayBill: "Lettera di vettura aerea",
  cfs: "CFS",
  addNewContainer: "Aggiungi nuovo contenitore",
  acmeClothing: "Abbigliamento Acme",
  purchasingOrganisation: "Organizzazione acquisti",
  orderNumber: "Ordine Numero",
  amosToken: "Token AMOS",
  token: "Token",
  australia: "Australia",
  sistrs: "SISTRS",
  pleaseEnterAValidToken: "Inserisci un token valido",
  revokeConnection: "Revoca connection",
  areYouSureYouWantToRevokeTheConnection: "Sei sicuro di voler revocare la connessione?",
  amos: "AMOS",
  copyKey: "Copia key",
  inviteSISTR: "Invita SISTR",
  editSISTR: "Modifica SISTR",
  SISTRemail: "Email SISTR",
  emailAlreadyExists: "L'email esiste già",
  waybills: "Lettere di vettura",
  moreOrders: "Più ordini",
  etd: "ETD",
  print: "Stampa",
  seeReport: "See rapporto",
  reportType: "Rapporto tipo",
  uploaded: "Caricato",
  uploadFile: "Carica file",
  documentsUploaded: "Documenti caricato",
  dragOrClickToUploadYourFile: "Trascina o clicca per caricare il tuo file",
  waybill: "Lettera di vettura",
  estimateDates: "Stima Dates",
  aircraftDestination: "Destinazione aereo",
  aircraftOrigin: "Origine aereo",
  aircraft: "Aereo",
  unpackDate: "Unpack Data",
  pickDate: "Pick Data",
  arrivalOfDestination: "Data of Consegna",
  deleteShipment: "Elimina Spedizione",
  image: "Immagine",
  billOfLanding: "Polizza di carico",
  enterBillOfLanding: "Inserisci Bill of Lading",
  billOfLandingMustBeAtLeast7CharactersLong: "La polizza di carico deve essere di almeno 7 caratteri",
  billOfLandingMustBeAtMax20CharactersLong: "La polizza di carico non deve superare i 20 caratteri",
  tradingName: "Trading nome",
  youCanGetStartedTrackingShipmentsFromHereRegardlessOfHowManyForwardersOrRoutes:
    "Puoi iniziare a tracciare le spedizioni da qui, indipendentemente dal numero di spedizionieri o itinerari.",
  eitherUploadACsvFileUsingTheTemplateOrClickNextToEnterAContainerNumber:
    "Carica un file CSV usando il modello oppure clicca avanti per inserire un numero di contenitore.",
  uploadYourShipmentDetails: "Carica i dettagli della spedizione",
  due: "Scadenza",
  notDefined: "Non definito",
  viewFile: "Visualizza file",
  thisFileIsRequired: "Questo file è obbligatorio",
  tryAgain: "riprova",
  tryAgain2: "Riprova",
  ifThisIsTakingTooLong: "Se sta richiedendo troppo tempo,",
  uploadMade: "Carica made",
  theFileMustBeLessThan2mbInSize: "Il file deve essere inferiore a 2 MB",
  invite: "Invita",
  inviteSupplier: "Invite fornitore",
  inviteSuppliers: "Invite fornitori",
  doYouWantToInvite: "Vuoi invitare",
  toShipeezi: "a Shipeezi?",
  anInvitationWillBeSendTo: "Un invito verrà inviato a",
  activeContainers: "Attivo Contenitori",
  avgContainerPerWeek: "Avg Contenitori per Week",
  containersDelayed: "Contenitori Delayed",
  containersWaitingAtGate: "Contenitori Waiting at gate",
  totalContainers: "Totale Contenitori",
  containersTracked: "Contenitori Tracked",
  averageDelay: "Ritardo medio",
  shipmentsTracked: "Spedizioni Tracked",
  currentVesselsWithShipmentsBeingTracked: "Navi attuali con spedizioni in monitoraggio",
  ctaDate: "CTA Data",
  teu: "TEU",
  atd: "ATD",
  actualTimeOfDeparture: "Orario effettivo di partenza",
  etaDate: "ETA Data",
  arrivalDate: "Arrival Data",
  via: "Via",
  customerEmail: "Cliente email",
  estimatedDate: "Estimated data",
  estimatedTimeOfPortArrival: "Orario stimato di arrivo in porto",
  estimatedTimeOfAirportArrival: "Orario stimato di arrivo in aeroporto",
  companyLogo: "Azienda Logo",
  yourShipmentIsExpectedToArriveAt: "La tua spedizione dovrebbe arrivare a",
  poweredBy: "Powered by",
  localTime: "Ora locale",
  booked: "Prenotato",
  collectedFromShipper: "Ritirato dallo spedizioniere",
  notArrivedAtPortOfLoad: "Non arrivato al porto di carico",
  waitingAtPortOfLoad: "In attesa al porto di carico",
  shippedOnBoard: "Imbarcato a bordo",
  underway: "In corso",
  underwayToATranshipmentPort: "In viaggio verso un porto di trasbordo",
  arrivalAtTranshipmentPort: "Arrivo al porto di trasbordo",
  waitingAtTranshipmentPort: "In attesa al porto di trasbordo",
  shippedOnBoardAtTranshipmentPort: "Imbarcato al porto di trasbordo",
  arrivedAtPortOrDischarge: "Arrivato al porto o scarico",
  waitingAtDestinationPort: "In attesa al porto di destinazione",
  leftTheDestinationPort: "Ha lasciato il porto di destinazione",
  shipmentCompleted: "Spedizione completato",
  maerskCode: "Maersk Codice",
  maerskBeCode: "Maersk BE Codice",
  clientCode: "Client Codice",
  addressCode: "Indirizzo Codice",
  divisionCode: "Division Codice",
  divisionDescription: "Descrizione divisione",
  departmentCode: "Department Codice",
  departmentDescription: "Descrizione dipartimento",
  sscc: "SSCC",
  ssccQuantity: "SSCC Quantità",
  quantityUnit: "Quantità Unit",
  purchasePrice: "Purchase Prezzo",
  style: "Stile",
  colour: "Colore",
  size: "Dimensione",
  expand: "Espandi",
  deleteThisSsccAndYourProducts: "Elimina questo SSCC e i tuoi prodotti",
  purchaseOrders: "Purchase Ordini",
  addNewOrder: "Aggiungi nuovo ordine",
  orderDate: "Ordine data",
  shipper: "Spedizioniere",
  readyForBooking: "Ready for prenotazione",
  selectOrdersBelowToAddThem: "Seleziona gli ordini qui sotto per aggiungerli",
  expectedStartDate: "Expected Inizio Data",
  expectedEndDate: "Expected End Data",
  assigned: "Assegnato",
  bookByDate: "Prenota per data",
  createBooking: "Crea Prenotazione",
  confirmed: "Confermato",
  underReview: "In revisione",
  received: "Ricevuto",
  pending: "In attesa",
  loadingBookings: "Caricamento Prenotazioni",
  scanned: "Scansionato",
  noThanks: "No, grazie",
  cancelBooking: "Annulla prenotazione",
  areYouSureYouWantToCancelTheBooking: "Sei sicuro di voler annullare la prenotazione",
  scannedItems: "Scanned articoli",
  thisOrderIsCancelled: "Questo ordine è annullato",
  packingType: "Packing Tipo",
  conditionAtOrigin: "Condizione all'origine",
  conditionAtDestination: "Condizione alla destinazione",
  conditionsAtOrigin: "Condizioni all'origine",
  conditionsAtDestination: "Condizioni alla destinazione",
  conditionAt: "Condizione a",
  upgradeVersionToDoThis: "Aggiorna la versione per farlo",
  viewProduct: "Visualizza Prodotto",
  hscode: "HSCODE",
  unitPrice: "Unit Prezzo",
  totalPrice: "Totale Prezzo",
  shipDate: "Ship Data",
  fobPrice: "FOB Prezzo",
  createSSCC: "Crea SSCC",
  newSSCCwasCreated: "Un nuovo SSCC è stato creato!",
  finish: "Termina",
  closeSSCC: "Chiudi SSCC",
  noInformations: "Nessuna informazione",
  itsCurrentlyLocatedAt: "è attualmente situato presso",
  atPosition: "alla posizione",
  asReportedByMarineTrafficTerrestrialAutomaticIdentificationSystem:
    "come riportato dal sistema di identificazione automatica terrestre MarineTraffic il",
  theVesselIsCurrentlyAtPort: "La nave è attualmente in porto",
  afterAVoyageOriginatingFromPort: "dopo un viaggio con origine dal porto",
  currentLocation: "Posizione attuale",
  delayTime: "Tempo di ritardo",
  newETA: "Nuovo ETA",
  sendTrackingLinkToACustomer: "Invia link di tracciamento a un cliente o a qualcun altro",
  areYouSureYouWantToCloseThisSSCC: "Sei sicuro di voler chiudere questo SSCC?",
  thisActionCannotBeUndoneAndIfYouWantToModifyThisSSCCYouMustDeleteItAndCreateANewOne:
    "Questa azione è irreversibile e se vuoi modificare questo SSCC, devi eliminarlo e crearne uno nuovo",
  selectProductsBelowToAddThemToSSCC: "Seleziona i prodotti qui sotto per aggiungerli all'SSCC",
  printLabel: "Stampa etichetta",
  allSelectedSsccMustBeClosedToBePrinted: "Tutti gli SSCC selezionati devono essere chiusi per essere stampati",
  moreContainers: "Più contenitori",
  portOfOrigin: "Port of Caricamento (PoL)",
  consignmentInfo: "Info spedizione",
  originAgent: "Agente origine",
  destinationAgent: "Agente destinazione",
  estimateTimeOfDeparture: "Orario di partenza",
  estimateTimeOfArrival: "Orario di arrivo",
  atDepartureDock: "Al molo di partenza",
  inactivateWaybill: "Disattiva lettera di vettura",
  inactiveWaybill: "Lettera di vettura inattiva",
  pleaseAddAValidContainerNumber: "Inserisci un numero di contenitore valido",
  waitingForUpdate: "Waiting for aggiorna",
  generated: "Generato",
  containerNumberIsInvalid: "Il numero contenitore non è valido",
  itemConditions: "Articolo conditions",
  addAPhoto: "Aggiungi a foto",
  conditionsAdded: "Conditions aggiunto",
  noConditions: "Nessuna condizione",
  noPhotosAdded: "No photos aggiunto",
  itemDescription: "Articolo description",
  pleaseSelectADescriptiveSymbol: "Seleziona un simbolo descrittivo",
  cbm: "CBM",
  submitted: "Inviato",
  rejected: "Rifiutato",
  partiallyDelivered: "Parzialmente consegnato",
  bookingMustBeConfirmed: "La prenotazione deve essere confermata",
  notificationCentre: "Notifica Centre",
  notificationCenter: "Notifica Center",
  addEmailTemplate: "Aggiungi Email Modello",
  from: "Da",
  subject: "Oggetto",
  bcc: "Ccn",
  createNewTemplate: "Crea nuovo modello",
  templateName: "Modello nome",
  newTemplate: "Nuovo modello",
  emailDetails: "Email Dettagli",
  emailContent: "Contenuto email",
  editEmailTemplate: "Modifica Email Modello",
  viewEmailTemplate: "Visualizza Email Modello",
  smsDetails: "SMS Dettagli",
  smsContent: "Contenuto SMS",
  pushNotificationDetails: "Push Notifica Dettagli",
  pushNotificationContent: "Push Notifica Content",
  use178CharactersOrLessForBestDisplay: "Usa 178 caratteri o meno per una visualizzazione ottimale",
  smsCharacterLimitHint: "I messaggi SMS oltre 168 caratteri saranno divisi in più messaggi.",
  selectATemplate: "Seleziona a Modello",
  addSMSTemplate: "Aggiungi SMS Modello",
  editSMSTemplate: "Modifica SMS Modello",
  viewSMSTemplate: "Visualizza SMS Modello",
  quoteCreation: "Creazione preventivo",
  quoteApproval: "Approvazione preventivo",
  quoteDecline: "Quote Rifiuta",
  ordersCreation: "Ordini Creation",
  orderDelivered: "Ordine Delivered",
  orderCancelled: "Ordine Annullato",
  createNewDocument: "Crea nuovo documento",
  documentGenerated: "Documento generated",
  resendInvite: "Reinvia invito",
  downloadBookingFile: "Scarica file prenotazione",
  createAndBook: "Crea and book",
  saveAndBook: "Salva and book",
  editBooking: "Modifica Prenotazione",
  viewBooking: "Visualizza Prenotazione",
  liveAnimalsAndFish: "Animali vivi e pesce",
  cerealGrains: "Cereali in grani",
  otherAgriculturalProducts: "Altri prodotti agricoli",
  feedAndProductsOfAnimalOrigin: "Feed and prodotti of animal origin",
  meatAndSeafood: "Carne e pesce",
  milledGrainProducts: "Milled grain prodotti",
  otherPreparedFoodstuffs: "Altri alimenti preparati",
  alcoholicBeverages: "Bevande alcoliche",
  tobaccoProducts: "Tobacco prodotti",
  buildingStone: "Pietra da costruzione",
  naturalSands: "Sabbie naturali",
  gravelAndCrushedStone: "Ghiaia e pietrisco",
  otherNonmetallicMinerals: "Altri minerali non metallici",
  metallicOres: "Minerali metallici",
  coal: "Carbone",
  crudePetroleum: "Petrolio greggio",
  gasolineKeroseneAndEthanol: "Benzina, cherosene ed etanolo",
  dieselAndOtherFuelOils: "Diesel e altri oli combustibili",
  otherFossilFuelProducts: "Altri prodotti di combustibili fossili",
  basicChemicals: "Prodotti chimici di base",
  pharmaceuticalProducts: "Pharmaceutical prodotti",
  fertilizers: "Fertilizzanti",
  chemicalProductsAndPreparations: "Chemical prodotti and preparations",
  plasticsAndRubber: "Plastiche e gomma",
  logsAndWoodInTheRough: "Tronchi e legname grezzo",
  woodProducts: "Wood prodotti",
  pulpPaperAndPaperboard: "Cellulosa, carta e cartone",
  paperOrPaperboardArticles: "Articoli di carta o cartone",
  printedProducts: "Printed prodotti",
  textilesAndLeather: "Tessuti e pelle",
  nonmetallicMineralProducts: "Nonmetallic mineral prodotti",
  metalInBasicShapes: "Metallo in forme base",
  articlesOfMetal: "Articoli di metallo",
  machinery: "Macchinari",
  electronics: "Elettronica",
  motorizedAndOtherVehicles: "Veicoli motorizzati e altri",
  otherTransportationEquipment: "Altre attrezzature di trasporto",
  precisionInstruments: "Strumenti di precisione",
  furniture: "Mobili",
  miscellaneousManufacturedProducts: "Miscellaneous manufactured prodotti",
  wasteAndScrap: "Rifiuti e rottami",
  mixedFreight: "Carico misto",
  commodity: "Merce",
  fillThisFieldBeforeAddingAnotherContainer: "Compila questo campo prima di aggiungere un altro contenitore",
  youShouldHaveAtLeastOneProductInsideAnSSCCToCloseIt:
    "Devi avere almeno un prodotto all'interno di un SSCC per chiuderlo",
  thisSupplierIsPartOfShipeezi: "Questo fornitore fa parte di Shipeezi",
  supplierNotFound: "Fornitore non trovato",
  thisSupplierNotHaveNameToSendInvitation: "Questo fornitore non ha un nome per inviare l'invito",
  thisSupplierDoesNotHaveAnEmailToSendInvitation:
    "Questo fornitore non ha un indirizzo email per inviare l'invito",
  emails: "email",
  youCannotInviteInactiveSuppliers: "Non puoi invitare fornitori inattivi",
  financials: "Dati finanziari",
  communicationCentre: "Centro comunicazioni",
  communication_centre: "Centro comunicazioni",
  notificationTemplates: "Notifica Modelli",
  communicationCentreDescription:
    "Gestisci i tuoi modelli di comunicazione, notifiche e impostazioni in un'unica posizione centrale.",
  templateCreatedSuccessfully: "Modello creato con successo",
  templateUpdatedSuccessfully: "Modello aggiornato con successo",
  templateDuplicatedSuccessfully: "Modello duplicated con successo",
  errorCreatingTemplate: "Error creazione modello",
  duplicateTemplate: "Duplicate Modello",
  editTemplate: "Modifica Modello",
  preFilled: "Precompilato",
  emailTemplates: "Email Modelli",
  emailTemplate: "Email modello",
  manageEmailTemplatesDescription:
    "Crea e gestisci modelli email per varie esigenze di comunicazione.",
  smsTemplates: "SMS Modelli",
  smsTemplate: "SMS modello",
  pushContentCannotExceed: "Push notifica content cannot exceed 178 characters",
  smsContentCannotExceed: "Il contenuto SMS non può superare i 168 caratteri",
  manageSmsTemplatesDescription: "Crea and gestisci SMS modelli for quick notifiche.",
  manageNotificationsDescription: "Configure notifica preferences and impostazioni.",
  communicationSettings: "Communication Impostazioni",
  configureCommunicationSettingsDescription:
    "Configura le preferenze di comunicazione e le opzioni di consegna.",
  clickToManage: "Click to gestisci",
  searchTemplates: "Cerca modelli...",
  noTemplatesFound: "Nessun modello trovato",
  content: "Contenuto",
  availableIn: "Disponibile in",
  areYouSureYouWantToChangeTheStatus: "Sei sicuro di voler cambiare lo stato?",
  beneficiaryDetails: "Beneficiary dettagli",
  beneficiaryBank: "Banca beneficiaria",
  accountNumber: "Account numero",
  invoiceNumber: "Fattura numero",
  invoiceNo: "Fattura No",
  ciDate: "CI Data",
  financialsUpdatedSuccessfully: "Financials aggiornato succesfully",
  yourShipmentInformationIsLoading: "Le informazioni sulla tua spedizione sono in caricamento",
  conditionAddedSuccessfully: "Condizione aggiunta con successo",
  atDestination: "Alla destinazione",
  someSelectedSupplierHasNoName: "Alcuni fornitori selezionati non hanno un nome",
  someSelectedSupplierDoesNotHaveAnEmail: "Alcuni fornitori selezionati non hanno un'email",
  allSelectedSuppliersMustHaveNameEmailAndNotYetBelongToShipeezi:
    "Tutti i fornitori selezionati devono avere nome, email e non appartenere ancora a Shipeezi",
  photoAddedSuccessfully: "Foto aggiunta con successo",
  generalSettings: "General Impostazioni",
  invalidTag: "Non valido tag",
  removeOrder: "Rimuovi ordine",
  houseAirWaybill: "Lettera di vettura aerea house",
  removeSelected: "Rimuovi Selezionato",
  createWarehouse: "Crea Magazzino",
  noWarehousesToShow: "No magazzini to mostra",
  statusUpdatedSuccessfully: "Stato aggiornato con successo",
  supplierPortal: "Fornitore Portal",
  youreReadyToGo: "Sei pronto a partire!",
  goToLoginPage: "Vai alla pagina di accesso",
  onUploadedCsvWeHaveFoundSomeErrors: "Nel CSV caricato abbiamo trovato alcuni errori",
  youShouldAdjustThoseLinesToproceed: "Devi correggere quelle righe per procedere",
  youreNowPartOfOurPortal: "Ora fai parte del nostro portale!",
  ssccGeneration: "Generazione SSCC",
  mustHave: "Deve avere",
  digit: "cifra",
  digits: "cifre",
  extensionDigit: "Cifra estensione",
  gs1CompanyCode: "GS1 Azienda Codice",
  checkDigit: "Cifra di controllo",
  columnMustBeFilled: "la colonna deve essere compilata",
  notFound: "non trovato",
  isNotValid: "non è valido",
  carton: "Cartone",
  alreadyHasTheLimitOfProductsInside: "ha già raggiunto il limite di prodotti all'interno",
  thereAreNoRecordsInThisFile: "Non ci sono record in questo file",
  importance: "Importanza",
  important: "Importante",
  notImportant: "Non importante",
  markAsUnread: "Segna come non letto",
  markAsRead: "Segna come letto",
  markAsImportant: "Segna come importante",
  unmarkAsImportant: "Deseleziona come importante",
  importantNotifications: "Important notifiche",
  markAllAsRead: "Mark tutti as read",
  seeAllNotifications: "See tutti notifiche",
  ssccOpen: "SSCC apri",
  contactVia: "Contatto via",
  orderedQuantity: "Ordered Quantità",
  percentage: "Percentuale",
  areYouSureYouWantToConfirmThisBooking: "Sei sicuro di voler confermare questa prenotazione",
  onceConfirmedThisWillBeSentTo: "Una volta confermato, sarà inviato a",
  youAreNotAbleToMakeAnyAdditionalChanges: "non è possibile apportare ulteriori modifiche",
  valueShouldBeBetween: "Il valore deve essere tra",
  valueShouldBe: "Il valore deve essere",
  someQuantitiesFulilledAreWrongPleaseReviewAndChangeValues:
    "Alcune quantità evase sono errate. Verifica e modifica i valori.",
  areYouSureYouWantToDeleteThisShipment: "Sei sicuro di voler eliminare questa spedizione",
  yesDeleteShipment: "Sì, elimina questa spedizione",
  editWaybill: "Modifica Waybill",
  createWaybill: "Crea Waybill",
  youCannotAddTheSameAgent: "Non puoi aggiungere lo stesso agente",
  saveAndSubscribe: "Salva and subscribe",
  theProductsMustBelongToTheSameOrder: "I prodotti devono appartenere allo stesso ordine",
  youShouldSelectTheProducts: "Devi selezionare i prodotti",
  haveProductsFromMultipleOrders: "Hanno prodotti da più ordini",
  portOfLoading: "Port of Caricamento",
  portOfDischarge: "Porto di scarico",
  placeOfReceipt: "Luogo di ricevimento",
  shipperDischargeAirport: "Aeroporto scarico spedizioniere",
  shipperReceiptAirport: "Aeroporto ricevimento spedizioniere",
  cargoReadyDate: "Cargo Ready Data",
  hasAlreadyBeenAssigned: "è già stato assegnato",
  isMissingShipByDate: "manca la data di spedizione",
  shipByDateIsToEarlyForBooking: "La data di spedizione è troppo anticipata per la prenotazione",
  shipByDateIsToLateForBooking: "La data di spedizione è troppo in ritardo per la prenotazione",
  office: "Ufficio",
  offices: "Uffici",
  notifyParty: "Notifica parte",
  youMustSelectABookingModeFirst: "Devi prima selezionare una modalità di prenotazione",
  isDifferentFromBooking: "è diverso dalla prenotazione",
  youMustSelectABookingLoadingPortFirst: "Devi prima selezionare un porto di carico per la prenotazione",
  youMustSelectABookingDestinationPortFirst: "Devi prima selezionare un porto di destinazione della prenotazione",
  orderAssociated: "Ordine associato",
  selectOrder: "Seleziona ordine",
  youMustSelectABookingDischargePortFirst: "Devi prima selezionare un porto di scarico per la prenotazione",
  youMustSelectedABookingCargoReadyDateFirst: "Devi prima selezionare una data merce pronta della prenotazione",
  mustHaveFourteenDifferenceAtMaxFromCargoReadyDate:
    "deve avere una differenza massima di 14 giorni dalla data di merce pronta",
  theLimitOfProductsInsideACartonIs: "Il limite di prodotti in un cartone è",
  tolerancePercentage: "Percentuale di tolleranza",
  activatingThisWillControlTheTolerancePercentageOfProductsInsideABookingToTheDefinedValue:
    "Attivando questa opzione, verrà controllata la percentuale di tolleranza dei prodotti all'interno di una prenotazione al valore definito.",
  theInputValueWillBeConvertedIntoAPercentage:
    "Il valore inserito verrà convertito in percentuale",
  youNeedToMatchTheToleranceOfTheRequestedQuantities:
    "Devi rispettare la tolleranza delle quantità richieste",
  atLeastOneCartonIsRequiredToCarryOutTheBooking:
    "È necessario almeno un cartone per effettuare la prenotazione",
  allCartonsMustContainAtLeastOneProduct: "Tutti i cartoni devono contenere almeno un prodotto",
  valueMustBeGreaterThanZero: "*Il valore deve essere maggiore di zero",
  allSelectedProductsMustMeetTheCriteria: "Tutti i prodotti selezionati devono soddisfare i criteri",
  thisValueMustBeAnInteger: "*Questo valore deve essere un numero intero",
  shipByDate: "Spedisci per data",
  bookedVolume: "Volume prenotato",
  receivedVolume: "Volume ricevuto",
  bookedWeight: "Peso prenotato",
  receivedWeight: "Ricevuto Peso",
  ssccQuantityBooked: "Quantità SSCC prenotata",
  ssccQuantityReceived: "Quantità SSCC ricevuta",
  theValuesWereTheSame: "I valori erano gli stessi",
  lessThanBooked: "inferiore al prenotato",
  moreThanBooked: "superiore al prenotato",
  volumeAndWeight: "Volume & Peso",
  insertTotalValue: "Insert totale value",
  insertValuesOf: "Inserisci i valori di",
  defineTotalValueOfSSCCs: "Define totale value of SSCC's",
  defineValuesOfOneSSCC: "Definisci i valori di un SSCC",
  SSCCCBM: "CBM SSCC",
  SSCCWeight: "Peso SSCC",
  valueMustBeWithin10OfSupplierValue: "* Ops! Il valore deve essere entro -/+ 10% del valore fornitore.",
  notReceived: "Non ricevuto",
  receiveSSCC: "Ricevi SSCC",
  changeIt: "Cambialo",
  theBookingWillBeSentBackToTheSupplier: "La prenotazione verrà rinviata al fornitore",
  areYouSureYouWantToChangeThisBookingStatusTo:
    "Sei sicuro di voler cambiare lo stato di questa prenotazione in",
  receiveAllSSCC: "Ricevi tutti gli SSCC",
  closeIt: "Chiudilo",
  areYouSureYouWantToMarkThisSSCCAsReceived: "Sei sicuro di voler contrassegnare questo SSCC come ricevuto",
  youAreAboutMarkAllSSCCAsReceived: "Stai per contrassegnare tutti gli SSCC come ricevuti",
  areYouSure: "Sei sicuro",
  thisActionCannotbeUndone: "Questa azione non può essere annullata",
  yesReceiveAll: "Sì, ricevi tutto",
  yesReceiveSSCC: "Sì, ricevi SSCC",
  allCartonsHaveAlreadyBeenMarkedAsReceived: "Tutti i cartoni sono già stati contrassegnati come ricevuti",
  bookingSummary: "Riepilogo prenotazione",
  downloadBookingData: "Scarica dati prenotazione",
  downloadReport: "Scarica rapporto",
  manageSSCC: "Gestisci SSCC",
  closeSSCCs: "Chiudi SSCCs",
  areYouSureYouWantToClosethese: "Sei sicuro di voler chiudere questi",
  thisActionCannotBeUndoneAndIfYouWantToModifyTheseSSCCsYouMustDeleteItAndCreateNewOnes:
    "Questa azione è irreversibile e se vuoi modificare questi SSCC, devi eliminarli e crearne di nuovi",
  allSSCCsMustBeReceived: "Tutti gli SSCC devono essere ricevuti",
  planned: "Pianificato",
  allCartonsShouldBeClosedToCarryOutTheBooking:
    "Tutti i cartoni devono essere chiusi per effettuare la prenotazione",
  unavailableNotification: "Notifica non disponibile",
  shipeeziPredicts: "Previsioni Shipeezi",
  carrierShipeeziPredicts: "Previsioni Vettore Shipeezi",
  allSSCCMustHaveProductsInsideThemToBeClosed:
    "Tutti gli SSCC devono contenere prodotti per essere chiusi",
  photosOf: "Foto di ",
  generalComments: "Commenti generali",
  valueMustBeEqualToTheSupplierValue: "Il valore deve essere uguale al valore del fornitore",
  beCode: "BE Codice",
  pleaseEnteraValidBecode: "Inserisci un codice valido",
  sendTaskToSistrs: "Invia attività to SISTRS",
  beCodeSupplierExample: "AUDASHING3 VDR",
  beCodeCustomerExample: " AUTHECOTT4 HQ",
  totalSSCC: "Totale SSCC",
  markBookingAs: "Segna prenotazione come",
  selectATriggerFirst: "Seleziona a trigger first",
  default: "Predefinito",
  commercialInvoice: "Commercial fattura",
  beneficiaryName: "Nome beneficiario",
  beneficiaryAddress: "Indirizzo beneficiario",
  vatNumber: "Numero IVA",
  eori: "EORI -",
  fiscalAgentDetails: "Dettagli agente fiscale",
  salesContractNumber: "Numero contratto di vendita",
  salesContractDate: "Data contratto di vendita",
  expNumber: "Numero EXP",
  bankName: "Bank Nome",
  bankAddress: "Bank Indirizzo",
  swiftCode: "Swift Codice",
  paymentTerms: "Termini di pagamento",
  termsOfDelivery: "Terms of Consegna",
  udNumber: "Numero UD",
  ercNumber: "Numero ERC",
  rexNumber: "REX Numero",
  commercialInvoiceDetails: "Commercial Fattura Dettagli",
  cfsReview: "Revisione CFS",
  receivedByCFS: "Ricevuto dal CFS",
  lining: "Rivestimento",
  construction: "Costruzione",
  category: "Categoria",
  fabric: "Tessuto",
  styleCode: "Style Codice",
  brand: "Marchio",
  manufacturerDetails: "Manufacturer Dettagli",
  composition: "Composizione",
  downloadAllFiles: "Scarica tutti file",
  areYouSureYouWantToRemoveThe: "Sei sicuro di voler rimuovere",
  fromThisBooking: "da questa prenotazione",
  removePurchaseOrder: "Rimuovi ordine di acquisto",
  allSSCCsInsideThePurchaseOrderWillAlsoBeRemoved:
    "Tutti gli SSCC nell'ordine di acquisto saranno rimossi",
  yesRemoveIt: "Sì, rimuovi it",
  markAndNumbers: "Marchi e numeri",
  limited: "Limitato",
  characters: "caratteri",
  saveEdit: "Salva modifica",
  cancelEdit: "Annulla modifica",
  purchaseOrderNumber: "PurchaseOrder Numero",
  cartonName: "Carton Nome",
  quotesStatus: "Quotes Stato",
  someInformationOfThisSkuAreMissing: "Alcune informazioni di questo SKU sono mancanti",
  writeHere: "Scrivi qui",
  createNewRow: "Crea nuovo row",
  noRowsCreatedYet: "Nessuna riga creata",
  noData: "Nessun dato",
  estimatedQuote: "Preventivo stimato",
  yourEstimateQuoteInformationIsLoading: "Le informazioni del tuo preventivo stimato sono in caricamento...",
  youAreAboutToApproveThisEstimateAreYouSure:
    "Stai per approvare questa stima. Sei sicuro?",
  reasonForDeclining: "Motivo del rifiuto",
  reasonForReview: "Motivo della revisione",
  estimateQuoteHasBeenApproved: "Il preventivo stimato è stato approvato",
  thankYouSoMuchForApprovingTheEstimateWithUs:
    "Grazie mille per aver approvato la stima con noi",
  cantDeliverOrderWithBookedStatus: "Non è possibile consegnare ordini con stato Prenotato",
  selectedPrice: "Selezionato prezzo: ",
  estimateQuoteHasBeenDeclined: "Il preventivo stimato è stato rifiutato",
  thisEstimateQuoteHasBeenSentToReview: "Questo preventivo stimato è stato inviato per la revisione",
  weAreVerySorryThatTheQuoteWasNotAsExpectedWeHopeYouCanTryAgainAndEverythingGoesWell:
    "Siamo molto dispiaciuti che la stima non fosse come previsto. Speriamo che tu possa riprovare e che tutto vada bene.",
  shipeeziWillAlwaysBeHereWithYou: "Shipeezi sarà sempre qui con te",
  weHaveAlreadyNotifiedTheResponsibleCompanyThatThereAreRevisionsToBeMadeAndIfEverythingGoesCorrectlyYouWillReceiveAReturnShortly:
    "Abbiamo già notificato l'azienda responsabile che ci sono revisioni da fare e se tutto procede correttamente, riceverai un riscontro a breve.",
  saveAndSendToCustomer: "Salva and invia to cliente",
  youHaveToChooseAPriceInTheQuoteTab: "Devi scegliere un prezzo nella scheda Preventivo",
  youHaveToChooseAPaymentMethodInTheQuoteTab:
    "Devi scegliere un metodo di pagamento nella scheda Preventivo",
  noItems: "No articoli",
  theFieldIsEmpty: "Il campo è vuoto",
  addNewMaterial: "Aggiungi nuovo materiale",
  destinations: "Destinazioni",
  show: "Mostra",
  taskAdded: "Attività Aggiunto",
  documentCreatedSuccessfully: "Documento creato con successo",
  documentsUploadedSuccessfully: "Documenti caricato con successo",
  noCommunicationOptionSelected: "No communication option selezionato",
  notificationSent: "Notifica inviata",
  searchForLocation: "Cerca posizione",
  noNotificationsForNow: "Nessuna notifica per ora",
  notificationsWillAppearHereWhenThereAreAnyUpdatesToTheTasksYouAreInvolvedIn:
    "Le notifiche appariranno qui quando ci saranno aggiornamenti sulle attività a cui partecipi.",
  markAndNumbersShouldHaveAtLeastOneFilledLine:
    "Marchi e numeri devono avere almeno una riga compilata",
  theEstimatedQuoteWasSuccessfullyShared: "Il preventivo stimato è stato condiviso con successo",
  noItemsInQuotedInventory: "No articoli in quoted inventario",
  of: "di",
  reportsTo: "Rapporti to",
  changeStatusesTo: "Cambia stati in",
  onlyBookingsWithReceivedByCFSCanChangeToReceivedStatus:
    "Solo le prenotazioni con stato \u00ab Ricevuto dal CFS \u00bb possono passare allo stato \u00ab Ricevuto \u00bb",
  theLinkHasExpired: "Il link è scaduto",
  theEstimatedQuoteLinkHasExpired: "Il link del preventivo stimato è scaduto.",
  youCanRequestANewOneByClickingOnTheButtonBellow:
    "Puoi richiederne uno nuovo cliccando sul pulsante qui sotto.",
  requestNewLink: "Richiedi nuovo link",
  requestedNewLinkSuccessfully: "Requested nuovo link con successo",
  whatDoYouWantToSendToCustomer: "Cosa vuoi inviare al cliente?",
  shareViaVideoSurveyInvite: "Condividi via Video Survey invite",
  sendANewInvitationToTheScheduledVideoSurvey:
    "Invia un nuovo invito al video sopralluogo programmato",
  shareViaEstimatedQuoteLink: "Condividi via Estimated quote link",
  sendTheExternalLinkOfEstimatedQuote: "Invia il link esterno del preventivo stimato",
  thisQuoteDoesNotHaveAValidVideoSurveyTask: "Questo preventivo non ha un'attività video sopralluogo valida",
  thisQuoteDoesNotHaveAnEstimate: "Questo preventivo non ha una stima",
  createNewOffice: "Crea nuovo office",
  editOffice: "Modifica Office",
  officeStatus: "Office stato",
  selectAtLeastOnePort: "Seleziona at least one port",
  city: "Città",
  viewPort: "Visualizza Port",
  siteCode: "Site Codice",
  locationName: "Location nome",
  portStatus: "Port Stato",
  site: "Sito",
  cityCode: "City Codice",
  bookings: "Prenotazioni",
  theInvitationWasSuccessfullySent: "L'invito è stato inviato con successo",
  youMustBeLoggedInToSeeTheInvitation: "Devi essere connesso per vedere l'invito!",
  youHaveReachedTheEndOfNotifications: "Hai raggiunto la fine delle notifiche",
  youHaventAddedAnyPriceYet: "Non hai ancora aggiunto nessun prezzo.",
  automaticallyApprove: "Automatically Approva",
  addSignatureForEveryPage: "Aggiungi firma per ogni pagina",
  addSignatureForOwnerAndLeaderForEveryPageOfReportsInsteadOfTheLastOne:
    "Aggiungi la firma del proprietario e del responsabile su ogni pagina dei rapporti, anziché sull'ultima",
  whenTheUserApprovesHisQuoteThisWillAutomaticallyUpdateTheQuoteOnTheSystem:
    "Quando l'utente approva il preventivo, questo aggiornerà automaticamente il preventivo nel sistema.",
  salesAndOPS: "Vendite e operazioni",
  sales: "Sales",
  ops: "Operazioni",
  onFieldStaff: "Personale sul campo",
  theCartonCanOnlyContainProductsOfTheSameTypeAndColor:
    "Il cartone può contenere solo prodotti dello stesso tipo e colore",
  yourCompanyLogoAndIconRepresentYourBrandIdentityAndValuesThisWillBeUsedInAllCommunicationsAndDocumentsSoItWouldBeGoodToUpload:
    "Il logo e l'icona della tua azienda rappresentano l'identità e i valori del tuo marchio. Saranno utilizzati in tutte le comunicazioni e i documenti, quindi sarebbe bene caricarli.",
  downloadOurCsvTemplate: "Scarica our CSV modello",
  csvActions: "Azioni CSV",
  leavingOnboarding: "Uscita dall'onboarding",
  youAreAboutToExitTheOnboardingProcessAreYouSureYouWantToDoThis:
    "Stai per uscire dal processo di onboarding. Sei sicuro di voler procedere?",
  rememberThatYouWillOnlyBeAbleToUseTheSystemAfterCompletingThisProcess:
    "Ricorda che potrai utilizzare il sistema solo dopo aver completato questo processo.",
  branchName: "Filiale nome",
  branchAddedSuccessfully: "Filiale aggiunto con successo!",
  viewBranches: "Visualizza Filiali",
  inShipeeziYouCanManageBranchesPhysicalLocationsOfYourBusinessAMinimumOf:
    "In Shipeezi puoi gestire le filiali (sedi fisiche della tua azienda). Un minimo di",
  oneBranch: "1 filiale",
  mustBeRecorded: "deve essere registrato.",
  resubmitToMODS: "Re-invia to MODS",
  cantSubmitCancelledBookings: "Non è possibile inviare prenotazioni annullate",
  cantDownloadCancelledBookings: "Non è possibile scaricare prenotazioni annullate",
  bookingsSubmittedSuccessfully: "Prenotazione(s) submitted con successo",
  areYouSureYouWantToReSubmitTheSelectedBookings:
    "Sei sicuro di voler reinviare la/le prenotazione/i selezionata/e?",
  theBookingFileWillBeSentWithAUpdateStatus: "Il file prenotazione sarà inviato con uno stato Aggiornamento",
  submit: "Invia",
  addShipment: "Aggiungi spedizione",
  noShipmentAssociatedYet: "Nessuna spedizione associata ancora",
  addShipmentToOrder: "Aggiungi spedizione to ordine",
  removed: "Rimosso",
  thisProductWasRemovedFromTheOrder: "Questo prodotto è stato rimosso dall'ordine",
  networkVisible: "Rete visibile",
  partner: "Partner",
  uploadImage: "Carica image",
  thisImageWillBeUsedWhenGeneratingCommercialInvoiceAndPackingListDocumentsBeingUsedAsAnEsignature:
    "Questa immagine sar\u00e0 utilizzata nella generazione della \u00ab Fattura Commerciale \u00bb e dei \u00ab Documenti Lista Colli \u00bb, come firma elettronica.",
  hereYouCanChooseWheterToSeeTheNetworkAndHaveTheOptionToSelectAndAgent:
    "Qui puoi scegliere se visualizzare la Rete e avere la possibilità di selezionare un agente come partner per una spedizione. Se viene selezionato un agente, non invieremo comunicazioni al cliente.",
  doYouHaveAgentShipeeziNetworkKey: "Hai la chiave rete Shipeezi dell'agente?",
  agentShipeeziNetworkToken: "Token rete Shipeezi dell'agente",
  thisShipmentHasAPartner: "Questa spedizione ha un partner",
  myAccount: "Il mio account",
  orderCancelledSuccessfully: "Ordine annullato con successo",
  prime: "Prime",
  managePlan: "Gestisci plan",
  lastInvoice: "Last fattura",
  seeInvoiceHistory: "See fattura cronologia",
  invoiceAmount: "Fattura Importo",
  amountOwing: "Importo Owing",
  billingDate: "Billing Data",
  manage: "Gestisci",
  userType: "Utente tipo",
  deductibleQty: "Qtà deducibile",
  extraQty: "Qtà extra",
  quantityUsed: "Quantità used",
  costPerExtraUnit: "Costo per extra unit",
  totalValue: "Totale value",
  addons: "Aggiungi-ons",
  addOn: "Componente aggiuntivo",
  dueDate: "Due data",
  amount: "Importo",
  currentAccountAmountOwing: "Current Account Importo Owing",
  nextBillingDate: "Avanti billing data",
  billingCountry: "Billing paese",
  needToCancelYourSubscription: "Devi annullare il tuo abbonamento",
  cancelSubscription: "Annulla subscription",
  pleaseNotThatOurPricesAreGSTExclusiveGSTWillBeBilledToAustraliaCustomers:
    "Tieni presente che i nostri prezzi sono al netto della GST. La GST sarà addebitata ai clienti australiani a meno che non venga fornito un numero ABN australiano registrato GST valido",
  weKnowCircumstancesCanStometimesChange: "Sappiamo che le circostanze possono cambiare",
  butBeforeYouGoHaveYouTriedOur: "Ma prima di andare, hai provato il nostro",
  forTechnicalFAQ: "per FAQ tecniche",
  knowledgeBase: "Base di conoscenze",
  invoiceHistory: "Fattura cronologia",
  invoiceID: "Fattura ID",
  seeInvoice: "See fattura",
  noKeepSubscription: "No, mantieni abbonamento",
  areYouSureYouWantToCancelYourSubscription: "Sei sicuro di voler annullare il tuo abbonamento",
  ifYouAreInDoubtWeOfferOtherPlansAsWell:
    "In caso di dubbio, offriamo anche altri piani, esplora i piani per vedere le nostre funzionalità.",
  byChoosingToCancelARequestWillBeSentToTeamAndThe:
    "Scegliendo di annullare, verrà inviata una richiesta al team e inizierà il processo di disiscrizione.",
  weAreSorryToSeeYouGo: "Ci dispiace vederti andare!",
  aCancellationRequestHasBeenSentToTheTeamAndWeWillContactYouShortlyToContinueTheOffBoardProcedure:
    "Una richiesta di annullamento è stata inviata al team e ti contatteremo a breve per continuare la procedura di disiscrizione.",
  youCanLogoutNow: "Puoi disconnetterti ora",
  paid: "Pagato",
  uncollectible: "Non riscuotibile",
  waitingForPayment: "In attesa di pagamento",
  planSummary: "Plan riepilogo",
  wantToChangeYourPlan: "Vuoi cambiare il tuo piano",
  contactSales: "contatto sales",
  contactSupport: "Contatto Support",
  ifYouWantToUpgradeOrDowngradeYourPlanPlease:
    "Se desideri aggiornare o ridurre il tuo piano, per favore",
  youDontHaveAnyInvoicesYetWhenAnInvoiceIsGeneratedYoullSeeItHere:
    "Non hai ancora fatture. Quando una fattura viene generata, la vedrai qui.",
  thisShipmentHasAnAgent: "Questa spedizione ha un agente",
  containerSizeType: "Contenitore dimensione & tipo",
  addOrderToShipment: "Aggiungi ordine to spedizione",
  uploadYourFile: "Carica il tuo file",
  maxImageSize: "Max image dimensione",
  changePicture: "Cambia immagine",
  ExporterInformationIsDifferentFromTheVendor: "Le informazioni dell'esportatore sono diverse dal fornitore",
  exporterName: "Exporter nome",
  exporterContactDetails: "Exporter contatto dettagli",
  canBeJust: "può essere solo ",
  or: "o",
  companies: "Aziende",
  ThisProcessIsRecommendedForCompaniesThatHave10OrMoreUsersButOnlyAdminAndGeneralRolesAreAvailableInThisStep:
    "Questo processo è consigliato per le aziende con 10 o più utenti, ma solo i ruoli amministratore e generale sono disponibili in questo passaggio.",
  introduction: "Introduzione",
  welcomeToShipeezi: "Benvenuto su Shipeezi!",
  unleashThePowerOfYourNewSoftware: "Libera la potenza del tuo nuovo software - A pochi passi!",
  wereConfidentThatYoullFindOurPlatformToBeAnInvaluableTool:
    "Siamo certi che troverai la nostra piattaforma uno strumento prezioso per eliminare la frammentazione e fornire visibilit\u00e0 end-to-end sulle tue operazioni. Iniziamo.",
  firstlyLetsAddYourCompanyDetailsToYourAccountIncludingBusinessAddress:
    "Per prima cosa, aggiungiamo i dettagli della tua azienda al tuo account, inclusi indirizzo aziendale, numero di telefono, contatto principale e informazioni email.",
  nextWellSetUpYourCompanyUsersAndDefineTheirPermissionsAndAccessLevels:
    "Successivamente, configureremo gli utenti della tua azienda e definiremo i loro permessi e livelli di accesso.",
  finallyWellAskYouToUploadPreliminaryInformationToAssistOurTeamWithConnectingYourDataStreams:
    "Infine, ti chiederemo di caricare informazioni preliminari per assistere il nostro team nella connessione dei tuoi flussi di dati.",
  deleteComment: "Elimina comment",
  areYouSureYouWantToDeleteThisComment: "Sei sicuro di voler eliminare questo commento?",
  itLooksLikeTheresNoCommentsYet: "Sembra che non ci siano ancora commenti",
  feelFreeToAddAnyCommentsYouFeelNecessary: "Sentiti libero di aggiungere qualsiasi commento ritieni necessario",
  typeHereYourNote: "Scrivi qui la tua nota...",
  notifyPartyStatus: "Notify Party stato",
  editNotifyParty: "Modifica Notify Party",
  viewNotifyParty: "Visualizza Notify Party",
  createNotifyParty: "Crea Notify Party",
  searchForAgent: "Cerca for agent",
  bodyOfEmail: "Corpo dell'email",
  bodyOfSMS: "Corpo del SMS",
  cartons: "Cartoni",
  custom: "Personalizzato",
  customTime: "Orario personalizzato",
  shipeeziBilling: "Fatturazione Shipeezi",
  theExtraQuantityIsTheDifferenceBetweenTheQuantityUsedAndDeductibleQty:
    'La quantità extra è la differenza tra la "Quantità utilizzata" e la "Quantità deducibile"',
  templateDetails: "Modello dettagli",
  youCannotCreateATemplateWithABrokenTag: "Non puoi creare un modello con un tag non valido",
  receiveUsingCSV: "Ricevi usando CSV",
  couldNotFoundSSCC: "Impossibile trovare SSCC",
  searchForAContact: "Cerca for a contatto",
  setTemplateAsDefault: "Set modello as default",
  ssccNotFound: "SSCC non trovato",
  ssccFound: "SSCC trovato",
  setAsDefault: "Imposta come predefinito",
  yesChangeIt: "Sì, change it",
  changeDefault: "Cambia predefinito",
  doYouWantToMakeTheSelectedTemplateTheDefault:
    "Vuoi impostare il modello selezionato come predefinito?",
  theCurrentDefaultForThisTypeWillBeReplaced: "Il valore predefinito corrente per questo tipo sarà sostituito.",
  youCanChangeItBackLaterIfYouWant: "Puoi ripristinarlo in seguito se vuoi.",
  cartonStatus: "Carton stato",
  weightAndCBMOfThisBookingMustBeConfirmedBeforeThisCanBeDone:
    "Il peso e il CBM di questa prenotazione devono essere confermati prima di procedere, puoi regolare i valori nella scheda CBM e Peso",
  allSSCCMustBeReceived: "Tutti gli SSCC devono essere ricevuti",
  confirmAndReceive: "Conferma and receive",
  allSSCCsFromCsvWereMarkedAsReceived: "Tutti gli SSCC dal CSV sono stati contrassegnati come ricevuti",
  boxesCouldntBeMarkedAsReceivedPleaseCheckAllErrorsOnWarehouseScanDataDocumentAndTryAgain:
    "scatole non possono essere contrassegnate come ricevute. Verifica tutti gli errori nel documento Dati Scansione Magazzino e riprova",
  NoneSSCCsCouldBeMarkedAsReceivedPleaseCheckAllErrorsOnWarehouseScanDataDocumentAndTryAgain:
    "Nessun SSCC può essere contrassegnato come ricevuto. Verifica tutti gli errori nel documento Dati Scansione Magazzino e riprova",
  attention: "Attenzione",
  containerNumberIsRequired: "Il numero contenitore è obbligatorio",
  youShouldAddAtLeastOneOrderToTheShipment: "Devi aggiungere almeno un ordine alla spedizione",
  thisFieldMustBeGreaterThanOrEqualTo0: "*Questo campo deve essere maggiore o uguale a 0",
  dcCode: "DC codice",
  thisIsADeliveryLocation: "Questa è una sede di consegna",
  stayLoggedIn: "Resta connesso",
  aSubscribedShipmentWasUnselectedAndCannotBeRemoved:
    "Una spedizione con abbonamento è stata deselezionata e non può essere rimossa!",
  saveAsDraft: "Salva as draft",
  tracking: "Tracciamento",
  thereWasAProblemTryingToImportTheFilePleaseRefreshThePage:
    "Si è verificato un problema durante l'importazione del file. Aggiorna la pagina e riprova.",
  theFileWasSentToImport: "Il file è stato inviato per l'importazione",
  vesselPositionUpdateDailyAt5pmUTC: "Vessel positions aggiorna daily at 5pm UTC",
  locationIndicatedAboveIsMoreAccurateIfItDiffersFromMapDisplay:
    "La posizione indicata sopra è più precisa se differisce dalla visualizzazione sulla mappa",
  unableToExportCSVFile: "Unable to esporta CSV file",
  analytics: "Analisi",
  uploadDateAndTime: "Carica data and time",
  exporter: "Esportatore",
  shipmentNumber: "Spedizione Numero",
  postCode: "Post Codice",
  itemType: "Articolo tipo",
  consignmentNumber: "Consignment numero",
  pieces: "Pezzi",
  stocksToDespatch: "Scorte da spedire",
  palletsToDespatch: "Pallet da spedire",
  deliveryWindowOpen: "Consegna Window Apri",
  deliveryWindowClose: "Consegna Window Chiudi",
  shippingItems: "Shipping Articoli",
  truck: "Camion",
  addExistingAddress: "Aggiungi Esistente Indirizzo",
  newAddress: "Nuovo Indirizzo",
  noDeliveryAddressAddedYet: "Nessun indirizzo di consegna aggiunto",
  noPickupAddressAddedYet: "Nessun indirizzo di ritiro aggiunto ancora",
  addresses: "Indirizzi",
  createDespatch: "Crea Despatch",
  editDespatch: "Modifica Despatch",
  staged: "In preparazione",
  inTransit: "In transito",
  newPickUpAddress: "Nuovo Pick up Indirizzo",
  newDeliveryAddress: "Nuovo Consegna Indirizzo",
  editPickUpAddress: "Modifica Pick up Indirizzo",
  editDeliveryAddress: "Modifica Consegna Indirizzo",
  labelAddress: "Etichetta indirizzo",
  pickUpAddress: "Pick up Indirizzo",
  addAddresses: "Aggiungi indirizzi",
  palletsPerTrucks: "Pallet per camion",
  newShippingItem: "Nuovo Shipping Articolo",
  editShippingItem: "Modifica Shipping Articolo",
  itLooksLikeThereSNoDataYet: "Sembra che non ci siano ancora dati",
  youWillBeAbleToSeeAllTheInformationAboutThe:
    "Potrai vedere tutte le informazioni su",
  associatedWithTheDespatchWhenYouAddThem: "associati alla spedizione quando li aggiungi",
  addShippingItems: "Aggiungi Shipping Articoli",
  editTruck: "Modifica Truck",
  newTruck: "Nuovo Truck",
  quantityOnHand: "Quantità On Hand",
  allDespatched: "Tutti Despatched",
  available: "Disponibile",
  youCanStartByCreatingANew: "Puoi iniziare creando un nuovo",
  passwordsDoNotMatch: "Le password non corrispondono.",
  theresNoEstimatesAvailableToView: "Non ci sono stime disponibili da visualizzare",
  userHasAccessTo: "L'utente ha accesso a...",
  poConfirmedVsPOReceived: "PO Confirmed vs PO Ricevuto",
  poPastShipByDate: "PO Past Ship by Data",
  pastShipByDate: "Data spedizione scaduta",
  pendingPurchaseOrders: "In attesa Purchase Ordini",
  printReport: "Stampa rapporto",
  addTruck: "Aggiungi Truck",
  maxValueAccepted: "Valore massimo accettato",
  averageMonthlyCost: "Average Monthly Costo",
  averageOverTheLast12MonthsExcludingTaxes: "Media degli ultimi 12 mesi escluse le tasse",
  templates: "Modelli",
  youShouldAddAtLeastOnePickUpAddress: "Devi aggiungere almeno un indirizzo di ritiro",
  youShouldAddAtLeastOneDeliveryAddress: "Devi aggiungere almeno un indirizzo di consegna",
  youShouldAddAtLeastOneProduct: "Devi aggiungere almeno un prodotto",
  ayrtonSenna: "Ayrton Senna",
  positionInManufacturingCompany: "Position in manufacturing azienda",
  nameOfManufacturingCompany: "Nome of manufacturing azienda",
  egSupplier: "E.g fornitore",
  egShipeezi: "Es. shipeezi",
  searchByCountry: "Cerca per paese",
  vendorId: "ID fornitore",
  countryOfOrigin: "Paese of Origin",
  accessIntructions: "Access Istruzioni",
  generateInvoice: "Genera fattura",
  schedule: "Programma",
  associatedWithTheInvoicesWhenYouAddThem: "associati alle fatture quando li aggiungi",
  loadingInvoices: "Caricamento Fatture",
  consol: "Consolidamento",
  etaMonth: "Mese ETA",
  actualDelivery: "Actual Consegna",
  commInvNo: "N. Fatt. Comm.",
  commInvDate: "Comm Inv Data",
  partNumber: "Part Numero",
  receivedLinePrice: "Prezzo riga ricevuto",
  invoiceExchangeRate: "Fattura Exchange Rate",
  audValue: "Valore AUD",
  duty: "dazio",
  lineDutyAmount: "Importo dazio riga",
  kewill: "Kewill",
  cblNo: "N. CBL",
  mawbNo: "N. MAWB",
  originCharges: "Costi origine",
  internationalFreight: "Trasporto internazionale",
  destinationCharges: "Costi destinazione",
  totalFreightAUD: "Totale Freight AUD",
  unitFob: "Unità FOB",
  freightCPU: "Trasporto CPU",
  freightasFOB: "Trasporto come FOB",
  deleteInvoice: "Elimina Fattura",
  areYouSureYouWantToDeleteTheInvoice: "Sei sicuro di voler eliminare la fattura",
  invoiceQuantity: "Quantità fattura",
  houseBill: "Polizza house",
  masterBill: "Polizza master",
  hblCountMode: "HBL Count Modalità",
  chargeCode: "Charge Codice",
  overseasAmount: "Importo estero",
  exchangeRateCurrency: "Valuta tasso di cambio",
  exchangeRate: "Tasso di cambio",
  invoicedLocalAmount: "Importo locale fatturato",
  gstAmount: "GST Importo",
  invoiceDate: "Data fattura",
  invoiceDueDate: "Data scadenza fattura",
  autoRate: "Tariffa automatica",
  cottonOnAdultsApportionment: "Ripartizione Cotton On Adulti",
  cottonOnAdultsLocalAmount: "Cotton On Adults Local Importo",
  ceresLifeApportionment: "Ripartizione Ceres Life",
  ceresLifeLocalAmount: "Ceres Life Local Importo",
  bodyApportionment: "Ripartizione corpo",
  bodyLocalAmount: "Importo locale corpo",
  factorieApportionment: "Ripartizione fabbrica",
  factorieLocalAmount: "Factorie Local Importo",
  kidsApportionment: "Ripartizione bambini",
  kidsLocalAmount: "Kids Local Importo",
  rubiApportionment: "Ripartizione Rubi",
  rubiLocalAmount: "Rubi Local Importo",
  foundationApportionment: "Ripartizione fondazione",
  foundationLocalAmount: "Foundation Local Importo",
  typoApportionment: "Ripartizione Typo",
  typoLocalAmount: "Typo Local Importo",
  gamedayApportionment: "Ripartizione giorno evento",
  gamedayLocalAmount: "Gameday Local Importo",
  supreApportionment: "Ripartizione Supre",
  supreLocalAmount: "Supre Local Importo",
  fixturesApportionment: "Ripartizione impianti fissi",
  fixturesLocalAmount: "Fixtures Local Importo",
  consumablesApportionment: "Ripartizione consumabili",
  consumablesLocalAmount: "Importo locale consumabili",
  otherApportionment: "Altra ripartizione",
  otherLocalAmount: "Altro importo locale",
  dateType: "Data tipo",
  searchBy: "Cerca per",
  sendReportByEmail: "Invia rapporto by email",
  originCountry: "Origin Paese",
  part: "Parte",
  id: "Id",
  createSendRecurrence: "Crea ricorrenza invio",
  daily: "Giornaliero",
  weekly: "Settimanale",
  monthly: "Mensile",
  frequency: "Frequenza",
  isNotAValidEmail: "non è un'email valida",
  emailScheduled: "Email programmata",
  emailSent: "Email inviata",
  storageStatus: "Stato stoccaggio",
  newStorageBox: "Nuova scatola di stoccaggio",
  editStorageBox: "Modifica scatola di stoccaggio",
  newStorageBoxType: "Nuovo Stoccaggio Box Tipo",
  editStorageBoxType: "Modifica Stoccaggio Box Tipo",
  typeNumber: "Tipo numero",
  depth: "Profondità",
  deleteStorageBox: "Elimina scatola di stoccaggio",
  deleteStorageBoxType: "Elimina Stoccaggio Box Tipo",
  areYouSureYouWantToDeleteThisStorageBox: "Sei sicuro di voler eliminare questa scatola di stoccaggio",
  areYouSureYouWantToDeleteThisStorageBoxType:
    "Sei sicuro di voler eliminare questo tipo di scatola di stoccaggio",
  createSmsTemplate: "Crea modello SMS",
  notBeingUsed: "Non in uso",
  inUse: "In uso",
  template: "Modello",
  hideCc: "Nascondi CC",
  hideBcc: "Nascondi BCC",
  showCc: "Mostra CC",
  showBcc: "Mostra BCC",
  sendEstimateToCustomer: "Invia stima to cliente",
  writeYourOwnOrChooseFromPreSetTemplates: "Scrivi il tuo o scegli tra modelli preimpostati",
  storageBoxesAndUnits: "Stoccaggio Boxes & Units",
  writeYourOwnOrChooseFromTemplates: "Scrivi il tuo o scegli dai modelli",
  movement: "Movimento",
  movements: "Movimenti",
  objectToMove: "Oggetto da spostare",
  storageBox: "Stoccaggio box",
  looseItem: "Loose articolo",
  typeOfObject: "Tipo di oggetto",
  seeObjectActivity: "Vedi attività oggetto",
  moveTo: "Sposta to",
  object: "Oggetto",
  moveToLocation: "Sposta to location",
  move: "Sposta",
  someObjectDetailsWillBeDisplayedWhenYouSelectIt:
    "Alcuni dettagli dell'oggetto saranno visualizzati qui quando lo selezioni",
  noObjectSelected: "Nessun oggetto selezionato",
  insideAStorageBox: "Inside a stoccaggio box",
  seeFullDetails: "See full dettagli",
  section: "Sezione",
  storageBoxDetails: "Stoccaggio box dettagli",
  dateIntoStorage: "Data entrata stoccaggio",
  lastMoved: "Ultimo spostamento",
  isLocatedInTheCellYouAreGoingToMoveDoYouWantToContinue:
    "si trova nella cella che stai per spostare, vuoi continuare?",
  isPlacedInThisLocationRightNowWouldYouLikeToMoveItToAnUnknowLocationForNow:
    "si trova in questa posizione in questo momento, vuoi spostarlo in una posizione « sconosciuta » per ora?",
  the: "Il",
  locationIsFull: "La posizione è piena",
  accessTo: "Accesso a",
  rows: "Righe",
  columns: "Colonne",
  levels: "Livelli",
  createMap: "Crea Map",
  editMap: "Modifica Map",
  input: "Input",
  columnsQuantity: "Columns quantità",
  characterUsed: "Carattere utilizzato",
  initial: "Iniziale",
  suffix: "Suffisso",
  rowsQuantity: "Rows quantità",
  levelsQuantity: "Levels quantità",
  buildMap: "Costruisci mappa",
  numbers: "Numeri",
  alphabetical: "Alfabetico",
  ascendant: "Ascendente",
  descendant: "Discendente",
  deleteMap: "Elimina Map",
  viewMap: "Visualizza Map",
  areYouSureYouWantToDeleteThisMap: "Sei sicuro di voler eliminare questa mappa",
  thisFieldMustBeGreaterThanZero: "Questo campo deve essere maggiore di zero",
  mapGenerated: "Mappa generata",
  topView: "Top visualizza",
  applySearch: "Applica cerca",
  cartonCondition: "Condizione cartone",
  eventDate: "Event Data",
  deliveryStore: "Consegna Store",
  storeNumber: "Store Numero",
  estimateArriveWH: "Stima Arrive WH",
  arrivalFinalPort: "Arrivo porto finale",
  meChecklist: "Checklist M&E",
  haveYouDoneTheMEChecklistOnThisItem: "Hai fatto il M&E su questo articolo?",
  meChecklistDone: "Checklist M&E completata",
  unsetAsDefault: "Rimuovi come predefinito",
  storageAccounts: "Stoccaggio accounts",
  period: "Periodo",
  nextBilling: "Avanti billing",
  createNew: "Crea nuovo",
  settlement: "Regolamento",
  createNewStorageAccount: "Crea nuovo stoccaggio account",
  storageAccountOrder: "Ordine conto stoccaggio",
  pickedUp: "Ritirato",
  assignLocation: "Assegna location",
  assignStorageBox: "Assegna scatola di stoccaggio",
  storageSpace: "Stoccaggio space",
  unit: "Unità",
  assignStorageBoxLocation: "Assegna stoccaggio box location",
  typeStorage: "Tipo stoccaggio",
  storageFrom: "Stoccaggio da",
  gracePeriodEnd: "Fine periodo di grazia",
  storageEnd: "Stoccaggio End",
  selectAPaymentMethod: "Seleziona a payment method",
  plan: "Piano",
  totalGSTIncluded: "Totale (GST Included)",
  extraServices: "Servizi extra",
  grandTotal: "Grand totale",
  etaUnpackDate: "Eta Unpack Data",
  finalPortArrival: "Arrivo porto finale",
  all: "Tutti",
  estimateArrivalWH: "Stima Arrival WH",
  selectAtLeastOneProject: "Seleziona at least one project",
  expectedQty: "Qtà prevista",
  quantityReceived: "Quantità ricevuta",
  dateReceived: "Data Ricevuto",
  selectBranch: "Seleziona filiale",
  selectGroup: "Seleziona gruppo",
  sections: "Sezioni",
  createNewSection: "Crea nuova sezione",
  contains: "contiene",
  storageBoxType: "Tipo scatola di stoccaggio",
  selectAtLeastOneWarehouseOrSku: "Seleziona at least one Magazzino or SKU",
  locationPreviewStatus: "Location preview stato",
  selectNewLocation: "Seleziona nuova posizione",
  noMapSelected: "Nessuna mappa selezionata",
  aLittleMapPreviewWillAppearHereWhenYouSelectTheSectionInTheObjectThatShouldBeMoved:
    "Un'anteprima della mappa apparirà qui quando selezioni la sezione dell'oggetto da spostare",
  unload: "Scarica",
  uploadDate: "Carica data",
  viewInWarehouseMap: "Visualizza in magazzino map",
  changeLocation: "Cambia posizione",
  funcionalityUnderDevelopment: "Funzionalità in sviluppo",
  selectWhichOrderToUnload: "Seleziona quale ordine scaricare",
  pleasePayAttention: "Per favore, fai attenzione!",
  onceTheOrderIsUnloadedItCannotChangeStatusAgain:
    "Una volta scaricato l'ordine, non può più cambiare stato.",
  full: "Completo",
  unusable: "Inutilizzabile",
  couldNotFound: "Impossibile trovare",
  selectAtLeastOneContainer: "Seleziona at least one contenitore",
  receivedExpected: "Ricevuto - Expected",
  receivedUnexpected: "Ricevuto - Unexpected",
  notReceivedExpected: "Non ricevuto - Previsto",
  clear: "Cancella",
  clearFields: "Cancella campi",
  palletDimensions: "Dimensioni pallet",
  cartonDimensions: "Dimensioni cartone",
  minimumValue: "Valore minimo",
  newMap: "Nuovo map",
  theFollowingStorageBoxesAreLoadedAndCanNotChangeStatus:
    "Le seguenti scatole di stoccaggio sono caricate e non possono cambiare stato:",
  theFollowingMapsHaveLoadedLocationsAndCanNotChangeStatus:
    "Le seguenti mappe hanno posizioni caricate e non possono cambiare stato:",
  theFollowingWarehousesHaveSectionsWithMapsInUseAndCanNotChangeStatus:
    "I seguenti magazzini hanno sezioni con mappe in uso e non possono cambiare stato:",
  selectAStartDate: "Seleziona a inizio data",
  enterAtLeast: "Inserisci at least",
  ordersHaveDifferent: "Gli ordini hanno diversi",
  jobNumber: "Job Numero",
  commercialInvoiceNumber: "Commercial Fattura Numero",
  commercialInvoiceDate: "Commercial Fattura Data",
  lineDutyPercent: "Percentuale dazio riga",
  nonAUEntryFees: "Commissioni ingresso non AU",
  totalUnitCosts: "Totale Unit Costi",
  freightAUD: "Trasporto AUD",
  freightFob: "Trasporto FOB",
  new: "Nuovo",
  shareable: "Condivisibile",
  routePlanner: "Pianificatore percorsi",
  mapSettings: "Map impostazioni",
  clearLocation: "Cancella posizione",
  routing: "Instradamento",
  sharedWith: "Condiviso con",
  belongsTo: "Appartiene a",
  hasNoWarehouses: "non ha magazzini",
  belongsToWarehouse: "Belongs to magazzino",
  sharedWarehouses: "Shared Magazzini",
  isNotShareable: "Non è condivisibile",
  cartonsPerPallet: "Cartoni per pallet",
  allIncluded: "tutti included",
  exampleOfTiHi: "Esempio di Ti-Hi",
  manufacture: "Produzione",
  deleteProduct: "Elimina prodotto",
  unitsInTransit: "Unità in transito",
  originShipments: "Origin spedizioni",
  cartonsToDespatch: "Cartoni da spedire",
  companyCurrentStock: "Azienda current stock",
  mainSupplier: "Main fornitore",
  stock: "Scorte",
  cartonWeight: "Carton peso",
  createProduct: "Crea prodotto",
  byWho: "Da chi",
  objectNumber: "Numero oggetto",
  newMovement: "Nuovo movement",
  none: "Nessuno",
  ordersQuantity: "Quantità ordini",
  itemsInsideThisStorageBox: "Articoli in questo contenitore di stoccaggio",
  bookingNumber: "Prenotazione numero",
  noLocation: "Nessuna posizione",
  typeInLocation: "Tipo in location",
  startWarehouse: "Inizio Magazzino",
  endWarehouse: "End Magazzino",
  rta: "RTA",
  addToRoutePlanner: "Aggiungi to Route Planner",
  removingFromRoutePlanner: "Rimozione dal pianificatore percorsi",
  removeFromRoutePlanner: "Rimuovi dal pianificatore percorsi",
  removedFromRoutePlanner: "Rimosso dal pianificatore percorsi",
  addingToRoutePlanner: "Aggiunta al pianificatore percorsi",
  addedToRoutePlanner: "Aggiunto to Route Planner",
  couldNotAddToRoutePlanner: "Impossibile aggiungere al pianificatore percorsi",
  couldNotRemoveFromRoutePlanner: "Impossibile rimuovere dal pianificatore percorsi",
  updatingInRoutePlanner: "Aggiornamento in Route Planner",
  updatedInRoutePlanner: "Aggiornato in Route Planner",
  couldNotUpdateInRoutePlanner: "Aggiornato in Route Planner",
  addToRoutePlannerQuestionMark: "Aggiungi to Route Planner ?",
  addAShift: "Aggiungi a shift",
  shiftTime: "Orario turno",
  shiftTimes: "Orari turno",
  addASecondShiftDuration: "Aggiungi a second shift duration",
  scacCode: "SCAC Codice",
  carrierName: "Vettore Nome",
  carrierNameAbbreviation: "Vettore Nome (Abbr.)",
  editCarrier: "Modifica Vettore",
  createNewCarrier: "Crea Nuovo Vettore",
  trackableBy: "Tracciabile per",
  areYouSureYouWantToDeleteThisCarrier: "Sei sicuro di voler eliminare questo vettore",
  deleteCarrier: "Elimina Vettore",
  transshipment: "Trasbordo",
  dueDateBy: "Data scadenza per",
  requestedBy: "Richiesto da",
  assignedTo: "Assegnato to",
  newTransshipment: "Nuovo trasbordo",
  showTodaysTransshipments: "Mostra today’s transshipments",
  generalDetails: "General dettagli",
  whatToDo: "Cosa fare",
  team: "Squadra",
  saveAndPublish: "Salva and Publish",
  markItemsYouWantToMove: "Segna gli articoli che vuoi spostare",
  perItem: "Per articolo",
  bingoSheet: "Foglio bingo",
  transshiping: "In trasbordo",
  thisFieldShouldHaveAlphaNumericCharactersOnly:
    "Questo campo deve contenere solo caratteri alfanumerici",
  bookingReference: "Prenotazione Riferimento",
  showAllStorageBoxes: "Mostra tutti Stoccaggio Boxes",
  addStorageBox: "Aggiungi scatola di stoccaggio",
  createASingleUseBox: "Crea a single use box",
  storageBoxNumber: "Stoccaggio box numero",
  volumeAvailable: "Volume disponibile",
  theStorageBoxHasBeenAddedSuccessfully: "Il contenitore di stoccaggio è stato aggiunto con successo",
  itLooksLikeTheresNoDataYet: "Sembra che non ci siano ancora dati",
  startSearchingForAStorageBoxOrCreateASingleUseBox:
    "Inizia a cercare una scatola di stoccaggio o creane una monouso.",
  system: "Sistema",
  editTransshipment: "Modifica trasbordo",
  any: "Qualsiasi",
  pickUpTime: "Ora di ritiro",
  deliveryTime: "Consegna Time",
  addDespatchesToRoute: "Aggiungi despatches to route",
  removeDespatchesToRoute: "Rimuovi despatches to route",
  added: "Aggiunto",
  searchForStorageBox: "Cerca for stoccaggio box",
  noItemsToAddToTransshipment: "No articoli to aggiungi to transshipment",
  showTodayTransshipments: "Mostra trasbordi di oggi",
  showing: "Visualizzazione",
  theOrderHasAlreadyBeenAdded: "L'ordine è già stato aggiunto",
  publish: "Pubblica",
  editProject: "Modifica Project",
  newProject: "Nuovo Project",
  fileName: "File nome",
  dateUploaded: "Data caricato",
  ofRows: "di righe",
  addFile: "Aggiungi File",
  whenYouAddThem: "quando li aggiungi",
  youWillBeAbleToSeeAllThe: "Potrai vedere tutti",
  detailsHereWhenYouUploadAtLeastOne: "dettagli qui quando carichi almeno uno",
  createProject: "Crea project",
  uploadAFile: "Carica un file",
  willBeRemoveAllOfTheItemsWillUnloadFromIt:
    "Verrà rimossa. Tutti gli articoli verranno scaricati.",
  areYouSureYouWantToContinue: "Sei sicuro di voler continuare?",
  removeStorageBox: "Rimuovi scatola di stoccaggio",
  cellInUse: "Cella in uso",
  allWarehouses: "Tutti Magazzini",
  yourStorageBoxesAreBeingUploaded: "I tuoi contenitori di stoccaggio sono in fase di caricamento",
  automate: "Automatizza",
  sentToEmail: "Inviato via email",
  editAutomation: "Modifica Automation",
  deletedSuccessfully: "Eliminato con successo",
  deleteAutomation: "Elimina automation",
  doYouReallyWantToDeleteTheAutomation: "Vuoi davvero eliminare l'automazione",
  createOrder: "Crea Ordine",
  addNewproducts: "Aggiungi nuovi prodotti",
  manual: "Manuale",
  paragraph: "Paragrafo",
  options: "Opzioni",
  addOption: "Aggiungi option",
  youNeedToLogOutAndLogBackInForSomeChangesToBeApplied:
    "Devi disconnetterti e riconnetterti per applicare alcune modifiche.",
  someChangesWereNotApplied: "Alcune modifiche non sono state applicate",
  enableAsAStorageBox: "Abilita as a stoccaggio box",
  enablingThisAllowsTheUserToChooseTheVehicleForStorageMovementOrTransshipmentAndIndicateWhenItemsArePlacedInsideLikeAStorageBox:
    "Abilitando questa opzione, l'utente può scegliere il veicolo per lo spostamento stoccaggio o il trasbordo e indicare quando gli articoli vengono posizionati all'interno, come una scatola di stoccaggio.",
  projectUpdatedWithSuccess: "Progetto aggiornato con successo",
  deleteBrandName: "Elimina nome del marchio",
  deleteBrandNames: "Elimina brand names",
  areYouSureYouWantToDeleteTheBrandName: "Sei sicuro di voler eliminare il nome del marchio",
  areYouSureYouWantToDeleteThese: "Sei sicuro di voler eliminare quelli",
  brandName: "Brand nome",
  brandNames: "Nomi del marchio",
  brandCode: "Brand codice",
  addNewBrandName: "Aggiungi nuovo brand nome",
  youCanStartByAddingANewBrandName: "Puoi iniziare aggiungendo un nuovo nome di marca",
  loadingBrands: "Caricamento Brands",
  newBrand: "Nuovo brand",
  logo: "Logo",
  editBrand: "Modifica brand",
  viewBrand: "Visualizza brand",
  deleteBrands: "Elimina Brands",
  previewOnSSCCLabel: "Preview on SSCC etichetta",
  noPdfFileSpecified: "Nessun file PDF specificato",
  loadType: "Load Tipo",
  groupageVanline: "Raggruppamento/Vanline",
  otherEnterDims: "Altro (inserisci dimensioni)",
  parties: "Parti",
  rail: "Ferrovia",
  itemIsAHardwareBox: "L'articolo è un box hardware",
  youCanSeeTheReportsAfterSelectingTheFollowingFilters:
    "Puoi visualizzare i rapporti dopo aver selezionato i seguenti filtri",
  selectAProject: "Seleziona a project",
  selectAWarehouse: "Seleziona un magazzino",
  selectASKU: "Seleziona a SKU",
  selectAContainer: "Seleziona a Contenitore",
  brands: "Marchi",
  repeat: "Ripeti",
  weAreCheckingIfALinkIsAvailable: "Stiamo verificando se un link è disponibile",
  pleaseSelectAOrderType: "Seleziona un tipo di ordine",
  etaDestination: "ETA destinazione",
  etaDespatch: "ETA spedizione",
  trackable: "Tracciabile",
  downloadShipmentInformations: "Scarica Spedizione Informations",
  boxContents: "Contenuto scatola",
  packedInto: "Imballato in",
  indicateLiftvanOrSectionTheItemCanBeFound: "Indica il liftvan o la sezione in cui si trova l'articolo",
  values: "Valori",
  automaticallyCreateOneHardwareBoxInEveryInventory:
    "Crea automaticamente una scatola hardware in ogni inventario",
  needsAtLeastOneActiveHardwareBoxItemToBeEnabled:
    "È necessario almeno un elemento scatola hardware attivo per essere abilitato.",
  carrierScac: "Vettore scac",
  fieldsAreRequired: "Numero contenitore, riferimento prenotazione o polizza di carico sono obbligatori.",
  theFleetNameIsUsedAsTheSystemDefault: "Il nome della flotta è usato come predefinito di sistema",
  isBox: "È scatola",
  isBoxInterrogation: "È scatola?",
  isThisTypeOfPackagingABox: "Questo tipo di imballaggio è un box?",
  hardwareBox: "Scatola hardware",
  itemIsHighRiskOrHighValue: "Articolo ad alto rischio/alto valore",
  thisCarrierAllowsShipmentTrackingBy: "Questo vettore consente il tracciamento della spedizione tramite",
  meChecklistIsmandatoryForThisItemPleaseAnswerIt:
    "La checklist M&E è obbligatoria per questo articolo, compilala",
  enableEstimateEditing: "Abilita stima editing",
  enable: "Abilita",
  areYouSureYouWantToEnableEditingEstimateForThisQuote:
    "Sei sicuro di voler abilitare la modifica della stima per questo preventivo?",
  changesMadeToThisQuoteMayAlsoAffectOrder: "Le modifiche a questo preventivo potrebbero influenzare anche l'ordine.",
  measurementPreview: "Anteprima misurazioni",
  me: "M&E",
  highRiskHighValue: "Alto rischio / Alto valore",
  proGear: "Pro-Gear",
  itemIsAME: "L'articolo è un M&E",
  youCanSeeTheReportsAfterSelectingAtLeast: "Puoi visualizzare i rapporti dopo aver selezionato almeno",
  warehouseCodeAlreadyExistsPleaseAssignANewCode:
    "Il codice magazzino esiste già. Assegna un nuovo codice.",
  enterTheBoxNumberToSearch: "Inserisci il numero del box da cercare.",
  enterTheOrderToSearch: "Inserisci l'ordine da cercare.",
  noResults: "Nessun risultato",
  etdOrigin: "ETD origine",
  etaPlanned: "ETA pianificato",
  addNewShipment: "Aggiungi nuova spedizione",
  basedOnABooking: "Based on a prenotazione",
  box: "Scatola",
  case: "Caso",
  pallet: "Pallet",
  ftl: "FTL",
  ltl: "LTL",
  fcl: "FCL",
  lcl: "LCL",
  groupage: "Raggruppamento",
  roro: "RORO",
  bulk: "Massa",
  commodityHSCode: "Commodity HS Codice",
  enterTheLocationToSearch: "Inserisci la posizione da cercare.",
  productPhoto: "Foto prodotto",
  masterbillOfLanding: "Polizza di carico master",
  housebillOfLanding: "Polizza di carico house",
  shipmentDetails: "Spedizione dettagli",
  placeOfOrigin: "Luogo di origine",
  shipperCode: "Shipper codice",
  addAnotherContainer: "Aggiungi another Contenitore",
  volumetricWeight: "Volumetric peso",
  grossVolume: "Volume lordo",
  tareWeight: "Tare peso",
  netWeight: "Net peso",
  verifiedGrossWeight: "Verified Gross Peso",
  selectABooking: "Seleziona una prenotazione",
  noSubscriberAdded: "Nessun abbonato aggiunto",
  selectABookingBellowToStartAShipmentBasedOnIt:
    "Seleziona una prenotazione qui sotto per avviare una spedizione basata su di essa",
  selectJustOneBookingPerShipment: "Seleziona una sola prenotazione per spedizione",
  startByAddingASubscribertoShipment: "Inizio by adding an Subscriber to spedizione",
  youMustSelectAShipmentLoadingPortFirst: "Devi prima selezionare un porto di carico della spedizione",
  youMustSelectAShipmentDestinationFirst: "Devi prima selezionare una destinazione della spedizione",
  youMustSelectAShipmentOriginFirst: "Devi prima selezionare un'origine della spedizione",
  youMustSelectAShipmentDischargePortFirst: "Devi prima selezionare un porto di scarico della spedizione",
  youMustSelectAShipmentModeFirst: "Devi prima selezionare una modalità di spedizione",
  youMustSelectAShipmentIncotermFirst: "Devi prima selezionare un incoterm della spedizione",
  variance: "Varianza",
  youCanStartByAddingAnOrder: "Puoi iniziare aggiungendo un ordine",
  editSubscriber: "Modifica subscriber",
  fromThisShipment: "da questa spedizione",
  regularCargo: "Carico regolare",
  hazardousCargo: "Merce pericolosa",
  foodGradeCargo: "Carico alimentare",
  rareCargo: "Carico raro",
  reeferCargoRefrigerated: "Carico reefer (Refrigerato)",
  addInAContainer: "Aggiungi in a contenitore",
  chooseAContainerToAddTheSsccInto: "Scegli un contenitore in cui aggiungere l'SSCC",
  choose: "Scegli",
  distanceTravelled: "Distanza percorsa",
  distanceToGo: "Distanza rimanente",
  route: "Itinerario",
  shipeeziPredictsETA: "Previsione ETA Shipeezi",
  plannedETA: "ETA pianificato",
  theCarrierProvidesDateTimesBelowAndMayNotMatchObservationsAndPredictionsInOtherSections:
    "Il vettore fornisce le date-ore qui sotto e potrebbero non corrispondere alle osservazioni e previsioni nelle altre sezioni.",
  events: "Eventi",
  notEventsToShowAtTheMoment: "Nessun evento da mostrare al momento",
  dayDelay: "Giorno delay",
  daysDelay: "Giorni delay",
  invalidNumber: "Numero non valido",
  trackingNotFound: "Tracciamento non trovato",
  shipmentCreated: "Spedizione creata",
  checkTheInformationYouHaveFilledInUpdateItAndSaveItWellValidateItAgainInAFewMinutes:
    "Verifica le informazioni inserite, aggiornale e salvale. Le convalideremo nuovamente tra pochi minuti.",
  weReStillValidatingInformationToSeeIfThisShipmentIsTrackableRefreshThisPageInAFewMinutes:
    "Stiamo ancora verificando le informazioni per vedere se questa spedizione è tracciabile. Aggiorna questa pagina tra pochi minuti.",
  thereIsNoTrackingAvailableForThisShipment: "Non è disponibile il tracciamento per questa spedizione.",
  yourShipmentWasSuccesfullyCreatedAndWereNowValidatingTheInformationToSeeIfItsTrackable:
    "La tua spedizione è stata creata con successo e stiamo verificando le informazioni per vedere se è tracciabile.",
  inAFewMinutesYouCanConsultTheTrackingInfoByClickingTheViewOrEditIconButtonInTheActionsColumnOnTheGrid:
    "Tra pochi minuti potrai consultare le informazioni di tracciamento cliccando sul pulsante Visualizza o Modifica nella colonna azioni della griglia.",
  whatDoYouWantToSend: "Cosa vuoi inviare?",
  sendTrackingViaSMSOrEmail: "Invia tracciamento via SMS or Email",
  sendShipmentTrackingViaSMSOrEmailToTheCustomerOrSomeoneElse:
    "Invia il tracciamento spedizione via SMS o email al cliente o a qualcun altro",
  writeAnEmailOrUseATemplate: "Write an email or use a modello",
  writeASMSOrUseATemplate: "Write a SMS or use a modello",
  writeAPushNotificationOrUseATemplate: "Write a push notifica or use a modello",
  sendJSONFile: "Invia file JSON",
  sendOnlyTheJSONFileToCustomer: "Invia solo il file JSON al cliente",
  trackingNotAvailable: "Tracciamento non disponibile",
  doYouAlsoWantToCancelTheLinkedOrder: "Vuoi anche annullare l'ordine collegato",
  areYouSureYouWantToDeleteThisProduct: "Sei sicuro di voler eliminare questo prodotto",
  createSingleUseBox: "Crea a single use box",
  newSingleUseBox: "Nuovo single-use stoccaggio box",
  createAnotherSingleUseBox: "Crea another single use box",
  searchByContactNameMobilePhoneOrEmailAddress:
    "Cerca per nome contatto, cellulare o indirizzo email",
  searchOrAddAContact: "Cerca or aggiungi a contatto",
  howMany: "Quanti?",
  autoNumberThem: "Auto numero them",
  typePrefix: "Tipo prefix",
  singleUse: "Monouso",
  noWarehouses: "Nessun magazzino",
  byWhom: "Da chi",
  enterTheObjectToSearch: "Inserisci l'oggetto da cercare.",
  orderOrCustomer: "Ordine o Cliente",
  salutation: "Saluto",
  allowance: "Indennità",
  secondReference: "2nd Riferimento",
  editLiftvans: "Modifica Liftvans",
  addLiftvans: "Aggiungi Liftvans",
  areYouSureYouWantToCancelTheTransshipment: "Sei sicuro di voler annullare il trasbordo",
  yesCancelTransshipment: "Sì, annulla trasbordo",
  cancelTransshipment: "Annulla trasbordo",
  sendTheShipmentTrackingViaSMSToTheCustomerOrAnotherPerson:
    "Invia il tracciamento spedizione via SMS al cliente o a un'altra persona",
  sendTrackingViaSMS: "Invia tracciamento via SMS",
  createdOn: "Creato il",
  sendTheShipmentTrackingViaSMSOrEmailToTheCustomerOrSomeoneElse:
    "Invia il tracciamento spedizione via SMS o email al cliente o a qualcun altro",
  sendTrackingViaSMSorEmail: "Invia tracciamento via SMS or Email",
  weightAndMeasurements: "Peso e misure",
  storageBoxAdded: "Stoccaggio box aggiunto",
  storageBoxRemoved: "Stoccaggio box rimosso",
  generateCsv: "Genera CSV",
  revokeInvite: "Revoca Invite",
  yesRevoke: "Sì, revoca",
  revokeInvitation: "Revoca invitation",
  doYouWantToRevokeTheInvitationSentTheUserWillNoLonge:
    "Vuoi revocare l'invito inviato? L'utente non potrà più accettare l'invito",
  youCanAlwaysInviteThemAgain: "Puoi sempre invitarli di nuovo.",
  cancelInvite: "Annulla invite",
  thisInviteWasRevoked: "Questo invito è stato revocato",
  oopsItLooksLikeThisInvitationHasBeenRevoked:
    "Ops, sembra che questo invito sia stato revocato e non sia più disponibile.",
  ifYouThinkThisIsAnErrorPleaseContactTheCompanyResponsibleToBetter:
    "Se pensi che sia un errore, contatta l'azienda responsabile per capire meglio cosa è successo.",
  unlinkInventory: "Unlink Inventario",
  yesUnlink: "Sì, unlink",
  doYouWantToUnlinkTheInventory: "Vuoi scollegare l'inventario",
  inventoryLinked: "Inventario collegato",
  inventoryUnlinked: "Inventario scollegato",
  inventoryLinkedSuccessfully: "Inventario collegato con successo",
  inventoryUnlinkedSuccessfully: "Inventario scollegato con successo",
  relinkInventory: "Relink Inventario",
  yesRelink: "Sì, relink",
  doYouWantToRelink: "Vuoi ricollegare",
  thisActionWillReplaceTheValuesYouveSetWithTheValuesFromYourActualInventory:
    "Questa azione sostituir\u00e0 i valori che hai impostato con i valori del tuo inventario reale.",
  whenYouUnlinkTheInventoryYouCanEditTheTotalValuesThisMeansThatAnyFutureChangesYouMakeToTheInventoryWillNotBeReflectedInTheseMeasurements:
    "Quando scolleghi l'inventario, puoi modificare i valori totali. Ciò significa che qualsiasi modifica futura all'inventario non sarà riflessa in queste misurazioni.",
  inventoriesSummary: "Inventories riepilogo",
  itemIsProGear: "Articolo Pro-Gear",
  apps: "App",
  thisStorageBoxTypeIsCurrentlyInUseAndItsStatusCantBeChanged:
    "Questo tipo di scatola di stoccaggio \u00e8 attualmente in uso e il suo stato non pu\u00f2 essere modificato",
  allowItemPhotosToBeUploadedFromTheDevicesImageGallery:
    "Consenti il caricamento di foto degli articoli dalla galleria immagini del dispositivo",
  thisSettingsEnablesMobileAppUsersToUploadImagesFromTheirDevicesGallery:
    "Questa impostazione consente agli utenti dell'app mobile di caricare immagini dalla galleria del loro dispositivo",
  thisMayCauseADataSecurityRiskAsItCanEncourageTheStoringOfCustomerItemPhotosOnPersonalDevices:
    "Questo può causare un rischio per la sicurezza dei dati, in quanto può incoraggiare la memorizzazione di foto degli articoli dei clienti su dispositivi personali",
  allowUseOfDeviceGallery: "Consenti l'uso della galleria dispositivo",
  galleryUsePermission: "Gallery use permesso",
  enablesUsersToUploadItemImagesFromTheirDevicesGallery:
    "Consente agli utenti di caricare immagini degli articoli dalla galleria del proprio dispositivo",
  note: "Nota",
  thisMayCauseAPersonalInformationSecurityRisksAsItCanEncourageTheStoringOfCustomerItemPhotosOnPersonalDevices:
    "Questo può causare rischi per la sicurezza delle informazioni personali in quanto può incoraggiare la memorizzazione di foto degli articoli dei clienti su dispositivi personali",
  typeHere: "Scrivi qui...",
  hideCC: "Nascondi CC",
  hideBCC: "Nascondi BCC",
  cc: "Cc",
  linkedTo: "Collegato to",
  linkedMaterials: "Collegato Materiali",
  selectAMaterial: "Seleziona a materiale",
  addAnExistingGroup: "Aggiungi an esistente gruppo",
  newBlankGroup: "Nuovo gruppo vuoto",
  selectOneOrMoreGroups: "Seleziona uno o più gruppi",
  addGroup: "Aggiungi gruppo",
  showCC: "Mostra CC",
  showBCC: "Mostra BCC",
  asTheShipmentIdentificationIsUniqueYouCannotChangeItAfterCreation:
    "Poiché l'identificativo della spedizione è unico, non puoi modificarlo dopo la creazione",
  generatePDFReport: "Genera PDF rapporto",
  reportLanguage: "Rapporto language",
  taskReportType: "Attività rapporto tipo",
  addedToContainer: "Aggiunto to Contenitore",
  ssccs: "SSCCs",
  typeAComment: "Tipo a comment",
  addAComment: "Aggiungi a comment",
  commentsHistory: "Commenti cronologia",
  addedOn: "Aggiunto on",
  youCanStartByCreatingASscc: "Puoi iniziare creando un SSCC",
  hereIsYourShipmentInfo: "Ecco le informazioni sulla tua spedizione",
  yourShipmentHasArrivedAt: "La tua spedizione è arrivata a",
  commentSpecialInstruction: "Commento/Istruzione speciale",
  hsCode: "HS Codice",
  typeInAConsignee: "Tipo in a consignee",
  typeInACustomer: "Tipo in a cliente",
  typeInOtherParty: "Inserisci altra parte",
  otherAdditionalParty: "Altra parte/Aggiuntiva",
  byFillingInOneOrMoreOfTheseFieldsYourShipmentWillBeTracked:
    "Compilando uno o più di questi campi, la tua spedizione sarà tracciata.",
  moreContainerType: "Altri tipi di contenitore",
  sendCustomerPortalLink: "Invia link portale clienti",
  typeInToSearch: "Tipo in to cerca",
  flight: "Volo",
  generatedBySystem: "Generato dal sistema",
  mandatory: "Obbligatorio",
  newDocument: "Nuovo documento",
  clearFile: "Cancella file",
  areYouSureYouWantToDelete: "Sei sicuro di voler eliminare",
  deleteDocument: "Elimina documento",
  notAvailableYet: "Non ancora disponibile",
  documentsForThisShipment: "Documenti per questa spedizione",
  shipmentMustBeConfirmed: "La spedizione deve essere confermata",
  clearingFile: "Cancellazione file",
  generatingFile: "Generazione file",
  openingFile: "Apertura file",
  shareCustomerPortalLink: "Condividi link portale clienti",
  sendTheCustomerPortalLinkWithAccessToTheOrderOnline:
    "Invia il link del portale clienti con accesso all'ordine online",
  loading: "Caricamento",
  escalation: "Escalation",
  escalationContactRaised: "Escalation/Contatto raised",
  removeEscalationRequest: "Rimuovi escalation request",
  noKeepIt: "No, mantienilo",
  ohNoSomethingWentWrongPleaseTryAgain: "Oh no! Qualcosa è andato storto. Riprova.",
  escalationRequestHasBeenRemoved: "La richiesta di escalation è stata rimossa",
  removingThisEscalationChangeRequestWillClearAnyPendingRequests:
    "La rimozione di questa richiesta di escalation/modifica cancellerà tutte le richieste in sospeso",
  areYouSureYouWishToProceed: "Sei sicuro di voler procedere",
  yourEscalationRequestHasBeenSentSuccessfully:
    "La tua richiesta di escalation è stata inviata con successo",
  inputComment: "Inserisci commento",
  sendTo: "Invia to",
  selectedPerson: "Selezionato person",
  selectWhoToNotify: "Seleziona chi notificare",
  theFollowingEmail: "La seguente email",
  notify: "Notifica",
  contactUs: "Contatto us",
  packingItems: "Packing articoli",
  closingTheBoxes: "Chiusura delle scatole",
  listeningToBubbleWrapConfessions: "Ascoltando le confessioni del pluriball",
  parkingTheShip: "Parcheggio della nave",
  talkingToTheFish: "Parlando con i pesci",
  cartonContents: "Contenuto cartone",
  ata: "ATA",
  thereIsNoTrackingInformationAvailableForThisShipment:
    "Non sono disponibili informazioni di tracciamento per questa spedizione",
  thisTabWillShowSomeTrackingInformationIfAvailableAfterYouCreateTheShipment:
    "Questa scheda mostrerà alcune informazioni di tracciamento, se disponibili, dopo la creazione della spedizione",
  theresNoTrackingInformationYet: "Non ci sono ancora informazioni di tracciamento",
  livePosition: "Posizione in tempo reale",
  containerCase: "Contenitore / Case",
  containerCaseSize: "Contenitore / Case dimensione",
  sealMarkings: "Marchi mare / Marcature",
  selectALoadType: "Seleziona a load tipo",
  selectAContainerCaseSize: "Seleziona a contenitore or case dimensione",
  typeAContainerCaseSize: "Tipo a contenitore or case dimensione",
  dContainer: "D-Contenitore",
  eContainer: "E-Contenitore",
  ldnContainer: "LDN Contenitore",
  liftvan: "Liftvan",
  liftvans: "Liftvan",
  eur1Iso1Pallet: "Pallet EUR1/ISO1",
  eur2Iso2Pallet: "Pallet EUR2/ISO2",
  itLooksLikeThereNoDataYet: "Sembra che non ci siano ancora dati",
  startByAddingAnOrderToShipment: "Inizio by adding an Ordine to Spedizione",
  thisValueShouldBeAPositiveNumber: "Questo valore deve essere un numero positivo",
  selectTheLoadTypeFirst: "Seleziona prima il tipo di carico",
  hsCommodityCode: "HS / Commodity codice",
  searchForAnAgent: "Cerca for an agent",
  enterAValueGraterThanNetWeight: "Inserisci un valore maggiore del peso netto",
  enterAValueLowerThanGrossWeight: "Inserisci un valore inferiore al peso lordo",
  youShouldAddAtLeastOneContainerToTheShipment:
    "Devi aggiungere almeno un contenitore alla spedizione",
  thisRepresentsTheInitialEstimatedTimeOfArrivalProvidedByTheCarrier:
    "Questo rappresenta l'orario di arrivo stimato iniziale fornito dal vettore",
  thisIsYourShipmentInformation: "Queste sono le informazioni sulla tua spedizione",
  today: "Oggi",
  configure: "Configura",
  last15Days: "Last 15 giorni",
  lastMonth: "Ultimo mese",
  monthToDate: "Month to data",
  lastYear: "Ultimo anno",
  customDate: "Custom data",
  customPeriod: "Periodo personalizzato",
  configureOverview: "Configure panoramica",
  adjustWidgetsAndViewAsYouWish: "Regola i widget e la visualizzazione come desideri",
  purchaseOrdersWidgets: "Purchase Ordini Widgets",
  poStatuses: "Stati OA",
  lastReceivedOrders: "Ultimi ordini ricevuti",
  poConfirmedVSPoReceived: "PO Confirmed vs PO Ricevuto",
  productsOrigin: "Prodotti Origin",
  mostRequestedProducts: "Most Requested Prodotti",
  productsRunningOutOfStock: "Prodotti in esaurimento",
  containersByArrivalDate: "Contenitori per data di arrivo",
  shipmentsPerTime: "Spedizioni Per Time",
  shipmentStatuses: "Spedizione Statuses",
  resetToDefault: "Reimposta to default",
  ofTotal: "Of totale",
  inboundAtPortAtDC: "In arrivo, In porto e Al centro distribuzione",
  containersStatuses: "Contenitori Statuses",
  amountOfSSCC: "Importo of SSCC",
  apply: "Applica",
  searchForAConsultant: "Cerca for a consultant",
  enableQuoteEditing: "Abilita quote editing",
  areYouSureYouWantToEnableEditingForThisQuote:
    "Sei sicuro di voler abilitare la modifica per questo preventivo?",
  trackYourShipmentByFillingInEitherOrBothFields:
    " Traccia la tua spedizione inserendo la polizza di carico (BOL), l'ID prenotazione o entrambi.",
  pleaseFillInAtLeastOnField: "Compila almeno un campo.",
  dimensionalWeight: "Dimensional Peso",
  airportOfOrigin: "Porto di scarico (PoD)",
  airportOfDestination: "Aeroporto destinazione",
  arrivalAOfDestination: "Data of consegna",
  accounts: "Account",
  ofUsers: "of utenti",
  newAccount: "Nuovo account",
  companyAddress: "Azienda indirizzo",
  accountLogo: "Logo account",
  notEnoughData: "Dati insufficienti",
  thereIsInsufficientDataToGenerateGraphicsForTheSelectedPeriod:
    "Non ci sono dati sufficienti per generare grafici per il periodo selezionato.",
  atDC: "Al centro distribuzione",
  incoterms: "Incoterms",
  uldContainers: "ULD Contenitori",
  uldPallets: "Pallet ULD",
  thisActionWillAlsoRemoveAnyFilesYouHaveUploadedInIt:
    "Questa azione rimuoverà anche tutti i file che hai caricato.",
  actualInventory: "Actual inventario",
  checkAllSteps: "Verifica tutti i passaggi",
  milestones: "Traguardi",
  checkYourMoveFileOnline: "Verifica il tuo file trasloco online",
  logedInAs: "Connesso come",
  english: "Inglese",
  yourOrder: "Il tuo ordine",
  theTokenProvidedIsIncorrect: "Il token fornito non è corretto",
  nextStep: "Avanti Step",
  survey: "Sopralluogo",
  typeYourCommentsHere: "Scrivi i tuoi commenti qui",
  agentContactDetails: "Agent Contatto Dettagli",
  distanceToNextPort: "Distance to avanti port",
  kg: "Kg",
  eventsUnavailable: "Eventi non disponibili",
  routeUnavailable: "Itinerario non disponibile",
  trackingInformationUnavailable: "Informazioni di tracciamento non disponibili al momento.",
  nauticalMiles: "Miglia nautiche",
  closeAllSSCCs: "Chiudi tutti SSCCs",
  areYouSureYouWantToCloseAllSSCCs: "Sei sicuro di voler chiudere tutti gli SSCC",
  isItByDefaultAMilestone: "È, per impostazione predefinita, un traguardo?",
  newTask: "Nuovo attività",
  addTask: "Aggiungi attività",
  tasksAndMilestones: "Attività and milestones",
  milestonesFunctionallity: "Funzionalità traguardi",
  aMilestoneIsAKeyDateThatShowsOnTheCustomerPortalMilestonesAreDisplayedAsAMoveFlowInAscendingOrderTasksAreSetByDefaultToBeConsideredAMilestoneOrNot:
    "Un traguardo è una data chiave visualizzata sul portale clienti. I traguardi sono visualizzati come flusso di trasferimento in ordine crescente. Le attività sono impostate per default come traguardo o meno.",
  youCanEditTheseDefaultsInSystemSettings: "Puoi modificare questi predefiniti nelle impostazioni di sistema.",
  youCanAlsoChooseToChangeThemAsNeededForThisFileOnly:
    "Puoi anche scegliere di modificarli secondo necessità solo per questo file.",
  setAsMilestone: "Imposta come traguardo",
  removeAsMilestone: "Rimuovi as milestone",
  youCanChooseFromTheListBelowWhichItemsYouWantToUpload:
    "Puoi scegliere dall'elenco sottostante quali elementi vuoi caricare",
  downloadCSVTemplate: "Scarica CSV modello",
  theFilesWereUploadedAndUpdatedSuccesfully: "I file sono stati caricati e aggiornati con successo",
  anErrorOccurredLoadingUploadCentreTryAgain: "Si è verificato un errore nel caricamento del Centro Caricamenti, riprova",
  weHaveFoundSomeErros: "abbiamo trovato alcuni errori",
  branchCode: "Filiale codice",
  warehouseCode: "Magazzino codice",
  branchCodeNotFound: "Codice filiale non trovato",
  warehouseCodeNotFound: "Codice magazzino non trovato",
  thisBranchIsNotRelatedToInformedWarehouse: "Questa filiale non è associata al magazzino indicato",
  serviceCodeAlreadyExistsPleaseAssignANewCode:
    "Il codice servizio esiste già. Assegna un nuovo codice.",
  materialCodeAlreadyExistsPleaseAssignANewCode:
    "Il codice materiale esiste già. Assegna un nuovo codice.",
  codeAlreadyExistsPleaseAssignANewCode: "Il codice esiste già. Assegna un nuovo codice.",
  codeIsDuplicated: "Il codice è duplicato",
  codeNotFound: "Codice non trovato",
  anErrorOccurredOnTryAgain: "Si è verificato un errore, riprova",
  looseItems: "Loose Articoli",
  thisFieldMustHaveAtLeastOneItem: "Questo campo deve avere almeno un elemento",
  theOrderAlreadyIsInATransshipment: "L'ordine è già in un trasbordo",
  publishTask: "Publish attività",
  unpublishTask: "Unpublish attività",
  noCommentsAdded: "No commenti aggiunto",
  actualAtDepartureDock: "Arrivo a PoD",
  actualArrivalOfDestination: "Data of Consegna",
  noRecord: "Nessun record",
  hwab: "HWAB",
  selectAPeriod: "Seleziona a period",
  storageBoxSingleUseSelected: "Stoccaggio box single-use selezionato",
  youCanAddOnlyOneOrderToAStorageBoxSingleUse:
    "Puoi aggiungere un solo ordine a una scatola di stoccaggio monouso",
  createsANomenclatureBasedOnTheTransshipmentNumberAndTheQuantityOfLiftvans:
    "Crea una nomenclatura basata sul numero di trasbordo e la quantità di liftvan.",
  result: "Risultato",
  results: "Risultati",
  youCanOnlyUseOneStorageBoxSingleUsePerOrder:
    "Puoi utilizzare una sola scatola di stoccaggio monouso per ordine",
  youCanOnlyUseStorageBoxSingleUseForJustOneOrder:
    "Puoi utilizzare una scatola di stoccaggio monouso solo per un ordine.",
  completed: "Completato",
  initialRequest: "Richiesta iniziale",
  noStepsInformed: "Nessun passaggio indicato",
  noTrackingAvailable: "No tracciamento disponibile",
  dateNotInformed: "Data non indicata",
  invoiceTotal: "Fattura Totale",
  receivedDate: "Ricevuto Data",
  error: "Errore",
  waitingUpdate: "Waiting aggiorna",
  shipeeziDefault: "Predefinito di Shipeezi",
  theFileToUploadMustBeInCSVFormat: "Il file da caricare deve essere in formato .csv",
  pleaseFillInTheRequiredFieldsBeforeSaving: "Compila i campi obbligatori prima di salvare.",
  changeAssignee: "Cambia assegnatario",
  selectAPerson: "Seleziona a person",
  theAssignedPersonHasBeenChangedSuccessfully: "La persona assegnata è stata cambiata con successo",
  shipmentsPerDate: "Spedizioni Per Data",
  for: "per",
  chapter: "Capitolo",
  heading: "Voce",
  subHeading: "Sottotitolo",
  statisticalClassification: "Classificazione statistica",
  applicableTo: "Applicabile a",
  inactivatingASectionChapterOrHeadingAllHSCommodityCodesRelatedWillBeInactivatedAsWell:
    "Disattivando una sezione, capitolo o voce, tutti i codici HS / merci correlati saranno disattivati.",
  doYouWantToInactivateAllOfThemAsWell: "Vuoi disattivare anche tutti loro?",
  activatingASectionChapterOrHeadingAllHSCommodityCodesRelatedWillBeActivatedAsWell:
    "Attivando una sezione, capitolo o voce, tutti i codici HS / merci correlati saranno attivati.",
  doYouWantToActivateAllOfThemAsWell: "Vuoi attivare anche tutti gli altri?",
  inactivateCode: "Inactivate codice",
  activateCode: "Activate codice",
  typeInTheFirst6Digits: "Digita le prime 6 cifre",
  typeInTheLast2To4Digits: "Inserisci le ultime 2-4 cifre",
  typeInTheCommodityCodeDescription: "Inserisci la descrizione del codice merce",
  typeInCountryOrRegion: "Tipo in paese or region",
  commodityCode: "Commodity codice",
  doYouReallyWantToDeleteThisCommodityCode: "Vuoi davvero eliminare questo codice merce",
  deleteCommodityCode: "Elimina Commodity Codice",
  clone: "Clona",
  adjustTheDataAsDesiredToCreateTheNewCode: "Modifica i dati come desiderato per creare il nuovo codice.",
  insertAValidCode: "*Insert a valid codice",
  youMustFillInTheFieldsInRed: "Devi compilare i campi in rosso",
  importCSV: "Importa CSV",
  importCSVFile: "Importa file CSV",
  weHaveFoundSomeErrors: "abbiamo trovato alcuni errori",
  regions: "Regioni",
  defineWheterTheStorageBoxTypeCanApperInAllWarehouses:
    "Definisci se il tipo di scatola di stoccaggio può apparire in tutti i magazzini",
  defineIfTheStorageBoxTypeCanBeUsedInTransitInsideTheWarehouseOrBoth:
    "Definisci se il tipo di scatola di stoccaggio può essere usato in transito, all'interno del magazzino o entrambi",
  pleaseSelectAtLeastOne: "Seleziona almeno uno",
  originAirport: "Aeroporto origine",
  finalDestinationAirport: "Aeroporto destinazione finale",
  plannedETD: "ETD pianificato",
  departureFrom: "Partenza da",
  departedFrom: "Partito da",
  theAirplanePositionIsUpdatedFrom15To15Minutes:
    "La posizione dell'aereo viene aggiornata ogni 15 minuti.",
  inviteCustomer: "Invite cliente",
  inviteCustomers: "Invite clienti",
  supplyChain: "Catena di approvvigionamento",
  allSelectedCustomersMustHaveNameEmailAndNotYetBelongToShipeezi:
    "Tutti i clienti selezionati devono avere nome, email e non appartenere ancora a Shipeezi",
  theBranch: "La filiale",
  warehouseNotFound: "Magazzino non trovato",
  isNotRelatedToInformedWarehouse: "non è correlato al magazzino indicato",
  writeACommentInSKU: "Scrivi un commento nello SKU",
  loadMore: "Carica di più",
  commentHistory: "Comment cronologia",
  readMore: "Leggi di più",
  return: "Ritorno",
  toAdd: "to aggiungi",
  shiftReturn: "Maiusc + Invio",
  toBreakLine: "per andare a capo",
  now: "Ora",
  inMoment: "Tra un momento",
  justNow: "Proprio ora",
  in: "in",
  years: "anni",
  yearAgo: "anno fa",
  yearsAgo: "anni fa",
  months: "mesi",
  monthAgo: "mese fa",
  monthsAgo: "mesi fa",
  weeks: "settimane",
  weekAgo: "settimana fa",
  weeksAgo: "settimane fa",
  tomorrow: "Domani",
  yesterday: "Ieri",
  daysAgo: "giorni ago",
  hour: "ora",
  hours: "ore",
  hourAgo: "ora fa",
  hoursAgo: "ore fa",
  minute: "minuto",
  minutes: "minuti",
  minuteAgo: "minuto fa",
  minutesAgo: "minuti fa",
  pleaseTypeLessThanCharacters: "Inserisci meno di {{maxLength}} caratteri",
  emailConfiguration: "Configurazione email",
  selectAll: "Seleziona Tutti",
  "common.clearAll": "Clear Tutti",
  youCantRemoveColumsTheMinimumIs: "Non puoi rimuovere colonne. Il minimo è",
  allTime: "Tutti time",
  lastWeek: "Ultima settimana",
  allTypes: "Tutti types",
  editions: "Edizioni",
  loads: "Carichi",
  unloads: "Scarichi",
  member: "Membro",
  spouse: "Coniuge",
  whoDoesThisItemBelongTo: "A chi appartiene questo articolo?",
  searchOrAddAnItem: "Cerca or aggiungi an articolo",
  writeYourMessageHere: "Scrivi il tuo messaggio qui",
  message: "Messaggio",
  youAreNotifying: "Stai notificando",
  perDestination: "Per destinazione",
  asQuoted: "Come preventivato",
  noItemsHaveBeenRegisteredYet: "Nessun articolo è stato ancora registrato",
  onceItemsAreAddedToInventoryYouWillBeAbleToSeeTheirDetails:
    "Una volta aggiunti gli articoli all'inventario, potrai vederne i dettagli",
  goodMorning: "Buongiorno",
  goodAfternoon: "Buon pomeriggio",
  goodNight: "Buonanotte",
  youDontHaveAnyMovesWithUsYet: "Non hai ancora nessun trasloco con noi.",
  youHaveNotYetRequestedAQuoteFromUs: "Non hai ancora richiesto un preventivo da noi.",
  itSeemsLikeEverythingIsFineAroudHere: "Sembra che sia tutto a posto qui",
  weAreHereToHelpYourMoveToBeAsSmoothlyAsPossible:
    "Siamo qui per aiutarti a rendere il tuo trasloco il più agevole possibile",
  weAreHereToHelpYourQuoteToBeAsSmoothlyAsPossible:
    "Siamo qui per aiutarti a rendere il tuo preventivo il più agevole possibile",
  yourMoves: "I tuoi traslochi",
  yourQuotes: "I tuoi preventivi",
  scheduled: "Programmato",
  needsYourAttention: "Richiede la tua attenzione",
  yourScheduleIsSqueakyCleanNoUpcomingAppointmentsToWorryAbout:
    "Il tuo programma è completamente vuoto! Nessun appuntamento imminente di cui preoccuparsi.",
  ifWeNeedYouForAnythingHereItIsThePlaceToTakeAction:
    "Se abbiamo bisogno di te per qualcosa, questo è il posto giusto per agire.",
  actualMilestone: "Traguardo effettivo",
  trackingAvailable: "Tracciamento disponibile",
  howAboutHavingACoffe: "Che ne dici di un caffè?",
  everythingIsUpToDate: "Tutto è aggiornato",
  youWillSeeAllTheCommunicationBetweenYourselfAndUsHere:
    "Vedrai qui tutta la comunicazione tra te e noi.",
  transshipped: "Trasbordato",
  weDidNotFindAnyMovesRelatedTo: "Non abbiamo trovato nessun trasloco relativo a",
  noResultsFound: "Nessun risultato trovato",
  nothingScheduledForNow: "Niente in programma per ora",
  timeline: "Cronologia",
  home: "Home",
  checkAllMilestones: "Controlla tutte le tappe",
  yourMoveProgress: "Avanzamento del tuo trasloco",
  showMore: "Mostra di più",
  transport: "Trasporto",
  originContacts: "Origin contatti",
  destinationContacts: "Destination contatti",
  checkMyInventories: "Verifica i miei inventari",
  messageSentThankYouForContactingUsWellGetBackToYouSoon:
    "Messaggio inviato! Grazie per averci contattato. Ti risponderemo presto.",
  contactHistory: "Contatto cronologia",
  youContacted: "Hai contattato",
  yourMoveDocumentStatus: "Stato del tuo documento di trasferimento",
  pleaseFillInEitherTheMobileNumberOrPhoneNumberField:
    "Compila il campo del numero di cellulare o del numero di telefono",
  pleaseFillAtLeastOne: "Compila almeno uno",
  allItemsPacked: "Tutti articoli packed",
  allYourItemsHaveBeenPackedAndEverythingIsFine:
    "Tutti i tuoi articoli sono stati imballati e tutto è in ordine.",
  couldNotFoundWithUsernamePassword:
    "Non abbiamo trovato un account con queste credenziali. Per motivi di sicurezza, dopo <strong>{{numberOfAttempts}} tentativi falliti</strong> di accesso, devi attendere <strong>{{lockoutDuration}}</strong> prima di riprovare. <HiddenText> Hai bisogno di <Link>reimpostare la password</Link>? </HiddenText>",
  members: "Membri",
  teams: "Squadre",
  newTeam: "Nuovo squadra",
  equipments: "Attrezzature",
  leaderUser: "Responsabile (Utente)",
  inviteMember: "Invita membro",
  newMember: "Nuovo membro",
  chooseTheTypeOfMember: "Scegli il tipo di membro",
  theMemberCanHaveAccessToSystemOrNot: "Il membro può avere accesso al sistema o meno",
  personalDetails: "Personal Dettagli",
  generalInformationAboutTheMember: "Informazioni generali sul membro",
  howThePersonAccessesAndInteractsWithTheSystem:
    "Come la persona accede e interagisce con il sistema",
  additional: "Aggiuntivo",
  hasAccessToShipeeziSystemWithALoginAndPassword:
    "Ha accesso al sistema Shipeezi, con un login e una password",
  thisMemberBelongsToASubcontractor: "Questo membro appartiene a un subappaltatore",
  subcontractor: "Subappaltatore",
  nickname: "Soprannome",
  startEmploymentDate: "Inizio employment data",
  endEmploymentDate: "End employment data",
  citizenship: "Cittadinanza",
  license: "Licenza",
  jobTitle: "Titolo di lavoro",
  editPhoto: "Modifica foto",
  specificDetailsAboutTheStaffPerson: "Dettagli specifici sulla persona del personale",
  staffInformation: "Personale information",
  typerOfUser: "Tipo of utente",
  notApproved: "Non approvato",
  review: "Revisione",
  expiry: "Scadenza",
  certification: "Certificazione",
  certifications: "Certificazioni",
  newCertification: "Nuovo certification",
  uploadANewFile: "Carica a nuovo file",
  confirmThisCertificationIsValidated: "Conferma che questa certificazione è validata",
  expire: "Scadenza",
  preferNotToSay: "Preferisco non dirlo",
  nonBinary: "Non binario",
  searchForCitizenship: "Cerca cittadinanza",
  serchForCountry: "Cerca paese",
  thisUserIsAlsoALeader: "Questo utente è anche un responsabile",
  pleaseCompleteAllRequiredFields: "Compila tutti i campi obbligatori",
  createMember: "Crea membro",
  associatedWithThisMemberWhenYouAddThem: "associati a questo membro quando li aggiungi",
  associatedWithThisEquipmentWhenTheyAreAdded: "associati a questa attrezzatura quando vengono aggiunti",
  newAbsence: "Nuovo absence",
  absences: "Assenza",
  absence: "Assenza",
  allDayAbsence: "Tutti giorno absence",
  availability: "Disponibilità",
  convertStaffIntoUser: "Converti personale in utente",
  convertUserIntoStaff: "Converti utente in personale",
  configureAsSubcontractor: "Configura come subappaltatore",
  doYouWantToConvertThisUserIntoStaff: "Vuoi convertire questo utente in personale?",
  doYouWantToConvertThisStaffIntoUser: "Vuoi convertire questo personale in un utente?",
  youWillNeedToFillInTheMissigInformation: "Dovrai compilare le informazioni mancanti",
  thisMemberIsA: "Questo membro è un",
  andIsDefinedAsA: "ed è definito come",
  subconttractorFor: "subappaltatore per",
  own: "Proprio",
  convertInto: "Converti in",
  subcontractorFor: "subappaltatore per",
  timesheet: "Foglio presenze",
  timesheets: "Fogli presenze",
  typeOfMember: "Tipo of membro",
  ifTheTeamAlreadyHasALeaderTheMemberWillBeAddedAsStaff:
    "Se la squadra ha già un responsabile, il membro sarà aggiunto come personale",
  emergencyEmail: "Email di emergenza",
  newTime: "Nuovo orario",
  editTeam: "Modifica squadra",
  addMember: "Aggiungi membro",
  addTeam: "Aggiungi squadra",
  nameL: "Nome",
  equipmentPhoto: "Foto attrezzatura",
  maxSize2mb: "Max dimensione 2MB",
  formatsJpgGifPng: "Formati: JPG, GIF, PNG",
  equipmentIcon: "Icona attrezzatura",
  rental: "Noleggio",
  leased: "In leasing",
  noMembersAssociatedToThisEquipment: "Nessun membro associato a questa attrezzatura",
  youCanStartByAddingAMember: "Puoi iniziare aggiungendo un membro",
  newUnavailabilityTime: "Nuovo periodo di indisponibilità",
  allDayUnavailable: "Non disponibile tutto il giorno",
  rolesecurity: "Ruolo (sicurezza)",
  loaction: "Posizione",
  addMembers: "Aggiungi membri",
  youwillbeabletoseealltheinformationabouttheavailabilityofthismemberwhenyouaddthem:
    " Potrai vedere tutte le informazioni sulla disponibilità di questo membro quando lo aggiungi",
  addUnavailability: "  Aggiungi indisponibilità",
  addTeams: "Aggiungi Squadre",
  enableThisFleetAsAStrorageBox: "Abilita questa flotta come contenitore di stoccaggio",
  dates: "Date",
  selectAnOptionToSeeTheForm: "Seleziona un'opzione per vedere il modulo",
  typeInToSearchAMebmer: "Tipo in to cerca a membro",
  pantech: "Pantech",
  nickName: "Soprannome",
  EuroNorm: "EUROnorm",
  driverLicense: "Patente di guida",
  manufacturer: "Produttore",
  branch1: "Filiale 1",
  warehouse1: "Magazzino 1",
  enableThisFleetAsAStorageBox: "Abilita questa flotta come contenitore di stoccaggio",
  writeADescription: "Scrivi una descrizione",
  chooseAvehicleTypeOfEquipmentLikeAForkliftOrATruck:
    "Scegli un tipo di veicolo attrezzatura, come un carrello elevatore o un camion",
  chooseAVehicleTypeOfEquipmentLikeAForkliftOrATruck:
    "Scegli un tipo di veicolo attrezzatura, come un carrello elevatore o un camion",
  createMoreGeneralizedEquipmentWithAFewDetails:
    "Crea un'attrezzatura più generica, con pochi dettagli",
  whoOwnsThisEquipment: "A chi appartiene questa attrezzatura?",
  businessphone: "Business telefono",
  vatcode: "VAT Codice",
  iban: "IBAN",
  bic: "BIC",
  usesameasgeneraladdress: "Usa lo stesso indirizzo generale",
  addaequipment: "Aggiungi a attrezzatura",
  quickcreationequipment: "Quick creation attrezzatura",
  addequipment: "Aggiungi attrezzatura",
  addAMember: "Aggiungi un membro",
  addATeam: "Aggiungi a squadra",
  createnew: "Crea Nuovo",
  businessdetails: "Business dettagli",
  businessinformationaboutthesubcontractor: "Informazioni aziendali sul subappaltatore",
  generalinformationabouttheowner: "Informazioni generali sul proprietario",
  bankingdetails: "Banking dettagli",
  nomembersassociatedtothisequipment: "Nessun membro associato a questa attrezzatura",
  youcanstartbyaddingamember: "Puoi iniziare aggiungendo un membro",
  createnewmember: "Crea nuovo membro",
  addanexistentmember: "Aggiungi an existent membro",
  quickcreation: "Creazione rapida",
  equipment: "Attrezzatura",
  quicklycreateanewequipmentwithessentialdetailsaddmoreinformationanytimeinsettings:
    "Crea rapidamente una nuova attrezzatura con i dettagli essenziali. Aggiungi altre informazioni in qualsiasi momento nelle impostazioni.",
  createmoregeneralizedequipmentwithafewdetails:
    "Crea un'attrezzatura più generica, con pochi dettagli",
  personaldetails: "Personal dettagli",
  platenumber: "Plate Numero",
  subcontractors: "Subappaltatori",
  newSubcontractor: "Nuovo subappaltatore",
  qtyMembers: "Qty membri",
  qtyEquipments: "Qtà attrezzature",
  businessDetails: "Business dettagli",
  businessInformationAboutTheSubcontractor: "Informazioni aziendali sul subappaltatore",
  businessPhone: "Business telefono",
  generalInformationAboutTheOwner: "Informazioni generali sul proprietario",
  addNumberHere: "Aggiungi il numero qui",
  bankingDetails: "Banking dettagli",
  vatCode: "VAT Codice",
  useSameAsGeneralAddress: "Usa lo stesso indirizzo generale",
  contactEmail: "Contatto email",
  noMembersAssociatedToThisSubcontractor: "Nessun membro associato a questo subappaltatore",
  createNewMember: "Crea nuovo membro",
  addAnExistentMember: "Aggiungi an existent membro",
  noMembersToShow: "No membri to mostra",
  noTeamsToShow: "No squadre to mostra",
  typeInToSearchAMember: "Tipo in to cerca a membro",
  addWorkTimeToMember: "Aggiungi work time to membro",
  howDoYouWantToAddAnewTime: "Come vuoi aggiungere un nuovo orario",
  createMockTask: "Crea attività fittizia",
  createAMimicTaskToRecordHoursForThisMember:
    "Crea un'attività fittizia per registrare le ore di questo membro.",
  selectExistentTask: "Seleziona attività esistente",
  selectAnExistingTaskInTHeOrderToLogWorkTime:
    "Seleziona un'attività esistente nell'ordine per registrare il tempo di lavoro",
  addTime: "Aggiungi time",
  backFromBreak: "Ritorno dalla pausa",
  itLooksLikeNoOrderWasSelectYet: "Sembra che nessun ordine sia stato ancora selezionato",
  startSearchingForAnOrderToBeAbleToCreateANewTask:
    "Inizia a cercare un ordine per poter creare una nuova attività",
  searchOrderBy: "Cerca ordine per",
  cancelAvailability: "Annulla availability",
  doYouReallyWantToCancelThisAbsence: "Vuoi davvero annullare questa assenza per",
  yesCancel: "Sì, annulla",
  thisActionCannotBeUndone: "Questa azione non può essere annullata",
  viewTime: "Visualizza Time",
  editTime: "Modifica time",
  noLeaderAvailable: "No leader disponibile",
  noStaffAvailable: "No personale disponibile",
  noTasks: "No attività",
  m3: "m³",
  unavailableUntil: "Non disponibile fino a",
  lv: "LV",
  noEquipmentToShow: "No attrezzatura to mostra",
  addEquipment: "Aggiungi attrezzatura",
  addAnExistentEquipment: "Aggiungi un'attrezzatura esistente",
  addEquipments: "Aggiungi attrezzatura",
  addAEquipment: "Aggiungi a attrezzatura",
  newEquipment: "Nuovo attrezzatura",
  chooseTheTypeOfEquipment: "Scegli il tipo di attrezzatura",
  purchaseDate: "Purchase data",
  soldDate: "Sold data",
  euronorm: "EUROnorm",
  lastInspectionDate: "Last inspection data",
  nextInspectionDate: "Avanti inspection data",
  pleaseSelectAnLaterDate: "Seleziona una data successiva",
  pleaseSelectAnEarlierDate: "Seleziona una data precedente",
  workedTime: "Tempo lavorato",
  breaks: "Pause",
  waitingApproval: "In attesa di approvazione",
  noSubcontractorAvailable: "Nessun subappaltatore disponibile",
  noLeaderAdded: "Nessun responsabile aggiunto",
  noStaffAdded: "No personale aggiunto",
  noEquipmentAdded: "No attrezzatura aggiunto",
  noStorageBoxAdded: "No stoccaggio box aggiunto",
  noOrders: "No ordini aggiunto",
  openOrder: "Apri ordine",
  accessDetails: "Access dettagli",
  membersAndTeams: "Membri & squadre",
  membersAndEquipments: "Membri & equipments",
  extraMembersAndTeams: "Extra Membri & Squadre",
  addTeamToBoard: "Aggiungi squadra to board",
  timeMustBeAfter: "L'ora deve essere dopo",
  addALeader: "Aggiungi un responsabile",
  addStaffs: "Aggiungi staffs",
  addStorageBoxes: "Aggiungi scatole di stoccaggio",
  timeClock: "Orologio",
  removeTaskFromTeam: "Rimuovi attività dal team",
  youCannotPublishATaskWithoutALeader: "Non puoi pubblicare un'attività senza un responsabile",
  thisChangeWillBeProcessedShortly: "Questa modifica sarà elaborata a breve",
  noLanguageAvailable: "No language disponibile",
  noJobTitleAvailable: "No job title disponibile",
  equipmentDetails: "Attrezzatura dettagli",
  removeThisTeamFromTheBoard: "Rimuovi questo team dalla bacheca",
  areYouSureyouWantToCancelTheTask: "Sei sicuro di voler annullare l'attività",
  forOrder: "For ordine",
  createCrew: "Crea crew",
  noTeamsAddedYet: "Nessuna squadra aggiunta ancora",
  allCaughtUpWhatAboutACoffee: "Tutto aggiornato! Che ne dici di un caffè?",
  weAreDoingOneLastSearchWhatAboutACoffee: "Stiamo facendo un'ultima ricerca... Che ne dici di un caffè?",
  viewOptions: "Visualizza options",
  showItemsUnavailable: "Mostra articoli non disponibili",
  showEmptyOrdersTasks: "Mostra empty ordini attività",
  showEmptyTeams: "Mostra empty squadre",
  collapseOrdersTasks: "Collapse ordini attività",
  collapseTeams: "Collapse squadre",
  expandOrdersTasks: "Expand ordini attività",
  expandTeams: "Expand squadre",
  organization: "Organizzazione",
  organiseByTask: "Organizza per attività",
  organiseByOrder: "Organizza per ordine",
  organiseByTeam: "Organizza per squadra",
  youCannotPublishThisTask: "Non puoi pubblicare questa attività",
  typeHereAndPressEnter: "Scrivi qui e premi invio",
  noMemberFound: "Nessun membro trovato",
  noTeamFound: "Nessuna squadra trovata",
  noOrderFound: "Nessun ordine trovato",
  noInformationToShow: "No information to mostra",
  noEquipmentFound: "Nessuna attrezzatura trovata",
  noStorageBoxFound: "No stoccaggio box found",
  pressToSearch: "Press to cerca",
  noOrderAvailable: "No ordine disponibile",
  youHaveToUnpublishFirst: "Devi prima annullare la pubblicazione",
  thisTaskAlreadyStartedByTheLeader: "Questa attività è già stata avviata dal responsabile",
  thisTaskAlreadyFinished: "Questa attività è già terminata",
  thisTaskAlreadyCancelled: "Questa attività è già annullata",
  youHaveToAddATaskBeforeCreateASingleUse: "Devi aggiungere un'attività prima di creare un uso singolo",
  youCannotAddASingleUseForDifferentOrders: "Non puoi aggiungere un uso singolo per ordini diversi",
  createAStorageBoxSingleUse: "Crea a stoccaggio box single use",
  thisTaskCannotBeCancelled: "Questa attività non può essere annullata",
  thereIsNoNeed: "Non c'è bisogno",
  vipMode: "VIP modalità",
  bluebarkMove: "Bluebark sposta",
  satefyMove: "Safety sposta",
  dispatch: "Spedizione",
  youHaveUnpublishedTasks: "Hai attività non pubblicate!",
  thisTeamHasTasksAlreadyPublishedForThisLeader:
    "Questa squadra ha già attività pubblicate per questo responsabile",
  anOperationalMemberUsedJustForRegisterPurposes:
    "Un membro operativo, utilizzato solo a scopi di registrazione",
  boardDisplay: "Visualizzazione bacheca",
  createATemporaryTeamoForTodaysTasks: "Crea a temporary squadra for today's attività",
  registredAddress: "Registered indirizzo",
  noResultMatchYourSearch: "Nessun risultato corrisponde alla ricerca",
  searchAndSelectOrder: "Cerca and seleziona ordine",
  itLooksLikeNoOrderWasSelectedYet: " Sembra che nessun ordine sia stato ancora selezionato",
  startSearchingForAnOrderYoBeAbleToCreateANewTask:
    "Inizia a cercare un ordine per poter creare una nuova attività",
  newTaskFor: "Nuovo attività for",
  timeFor: "Tempo per",
  notifyTheClientAboutTheStartOfTheTask30MinutesInAdvance:
    "Notifica il cliente dell'inizio dell'attività con 30 minuti di anticipo",
  breakFromBreak: "Ritorno dalla pausa",
  albertFloresMarvinMcKinneyJeromeBell: " Albert Flores, Marvin McKinney, Jerome Bell",
  extraMembers: "Extra Membri & Squadre",
  devonLane: "Devon Lane",
  readLess: "Leggi di meno",
  writeACommentIn: "Scrivi un commento in",
  shift: "turno",
  teamRemovalIsBlockedDueToThePresenceOfTasks:
    "La rimozione della squadra è bloccata a causa della presenza di attività.",
  vipTreatment: "Trattamento VIP",
  personalAddress: "Personal indirizzo",
  pleaseSelectAStartDate: "Seleziona una data di inizio",
  morning: "Mattina",
  afternoon: "Pomeriggio",
  evening: "Sera",
  night: "Notte",
  registeredAddress: "Registered indirizzo",
  noTaskYest: "Ancora nessuna attività",
  writeAComment: "Scrivi un commento",
  allowBookingSearch: "Consenti ricerca prenotazioni",
  securityLoginAttempts:
    "Per motivi di sicurezza, dopo <strong>{{numberOfAttempts}} tentativi falliti</strong> di accesso, devi attendere <strong>{{lockoutDuration}}</strong> prima di riprovare.",
  weakPassword: "Password debole",
  avaragePassword: "Password media",
  goodPassword: "Buona password",
  strongPassword: "Password forte",
  passwordMustHave: "La tua password deve avere:",
  UpperAndLowercaseLetters: "Lettere maiuscole e minuscole",
  aSpecialCharacter: "Un carattere speciale (#$&@)",
  atLeastOneNumber: "At least one numero",
  minLength: "12 o più caratteri",
  pleaseEnterANewPassword: "Inserisci una nuova password",
  pleaseConfirmPassword: "Conferma la password",
  autoTerminateSessionExpire:
    "Per motivi di sicurezza, la tua connessione scade dopo 8 ore di attività. Salva il tuo lavoro e disconnettiti. Se preferisci rimanere connesso, tra <strong>15 minuti</strong> ti chiederemo di reinserire le tue credenziali.",
  yourSessionIsAboutToExpire: "La tua sessione sta per scadere",
  terminatedSession: "Questa sessione è stata terminata.",
  reEnterCreds: "Per favore <strong> reinserisci </strong> le tue credenziali.",
  weWillSendALinkToResetYourPasswordToTheEmailAddressAssociatedWithYourAccount:
    "Invieremo un link per reimpostare la password all'indirizzo email associato al tuo account.",
  sortReportBy: "Ordina rapporto per",
  sortedByInventory: "Sorted by inventario",
  sortedAndGroupedByStorageBox: "Sorted and grouped by stoccaggio box",
  loadOrder: "Load ordine",
  areYouSureYouWantToLoadThisOrder: "Sei sicuro di voler caricare questo ordine?",
  changeOrderStatusModalDescription: "Il nuovo stato dell'ordine sarà '{{status}}'.",
  noKeepItAsItIs: "No, mantienilo così com'è",
  noKeepItAsStatus: "No, keep it as {{stato}}",
  yesLoad: "Sì, load",
  yesDeliver: "Sì, consegna",
  noPhotosHaveBeenAddedYet: "Nessuna foto è stata ancora aggiunta",
  transportationType: "Transportation tipo",
  assistance: "Assistenza",
  doorToDoor: "Porta a porta",
  doorToPort: "Porta a porto",
  doorToWarehouse: "Door to Magazzino",
  fotWarehouse: "FOT Magazzino",
  portToDoor: "Porto a porta",
  portToPort: "Porto a porto",
  portToWarehouse: "Port to Magazzino",
  warehouseToDoor: "Magazzino to Door",
  warehouseToPort: "Magazzino to Port",
  warehouseToWarehouse: "Magazzino to Magazzino",
  accountType: "Account tipo",
  accountContact: "Account contatto",
  bookingAgent: "Prenotazione agent",
  personalPropertyProgram: "Programma proprietà personale",
  searchForAnOption: "Cerca for an option",
  memberWillChangeFromSubcontractorToOwnAfterSaving:
    'Il membro passerà da "subappaltatore" a "proprio" dopo il salvataggio',
  memberWillChangeFromOwnToSubcontractorAfterSaving:
    'Il membro passerà da "proprio" a "subappaltatore" dopo il salvataggio',
  memberWillChangeFromUserToStaffAfterSaving:
    'Il membro passerà da "utente" a "personale" dopo il salvataggio',
  memberWillChangeFromStaffToUserAfterSaving:
    'Il membro passerà da "personale" a "utente" dopo il salvataggio',
  noTaskYet: "Ancora nessuna attività",
  workHours: "Ore di lavoro",
  breakHours: "Ore di pausa",
  mostCommonTask: "Most common attività",
  theCompanyDoesNotHaveARegisteredAddress: "L'azienda non ha un indirizzo registrato",
  noPhotoAdded: "Nessuna foto aggiunta",
  exampleAyrton: "Esempio: Ayrton",
  exampleSenna: "Esempio: Senna",
  mailmailcom: "mail@mail.com",
  newUnavailability: "Nuova indisponibilità",
  editTask: "Modifica attività",
  notAllocated: "Non assegnato",
  vipTasksWithAssign: "Attività VIP con assegnazione",
  tasksWithNoAssign: "Attività senza assegnazione",
  normalTasksWithAssign: "Attività normali con assegnazione",
  noCrewAssigned: "No crew assegnato",
  certificationType: "Certification Tipo",
  defineWheterTheStorageBoxTypeRequiresPhotosSealNumberOrBoth:
    "Definisci se il tipo di scatola di stoccaggio richiede foto, numero di sigillo o entrambi",
  checklist: "Checklist",
  sealsNumber: "Seals numero",
  ifNoRuleIsAddedToAnOrderTypeTheRequiredSealNumberWillBeEqualTo1:
    "Se nessuna regola viene aggiunta a un tipo di ordine, il numero di sigillo richiesto sarà uguale a 1",
  checklistRules: "Regole checklist",
  itLooksLikeThereIsNoRulesAdded: "Sembra che non siano state aggiunte regole",
  youCanStartByAddingANewRuleByClickingTheButtonBellow:
    "Puoi iniziare aggiungendo una nuova regola cliccando il pulsante qui sotto",
  addARule: "Aggiungi a rule",
  sealNumbersNeeded: "Numeri sigillo necessari",
  numberOfSealsRequired: "Numero of seals obbligatorio",
  whenOrderTypeIs: "Quando il tipo di ordine è",
  addAnotherRule: "Aggiungi another rule",
  sealsValueMustBeGreaterThan0: "Il valore dei sigilli deve essere maggiore di 0",
  pleaseFillInTheCustomerInformationFirst: "Compila prima le informazioni del cliente.",
  isAllocated: "È assegnato",
  clearSelection: "Cancella selezione",
  typeIn: "Tipo in",
  newPlaceholderTask: "Nuova attività segnaposto",
  taskName: "Attività nome",
  typeHereAComment: "Scrivi qui un commento",
  deleteTask: "Elimina attività",
  yesDelete: "Sì, elimina",
  areYouSureyouWantToDeleteTheTask: "Sei sicuro di voler eliminare l'attività",
  placeholder: "Segnaposto",
  taskDescription: "Attività description",
  describeTaskHere: "Descrivi l'attività qui",
  sealNumbers: "Numeri sigillo",
  sealNumber: "Seal numero",
  photosOfSpecialItemsInside: "Photos of special articoli inside",
  photosOfCaulked: "Foto di calafatato",
  photosOfPackedAndSealed: "Foto di imballato e sigillato",
  itLooksLikeThereIsNoPhotosYet: "Sembra che non ci siano ancora foto",
  youCanStartByAddingANewPhotoOnTheButtonBelow:
    "Puoi iniziare aggiungendo una nuova foto cliccando il pulsante qui sotto",
  addAnotherPhoto: "Aggiungi un'altra foto",
  checklistDone: "Checklist completata",
  noTaskAdded: "No attività aggiunto",
  createAnInternalTaskOrARegisterForADraftTask:
    "Crea un'attività interna o un registro per un'attività « bozza »",
  selectAReport: "Seleziona a rapporto",
  crew_schedule_report: "Crew Programma Rapporto",
  warehouse_schedule_report: "Magazzino Programma Rapporto",
  atLeastOneBranchMustBeSelected: "Deve essere selezionata almeno una filiale",
  reportTypeIsRequired: "Il tipo di rapporto è obbligatorio",
  noReportGenerated: "No rapporto generated",
  reportGeneratedSuccessfully: "rapporto generato con successo",
  reportsGeneratedSuccessfully: "rapporti generated con successo",
  youMustSelectAtLeast1BranchToPrint: "Devi selezionare almeno 1 filiale da stampare",
  leaderName: "Nome responsabile",
  memberName: "Membro Nome",
  equipmentName: "Attrezzatura Nome",
  multiDay: "Multi giorno",
  theTaskIsFinishedSoItCannotBeRemoved: "L'attività è terminata, quindi non può essere rimossa.",
  showSupplierNameOnTheSSCCLabel: "Mostra il nome del fornitore sull'etichetta SSCC",
  dateFor: "Data for",
  isThisAMultiDayTask: "Questa è un'attività multi-giorno?",
  endDateCantBeBeforeStartDate: "La data di fine non può essere precedente alla data di inizio",
  quickSearch: "Quick Cerca",
  newSubscriber: "Nuovo Subscriber",
  searchForAnUserByTyping: "Cerca un utente digitando",
  enterContactType: "Inserisci contatto tipo",
  unselectAll: "Unselect Tutti",
  thereAreNoOrderBelongingToTheSelectedBranchesFor:
    "Non ci sono ordini appartenenti alla/alle filiale/i selezionata/e per",
  thereAreNoOrderBelongingToTheSelectedBranchesForToday:
    "Non ci sono ordini appartenenti alla/alle filiale/i selezionata/e per oggi",
  multi_day: "Multi-Giorno",
  fullDay: "Full giorno",
  between: "tra",
  unavailableOn: "Non disponibile il",
  h: "h",
  m: "m",
  withPhotos: "Con foto",
  withoutPhotos: "Senza foto",
  manageEmailSubscriptions: "Gestisci email subscriptions",
  reportName: "Rapporto nome",
  subscribers: "Abbonati",
  editActivities: "Modifica Activities",
  emailActivities: "Attività email",
  activities: "Attività",
  timestamp: "marca temporale",
  changes: "Modifiche",
  modifiedBy: "Modificato da",
  selectedFilters: "Selezionato Filters",
  deactivate: "Disattiva",
  areYouSureYouWantToDeactivateThisReportEmailSubscription:
    "Sei sicuro di voler disattivare questa sottoscrizione email per i rapporti?",
  youWillNoLongerReceiveEmailsForTheSelectedReport:
    "Non riceverai più email per il rapporto selezionato.",
  deactivateEmailScheduleForThisReport: "Disattivare la pianificazione email per questo rapporto?",
  yesDeactivate: "Sì, Deactivate",
  cancelGoBack: "Annulla & Go Indietro",
  noEmailSubscriptionsRegistered: "Nessuna sottoscrizione email registrata",
  addAdminUser: "Aggiungi admin utente",
  oneTime: "Una volta",
  emailFrequency: "Frequenza email",
  noOfTasks: "N. di attività",
  orderCreated: "Ordine creato",
  totalOrders: "Totale ordini",
  ordersCompleted: "Ordini completato",
  totalTasks: "Totale attività",
  tasksCompleted: "Attività completato",
  exportingCSV: "Esportazione CSV",
  taskBooked: "Attività prenotata",
  hideTasks: "Nascondi attività",
  showTasks: "Mostra attività",
  lifetime: "A vita",
  reportLifetimeData: "Rapporto lifetime data",
  originBranch: "Origin filiale",
  destinationBranch: "Destination filiale",
  teamBranches: "Filiali della squadra",
  receiveOnlyOnce: "Ricevi solo una volta",
  receiveEveryWeek: "Ricevi ogni settimana",
  receiveOnceAMonth: "Ricevi una volta al mese",
  sendOn: "Invia il",
  sendEvery: "Invia ogni...",
  onceYouClickOn: "Una volta cliccato su",
  youWillReceiveThisReportWithAllTheSelectedFiltersAndSetFrequency:
    "riceverai questo rapporto con tutti i filtri selezionati (elencati sopra) e la frequenza impostata.",
  emailDeliveryMayBeDelayedDueFactorsBeyondOurControl:
    "La consegna delle email potrebbe subire ritardi a causa di fattori indipendenti dalla nostra volontà.",
  pleaseWhitelistToAvoidEmailsGoingToSpam:
    "Aggiungi shipeezi.com alla lista bianca per evitare che le email finiscano nello spam.",
  subscriberMustBeRegisteredOnShipeezi: "L'abbonato deve essere registrato su Shipeezi",
  enterADayOfTheMonthBetween1and28: "Inserisci un giorno del mese tra 1 e 28",
  selectReportType: "Seleziona rapporto tipo",
  allReports: "Tutti rapporti",
  selectTaskReportType: "Seleziona attività rapporto tipo",
  generateAndDownload: "Genera & Scarica",
  workOrder: "Work ordine",
  applicableOnlyOnInventoryConditionReport: "Applicabile solo al rapporto condizioni inventario",
  applicableOnlyOnLoadAndTransshipmentReport: "Applicabile solo al rapporto Carico e Trasbordo",
  applicableOnInventoryConditionReportMechanicalAndEletricalChecklistHightValuePropertyDemange:
    "Applicabile al rapporto condizione inventario, checklist meccanica ed elettrica, inventario ad alto rischio/alto valore, rapporto danni alla proprietà, rapporto carico e trasbordo, rapporto checklist (se selezionato)",
  listOfReports: "List of rapporti",
  allAvailableReportsForThisOrderWillBeGeneratedInOneBatchWhichMayTakeLongerThanUsual:
    "Tutti i rapporti disponibili per questo ordine saranno generati in un unico lotto, il che potrebbe richiedere più tempo del solito.",
  pleaseNoteThatGrayedOutReportsAreCurrentlyUnavailbaleForThisOrder:
    "Tieni presente che i rapporti in grigio non sono attualmente disponibili per questo ordine.",
  youCanChooseTheSpecificReportsYouNeedAndEachSelectedReportWillBeGeneratedAsAnIndividualFileWhichMayTakeLongerThanUsual:
    "Puoi scegliere i rapporti specifici di cui hai bisogno e ogni rapporto selezionato sarà generato come file individuale, il che potrebbe richiedere più tempo del solito.",
  security: "Sicurezza",
  enableTwoFactorAuthenticationToLogin: "Abilita two-factor authentication to login",
  enableAnExternalMethodToAuthenticateLogin: "Abilita un metodo esterno per autenticare l'accesso.",
  limitUnsuccessfulLogonAttempts: "Limita i tentativi di accesso non riusciti",
  anThe4thFailedAttemptTheAccountWillBeLockedFor30Seconds:
    "Al 4° tentativo fallito, l'account sarà bloccato per 30 secondi;",
  onThe5thFailedAttemptTheAccountWillBeLockedFor60Seconds:
    "Al 5° tentativo fallito, l'account sarà bloccato per 60 secondi;",
  anyFailedAttemptsAfterThe5thTheAccountWillBeLockedFor120Seconds:
    "Qualsiasi tentativo fallito dopo il 5°, l'account sarà bloccato per 120 secondi.",
  onThe6thFailedAttemptTheAccountWillBeLockedFor120Seconds:
    "Al 6° tentativo fallito, l'account sarà bloccato per 120 secondi;",
  anyFailedAttemptsAfterThe6thTheAccountWillBeLockedFor120Seconds:
    "Qualsiasi tentativo fallito dopo il 6°, l'account sarà bloccato per 120 secondi.",
  autoTerminateSessionsAfter8HoursFromLogin: "Termina automaticamente le sessioni dopo 8 ore dall'accesso",
  thePlatformCalculates8HoursFromTheMostRecentLoginAndTerminatesTheSessionRequiringTheUserToLogInAgain:
    "La piattaforma calcola 8 ore dall'ultimo accesso e termina la sessione, richiedendo all'utente di accedere nuovamente.",
  aWarningAppears15MinutesBeforeTheSessionTeminates:
    "Un avviso appare 15 minuti prima della fine della sessione.",
  minimumPasswordComplexityPolicy: "Politica complessità minima password",
  passwordsMustFulfilMinimumRequirementsForAComplexPasswordWhenCreatingOrResettingAPassword:
    "Le password devono soddisfare i requisiti minimi di complessità durante la creazione o la reimpostazione di una password.",
  prohibitPasswordReuse: "Impedisci riutilizzo password",
  prohibitUsersFromReusingAPreviousPasswordWhenCreatingOrResettingAPassword:
    "Impedisci agli utenti di riutilizzare una password precedente durante la creazione o la reimpostazione di una password.",
  automatedPasswordResetPolicy: "Automated password reimposta policy",
  passwordsMustBeChangedEvery90Days: "Le password devono essere cambiate ogni 90 giorni.",
  operationsApp: "App operazioni",
  inventoryNumberingIsTheStartingInventoryNumberEditable:
    "Numerazione inventario: il numero di inventario iniziale è modificabile?",
  enforceAppLockScreen: "Imponi blocco schermo app",
  usingTheAppForMilitaryPurpose: "Usi l'app per scopi militari?",
  ifAUserIsInactiveForASetPeriodTheAppLocksAutomaticallyForSecurityUsersChooseAPinAtFirstLoginAndCanResetItUsingTheirUsernameAndPasswordThisPreventsUnauthorizedAccessToSensitiveData:
    "Se un utente è inattivo per un periodo prestabilito, l'app si blocca automaticamente per sicurezza. Gli utenti scelgono un PIN al primo accesso e possono reimpostarlo usando nome utente e password. Questo impedisce l'accesso non autorizzato ai dati sensibili.",
  enterInactivityTime: "Inserisci inactivity time",
  fieldRelatedSettings: "Impostazioni relative ai campi",
  loadIntoStorageBoxIsMandatoryInUpliftTask: "Il caricamento nella scatola di stoccaggio è obbligatorio nell'attività di ritiro",
  systemConfigurationIsNotAvailablePleaseContactTheAdministratorForAssistance:
    "La configurazione di sistema non è disponibile. Contatta l'amministratore per assistenza.",
  updatedSuccessfully: "Aggiornato Successfully",
  ifVolumeConfirmationIsMandatoryThenStorageBoxMandatoryOptionMustBeSetToFalse:
    "Se la conferma del volume è obbligatoria, l'opzione scatola di stoccaggio obbligatoria deve essere impostata su falso.",
  volumeConfirmation: "Conferma volume",
  autofillBasedOnTheTask: "Compilazione automatica in base all'attività",
  allowMultipleSelection: "Consenti selezione multipla",
  inventoryFields: "Campi inventario",
  expanseManagement: "Gestione spese",
  others: "Altri",
  cost: "Costo",
  onceDeletedThisEntryWillBePermanentlyRemoved:
    "Una volta eliminata, questa voce sarà rimossa definitivamente.",
  loadingTaskInformation: "Caricamento attività information...",
  taskNotFound: "Attività non trovata",
  couldNotLoadRequestedTaskDetails: "Impossibile caricare i dettagli dell'attività richiesta.",
  recalculateExpenses: "Ricalcola spese",
  isTimeSlotRequiredForMultiDayTask: "È richiesta una fascia oraria per le attività multi-giorno?",
  fixedTimeSlot: "Fascia oraria fissa",
  variableTimeSlot: "Fascia oraria variabile",
  addAnotherDate: "Aggiungi another data",
  itShouldBeAtLeastTwoDates: "Devono essere almeno due date.",
  endTimeMustBeGreaterThanStartTime: "L'orario `A` deve essere successivo all'orario `Da`.",
  generatingYourReportMightTakeLongerThanUsual:
    "La generazione del rapporto potrebbe richiedere più tempo del solito.",
  weWillNotifyYouAsSoonAsItsReadyForDownload:
    "Ti avviseremo non appena sarà pronto per il download. Nel frattempo puoi chiudere questa finestra in sicurezza.",
  categorizeItemsInOperationsApp: "Categorize articoli in operations app",
  checkedFieldsWillBeMarkedAsAMandatory: "I campi selezionati saranno contrassegnati come obbligatori.",
  selectCategories: "Seleziona categories",
  mandatoryFields: "Campi obbligatori",
  mandatoryFieldsByCategory: "Campi obbligatori per categoria",
  noAccess: "Nessun accesso",
  fullAccess: "Accesso completo",
  partialAccess: "Accesso parziale",
  newAccessRuleAdded: "Nuova regola di accesso '{{accessRuleName}}' aggiunta",
  newAccessRuleAddedAndSetAsInactive:
    "Nuova regola di accesso '{{accessRuleName}}' aggiunta e impostata come inattiva",
  accessRuleUpdatedSuccessfully: "Regola di accesso '{{accessRuleName}}' aggiornata con successo",
  accessRuleDeletedSuccessfully: "Regola di accesso '{{accessRuleName}}' eliminata con successo",
  thisIsASystemDefaultAccessRuleAndCannotBeModifiedYouAreWelcomeToCreateANewAccessRuleOrDuplicateAsNeeded:
    "Questa è una regola di accesso predefinita di sistema e non può essere modificata. Puoi creare una nuova regola di accesso o duplicarla secondo necessità.",
  thisAccessRuleIsUtilizedBy: "Questa regola di accesso è utilizzata da {{group}}",
  returnToPermissions: "Return to permessi",
  thisRuleIsCurrentlyUtilizedByGroupsAndCannotBeDeactivated:
    "Questa regola è attualmente utilizzata da gruppi e non può essere disattivata.",
  thisRuleIsCurrentlyUtilizedByGroupsAndCannotBeDeleted:
    "Questa regola è attualmente utilizzata da gruppi e non può essere eliminata.",
  pleaseUseOnlyLettersNumbersAndSpacesSpecialCharactersAreNotAllowed:
    "Utilizza solo lettere, numeri e spazi. I caratteri speciali non sono consentiti.",
  enterNameForThisAccessRule: "Inserisci il nome per questa regola di accesso",
  describeThisAccessRuleInFewWords: "Descrivi questa regola di accesso in poche parole",
  failedToAssignPermissionsToAccessRulePleaseTryAgain:
    "Impossibile assegnare i permessi alla regola di accesso. Riprova.",
  yourPermissionsHaveBeenUpdatedPleaseLogInAgainToApplyTheNewChanges:
    "Un amministratore ha aggiornato i permessi di accesso del tuo gruppo. Per applicare le modifiche, devi disconnetterti e riconnetterti.",
  signBackIn: "Sign indietro-in",
  groupAccessRuleUpdated: "Gruppo access rule aggiornato",
  theAccessRuleNameAlreadyExistsPleaseChooseADifferentName:
    "Il nome della regola di accesso '{{accessRuleName}}' esiste già. Scegli un nome diverso.",
  enterNickname: "Inserisci Nickname",
  nicknameIsForYourOwnReference: "Il soprannome è per tuo riferimento personale",
  dateOfDeparture: "Data of Departure",
  arrivalAtAod: "Arrivo ad AoD",
  enterOrder: "Inserisci ordine",
  enterEmail: "Inserisci Email",
  enterMobileNumber: "Inserisci mobile numero",
  realTimeTrackingUnavailable: "Real-Time Tracciamento Unavailable",
  liveTrackingIsUnavailableOnYourCurrentPlanUnlockThisFeatureByUpgradingYourPlanOrContactingOurSupportTeamForAssistance:
    "Il tracciamento in tempo reale non è disponibile nel tuo piano attuale. Sblocca questa funzionalità aggiornando\nil tuo piano o contattando il nostro team di supporto.",
  typeOfContact: "Tipo of Contatto",
  notifyVia: "Notifica tramite",
  refineByOrder: "Affina per ordine",
  bolBooking: "BoL/Prenotazione",
  pol: "PoL",
  utilization: "Utilizzo",
  destinationAirport: "Aeroporto destinazione",
  display: "Visualizzazione",
  items2: "Articoli",
  exportCSV: "Esporta CSV",
  numberOfRowsPerPage: "Numero of rows per page",
  errorField: "Errore",
  showHideColumn: "Mostra/Nascondi columns",
  typeAndClickEnterToAdd: "Tipo and click inserisci to aggiungi",
  communicationSentSuccessfully: "Communication sent con successo!",
  deSelectAll: "Unselect Tutti",
  selectOrders: "Seleziona ordini",
  addSelectedOption: "Aggiungi Selezionato Ordini",
  volumeAdded: "Volume Aggiunto",
  noLinkNotYet: "Nessun ordine collegato!",
  notifyUsers: "Notify Utenti",
  notificationSentSuccessfully: "Notifica sent con successo!",
  continueBooking: "Continue Prenotazione",
  saveADraft: "Salva a Draft",
  grossWeightKg: "Gross peso (Kg)",
  saveThisSearch: "Salva questa ricerca",
  serial: "Seriale",
  groupManagementCreatedSuccessfully: "Gruppo '{{groupName}}' creato con successo",
  groupManagementUpdatedSuccessfully: "Gruppo '{{groupName}}' aggiornato con successo",
  errorUpdateGroupManagement:
    "Si è verificato un errore durante l'aggiornamento del gruppo '{{groupName}}'. Contatta il supporto Shipeezi per assistenza",
  groupInfoViewOnly:
    "Questo è un gruppo di sistema predefinito che non può essere modificato, ma puoi aggiungere o rimuovere membri",
  groupNameAlreadyExists:
    "Il nome del gruppo '{{groupName}}' esiste già. Scegli un nome diverso.",
  departure: "Partenza",
  arrival: "Arrivo",
  itLooksLikeYoureAboutToLeaveTheBookingProcessIfYouExitNowYourBookingWillNotBeCompletedAndAllTheInformationYouveEnteredSoFarWillBeLost:
    "Sembra che tu stia per abbandonare il processo di prenotazione. Se esci ora, la tua prenotazione non sarà completata e tutte le informazioni inserite finora andranno perse.",
  importantOnceYouLeaveTheresNoGuaranteeThatTheSameAvailabilityAndRatesWillStillApplyIfYouStartTheBookingAgain:
    "Importante: una volta uscito, non c'è garanzia che la stessa disponibilità e le stesse tariffe saranno ancora valide se ricomincerai la prenotazione.",
  areYouSureYouWantToCancel: "Sei sicuro di voler annullare?",
  connectionTimeout: "Timeout connessione: Riprova",
  timeoutDetail:
    "Sta richiedendo più tempo del previsto. Potrebbe essere un problema temporaneo. Aggiorna la pagina o riprova tra poco.",
  retry: "Riprova",
  nothingToDisplayHere: "Niente da visualizzare qui!",
  toGetStartedFillOutTheSearchFormWithYourFreightDetailsAndHitTheSearchButtonToSeeTheBestAvailableOptions:
    'Per iniziare, compila il modulo di ricerca con i dettagli del tuo carico e premi il pulsante "Cerca" per vedere le migliori opzioni disponibili.',
  averagePassword: "Password media",
  tariff: "Tariffa",
  roadFreightPickUp: "Trasporto stradale\n(ritiro)",
  thcO: "THC-O",
  exportService: "Esporta service",
  thcD: "THC-D",
  importService: "Importa service",
  roadFreightDelivery: "Road freight (consegna)",
  carbonOffset: "Compensazione carbonio",
  transportMode: "Transport modalità",
  rateValidity: "Validità tariffa",
  totalCargoWeight: "Totale cargo peso",
  inspectionServices: "Servizi di ispezione",
  customClearance: "Sdoganamento",
  etaAtWarehouse: "ETA at magazzino",
  edd: "EDD",
  etaUnpack: "ETA disimballaggio",
  supplierPortalBannerMessagePaymentPending:
    "In base all'<strong>Incoterm {{incoterm}}</strong>, i costi devono essere pagati dall'acquirente. La prenotazione sarà confermata dopo il pagamento.",
  supplyChainBannerMessagePaymentPending:
    "In base all'<strong>Incoterm {{incoterm}}</strong>, i costi devono essere pagati per confermare la prenotazione.",
  originTerminalHandlingCharge: "Costo movimentazione terminale origine",
  destinationTerminalHandlingCharge: "Costo movimentazione terminale destinazione",
  portOfLoadingPoL: "Port of Caricamento (PoL)",
  portOfDischargePoD: "Porto di scarico (PoD)",
  movementType: "Movement tipo",
  freightCharges: "Costi di trasporto",
  payWithCard: "Paga con carta",
  notRequired: "Non obbligatorio",
  paymentWillBeAvailableToTheBuyerSoon: "Il pagamento sarà presto disponibile per l'acquirente.",
  theBuyerHasPaidSuccessfully: "L'acquirente ha pagato con successo.",
  thisBookingHasExpiredAndBeenCancelled: "Questa prenotazione è scaduta ed è stata annullata.",
  onceConfirmedThisWillBeSentToTheCarrierYouAreNotAbleToMakeAnyAdditionalChanges:
    "Una volta confermato, questo sarà inviato al vettore e non potrai apportare ulteriori modifiche.",
  payBooking: "Pay prenotazione",
  paidOn: "Pagato il",
  noAllocated: "Non assegnato",
  thisFieldDoesntAllowSpecialCharacters: "Questo campo non consente caratteri speciali",
  anErrorOccurredWhileProcessingYourRequestPleaseTryAgainOrContactSupport:
    "Si è verificato un errore durante l'elaborazione della richiesta. Riprova o contatta il supporto.",
  anErrorOccurredWhileProcessingYourRejectionPleaseTryAgainOrContactSupport:
    "Si è verificato un errore durante l'elaborazione del rifiuto. Riprova o contatta il supporto.",
  errorProcessingRejection: "Errore nell'elaborazione del rifiuto",
  errorProcessingRequest: "Errore nell'elaborazione della richiesta",
  areYouAnExistingShipeeziUser: "Sei già un utente Shipeezi?",
  yesGoToLoginPage: "Sì, go to login page",
  noRegisterAsAnAgent: "No, registra come agente",
  selectCompany: "Seleziona Azienda",
  enterName: "Inserisci nome",
  connect: "Connetti",
  anErrorOccurredWhileTryingToConnectTheCompaniesPleaseTryAgainLater:
    "Si è verificato un errore nel tentativo di connettere le aziende. Riprova più tardi.",
  invalidOrExpiredLink: "Non valido or expired link",
  thisInvitationLinkIsInvalidOrHasAlreadyExpiredPleaseContactUsToReceiveANewInvitation:
    "Questo link di invito non è valido o è già scaduto. Contattaci per ricevere un nuovo invito.",
  paymentPending: "Payment in attesa",
  processing: "Elaborazione",
  searchFreight: "Cerca Freight",
  freightBooking: "Freight Prenotazione",
  YourShipeeziID: "Il tuo ID Shipeezi",
  noOfOrders: "N. di ordini",
  carriersFound: "Vettori trovati",
  LowToHigh: "Da basso ad alto",
  HighToLow: "Da alto a basso",
  directRoutes: "Itinerari diretti",
  alternateRoutes: "Itinerari alternativi",
  alternate: "Alternativo",
  direct: "Diretto",
  Shipmentno: "Spedizione No",
  passwordResetSuccesfully: "Password reimposta successful",
  frieghtid: "ID Trasporto",
  passwordRestLinkExpired: "Il link di reimpostazione password è scaduto",
  valid: "Valido",
  customerIsNotAllowedToReceiveNotification: "Al cliente non è consentito ricevere notifiche",
  carbonFootprint: "Impronta di carbonio",
  PlaceOfDestination: "Luogo di destinazione",
  advanceShippingNoticeIsRequired: "L'avviso di spedizione anticipata è obbligatorio",
  weightCantBe0: "Il peso non può essere 0",
  shipTermsIsRequired: "I termini di spedizione sono obbligatori",
  selectOfficeFromTheDropdown: "Seleziona l'ufficio dal menu a tendina",
  marksAndNumber: "Marks and Numero",
  requiredDocument: "Obbligatorio Documenti",
  supportingDocuments: "Supporting Documenti",
  optionalShipmentData: "Opzionale Spedizione Data",
  requiredVolumeConfirmation: "La conferma del volume è obbligatoria",
  shipmentsSettings: "Spedizioni",
  seaTrackingEnabled: "Sea tracciamento abilitato",
  airTrackingEnabled: "Air tracciamento abilitato",
  accessRuleCreatedSuccessfully: "Nuova regola di accesso '{{accessRuleName}}' aggiunta",
  accessRuleDuplicatedSuccessfully: "Nuova regola di accesso '{{accessRuleName}}' aggiunta e impostata come inattiva",
  accessRuleInfoViewOnly:
    "Questa è una regola di accesso predefinita di sistema e non può essere modificata. Puoi creare una nuova regola di accesso o duplicarla secondo necessità.",
  viewGroupAccessRuleTitle: "Questa regola di accesso è utilizzata da {{groupCount}} gruppi",
  accessRuleNameHaveSpecialCharacter:
    "Utilizza solo lettere, numeri e spazi. I caratteri speciali non sono consentiti.",
  updatedPreference: "Data table preference aggiornato!",
  subscriberThatLinkedToOrdersIsNotAllowedToBeDelete:
    "Gli abbonati collegati a ordini non possono essere eliminati!",
  minimumPageSizeGreaterThanTen: "La dimensione minima della pagina è 10",
  subscriberSuccessfullyAdded: "Abbonato aggiunto con successo",
  defaultTeam: "Default Squadra",
  customTeam: "Custom Squadra",
  created: "Creato",
  noMatchingRecordsFound: "Nessun record corrispondente trovato",
  tryAdjustingYourFilters: "Prova a regolare i filtri.",
  noRecordFound: "Nessun record trovato",
  haveTask: "Ha attività",
  dontHaveTask: "Non ci sono attività",
  forContainerOnRow: "For contenitore on row",
  column: "colonna",
  storeName: "Store Nome",
  loadedStatus: "Loaded Stato",
  markAsDefault: "Imposta come predefinito",
  enterTemplateName: "Inserisci nome modello",
  enterSubject: "Inserisci subject",
  enterFromName: "Inserisci nome mittente",
  enterStatus: "Inserisci stato",
  enterAvailableIn: "Inserisci disponibile in",
  enterAutomation: "Inserisci automation",
  enterLastUpdate: "Inserisci ultimo aggiornamento",
  addBusinessIcon: "Aggiungi icona aziendale",
  addBusinessLogo: "Aggiungi Business Logo",
  addIcon: "Aggiungi icona",
  fromName: "Nome mittente",
  formatsJPG_GIF_PNG: "Formati: JPG, GIF, PNG",
  maxSize2MB: "Max dimensione: 2MB",
  attachments: "Allegati",
  pushNotification: "Push Notifica",
  salesApp: "App Vendite",
  linkedAutomation: "Collegato Automation",
  noAutomationsLinked: "Nessuna automazione collegata",
  signup: {
    left: {
      title: "Una piattaforma, ogni movimento",
      subtitle:
        "Inizia la tua prova gratuita e scopri come Shipeezi unifica ogni parte del tuo flusso di lavoro, dalle vendite alle operazioni al magazzinaggio.",
      card1Title: "Semplicità su larga scala",
      card1Desc:
        "Shipeezi riunisce tutti i tuoi processi in un unico posto, aiutando il tuo team a lavorare in modo più intelligente e veloce in tutto il mondo.",
      card2Title: "Più controllo, meno costi",
      card2Desc:
        "Con tutto connesso, risparmierai tempo, ridurrai gli errori e abbasserai i costi — offrendo ai tuoi clienti un'esperienza fluida.",
      trusted: "Scelto dai leader del settore a livello globale",
    },
    right: {
      createAccount: "Crea il tuo account",
      subtitle:
        "Sei a pochi passi dall'avere piena visibilità e controllo sulle tue spedizioni!",
      haveAccount: "Hai un account?",
      signIn: "Accedi",
      thankYou: "Grazie per aver richiesto un account con Shipeezi",
      pendingApproval: "Il nostro team ti contatterà prima di attivare il tuo account",

      // Step 2
      step2Title: "Raccontaci della tua azienda",
      step2Subtitle: "Adatteremo Shipeezi alle esigenze della tua azienda",
      companyName: "Azienda nome",
      companyType: "Azienda tipo",
      selectYourPlatform: "Seleziona la tua piattaforma",

      // Step 3
      step3Title: "Cosa vorresti migliorare con Shipeezi?",
      step3Subtitle: "Scegli le aree della tua azienda che vuoi semplificare e scalare",
      sales: "Sales",
      operations: "Operazioni",
      warehousing: "Magazzinaggio",

      // botões genéricos
      next: "Avanti",
      back: "Indietro",

      // (para etapas futuras, mas já deixo pronto)
      requestAccount: "Richiedi account",
      termsOfUse: "Condizioni d'uso",
      privacyPolicy: "Politica sulla Privacy",
      and: "e",
      byContinuingYouReAgreeingToShipeeziS: "Continuando, accetti le condizioni di Shipeezi",
      getEmailsFromShipeeziAboutProductUpdatesIndustryNewsAndEventsIfYouChangeYourMindYouCanUnsubscribeAtAnyTime:
        "Ricevi email da Shipeezi su aggiornamenti dei prodotti, notizie del settore ed eventi. Se cambi idea, puoi annullare l'iscrizione in qualsiasi momento.",
      captchaExpired: "Captcha scaduto",

      step4Title: "Aiutaci a capire il tuo processo di vendita",
      step4Subtitle: "Le tue risposte ci aiuteranno a configurare Shipeezi per il tuo team",

      // Questions
      videoSurveysQuestion: "Offri video sopralluoghi ai tuoi clienti?",
      salesRepsQuestion: "Quanti rappresentanti commerciali ha la tua azienda?",
      yes: "Sì",
      no: "No",
      range_1_10: "1-10",
      range_11_20: "11-20",
      range_above_30: "Sopra 30",

      // Titles/subtitles por área (Step 4)
      salesStepTitle: "Aiutaci a capire il tuo processo di vendita",
      salesStepSubtitle: "Le tue risposte ci aiuteranno a configurare Shipeezi per il tuo team",

      operationsStepTitle: "Raccontaci delle tue operazioni",
      operationsStepSubtitle: "Configureremo Shipeezi in base a come la tua azienda opera oggi",

      warehousingStepTitle: "Raccontaci del tuo magazzinaggio",
      warehousingStepSubtitle:
        "Ottimizzeremo la configurazione del magazzino e dell'inventario in Shipeezi",

      // Warehousing
      storageQuestion: "Offri servizi di stoccaggio ai tuoi clienti?",
      warehousesCountQuestion: "Quanti magazzini gestisci?",

      // Operations
      shipmentType: "Spedizione Tipo",
      local: "Locale",
      international: "Internazionale",
      interstate: "Interstatale",
      military: "Militare",
      annualShipmentVolume: "Annual spedizione volume",
      v_1_4: "1-4",
      v_5_600: "5-600",
      v_601_10000: "601 - 10.000",
      v_10001_20000: "10.001 - 20.000",
      v_20001_plus: "20.001 +",

      step5Title: "Fantastico! Abbiamo quasi finito!",
      step5Subtitle: "Ci piacerebbe sapere come hai scoperto Shipeezi!",

      thankYouV2Title: "Grazie per la registrazione!",
      thankYouV2Description:
        "Il nostro team ti contatterà a breve per attivare il tuo account. Sarai quindi pronto a scoprire Shipeezi — una piattaforma, ogni movimento.",
      returnToWebsite: "Torna al nostro sito web",

      // Discovery options
      discover: {
        website: "Il nostro sito web",
        email: "Marketing email",
        google: "Google",
        newsletter: "Newsletter",
        aiTools: "Strumenti IA",
        referral: "Referenza",
        whereLabel: "Dove?",
        whoReferredLabel: "Chi ti ha segnalato?",
        other: "Altro",
      },
      wh_1_10: "1-10",
      wh_11_30: "11-30",
      wh_above_30: "Oltre 30",
      trustedBy: "Scelto dai leader del settore in tutto il mondo",
      paymentTerms: "Termini di pagamento",
      privacyAndCompliance: "Informativa privacy e conformità",
      saasAgreement: "Accordo SAAS e SLA",
      termsOfSale: "Termini di vendita",
      termsPrefix: "Continuando, accetti i",
      ownWords: {
        questionLabel: "Quali sono le tue sfide o ostacoli attuali?",
        placeholder: "Scrivi qualcosa...",
        characters: "caratteri",
        helperShort: "Il messaggio deve contenere almeno 50 caratteri.",
        helperLong: "Mantieni il messaggio sotto i 500 caratteri.",
      },
    },
  },
  common: {
    close: "Chiudi",
    save: "Salva",
    saving: "Salvataggio",
  },
  onboarding: {
    pageTitle: "Onboarding",
    left: {
      title: "Benvenuto su Shipeezi!\nUna piattaforma, ogni trasloco",
      subtitle:
        "Sei a pochi rapidi passi dalla configurazione del tuo account. Shipeezi ti aiuterà a semplificare i processi, connettere il tuo team e darti il pieno controllo su ogni movimento. Iniziamo.",
    },
    steps: {
      introduction: "Introduzione",
      companyDetails: "Azienda Dettagli",
      myBilling: "La mia fatturazione",
      members: "Membri",
      uploadCentre: "Carica Centre",
      complete: "Completa",
    },
    uploadCentre: {
      title: "Carica Centre",
      description:
        "Qui puoi caricare i tuoi file (come inventario, personale o elenchi servizi) o iniziare con l'elenco predefinito di Shipeezi. Puoi sempre aggiornarlo in seguito.",
      uploadOwnList: "Carica my own list",
      uploadOwnListDescription: "Porta i tuoi dati per personalizzare Shipeezi fin dall'inizio.",
      useDefaultList: "Usa l'elenco predefinito di Shipeezi (ISO17451-1:2016)",
      useDefaultListDescription:
        "Inizia rapidamente con il nostro elenco preconfigurato, basato sullo standard globale ISO17451-1:2016. Puoi aggiornarlo o ampliarlo in qualsiasi momento.",
      downloadTemplate: "Scarica il nostro modello CSV qui",
      complete: "Completa",
    },
    complete: {
      title: "Benvenuto su Shipeezi — dove visibilità, controllo e semplicità si uniscono.",
      subtitle: "",
      button: "Inizia",
      leftTitle: "Configurazione completata!",
      leftSubtitle: "Sei pronto a gestire ogni trasloco in un'unica piattaforma.",
    },
    buttons: {
      goBackToLogin: "Go indietro to login",
      skip: "Salta per ora",
      downloadCsvTemplate: "Scarica il nostro modello CSV qui",
      next: "Avanti",
      back: "Indietro",
    },
    introduction: {
      companyDetails:
        "Aggiungi le informazioni della tua azienda, l'indirizzo aziendale, il contatto principale e i dettagli email, così possiamo configurare il tuo account correttamente.",
      members:
        "Invita i membri del tuo team e assegna i permessi giusti per dare loro l'accesso dove ne hanno bisogno.",
      uploadCentre:
        "Carica le tue informazioni e i tuoi dati iniziali affinché Shipeezi possa connettere tutto senza problemi.",
    },
    members: {
      title: "Membri",
      description:     "Invita le persone che useranno Shipeezi con te. Assegna ruolo e filiale per l'accesso corretto fin dall'inizio. Puoi sempre aggiornare o aggiungere membri in seguito.",
      registeredMembers: "Membri registrati",
      firstName: "Nome",
      lastName: "Cognome",
      email: "Email",
      memberCode: "Codice membro",
      branch: "Filiale",
      mobile: "Cellulare",
      accessGroup: "Gruppo di accesso",
      memberType: "Tipo membro",
      additionalMembers: "Membri aggiuntivi",
      uploadMembers: "Carica membri",
      addMembers: "Aggiungi membri",
      name: "Nome",
      group: "Gruppo",
      type: "Tipo",
      noAdditionalMembers: "Nessun membro aggiuntivo",
      downloadTemplate: "Scarica modello",
      uploadCSV: "Carica CSV",
      addMember: "Aggiungi membro",
      userCode: "Codice utente",
    },
    billing: {
      useSameAdmin: 'Use the same “administrator user" details',
      contactName: "Billing Contatto Nome",
      email: "Email",
      phone: "Numero di telefono",
      address: "Indirizzo",
      paymentMethod: "Metodo di pagamento",
      noPaymentMethod: "Nessun metodo di pagamento registrato",
      addPaymentMethod: "Aggiungi a payment method",
      creditCard: "Carta di credito",
      nameOnCard: "Nome sulla carta",
    },
  },
  notShared: "Non condiviso",
  partiallyShared: "Parzialmente condiviso",
  fullyShared: "Completamente condiviso",
  scac: "SCAC",
  inventorySummary: "Inventario riepilogo",
  networkDetails: "Dettagli",
  networkRoles: "Ruoli",
  networkWeightAndMeasurements: "Peso e misure",
  networkPickup: "PICKUP",
  networkDelivery: "Consegna",
  networkGeneralComments: "Commenti generali",
  networkActualInventory: "INVENTARIO EFFETTIVO",
  networkQuotedInventory: "INVENTARIO PREVENTIVATO",
  networkPhotosAndVideos: "FOTO E VIDEO",
  networkDocuments: "Documenti",
  networkSettingsBannerMessage:
    "Scegli i campi dati dalla sezione sottostante che desideri vengano visualizzati all'agente della rete all'accettazione dell'attività.",
  failedToSaveNetworkSettings: "Impossibile salvare le impostazioni di rete. Riprova.",
  assignToAnAgent: "Assegna to an agent?",
  selectAnAgent: "Seleziona un agente",
  additionalInstructions: "Additional istruzioni",
  enterAdditionalInstructions: "Inserisci additional istruzioni",
  agentName: "Agent nome",
  started: "Iniziato",
  taskAddedSuccessfully: "Attività aggiunto con successo!",
  thisInstructionWillBeVisibleInTheEmailAndTaskView:
    "Questa istruzione sarà visibile nella vista Email e Attività.",
  moreJobTypes: "Più tipi di lavoro",
  moreTaskTypes: "Più tipi di attività",
  moreTriggers: "Più trigger",
  selectTaskTypes: "Seleziona attività types",
  selectOrderTypes: "Seleziona ordine types",
  selectTriggers: "Seleziona triggers",
  typeCode: "Tipo codice",
  newChecklist: "Nuovo checklist",
  enterQuestionHere: "Inserisci la domanda qui",
  responseType: "Response tipo",
  addLogic: "Aggiungi logic",
  shortDescription: "Breve descrizione",
  enterDescriptionHere: "Inserisci la descrizione qui",
  singleChoiceQuestion: "Domanda a scelta singola",
  multipleChoiceQuestion: "Domanda a scelta multipla",
  inputText: "Inserisci testo",
  inputNumber: "Input numero",
  selectDate: "Seleziona data",
  addSignature: "Aggiungi signature",
  checklistItem: "Checklist articolo",
  enterOptions: "Inserisci options",
  option: "Opzione",
  addQuestion: "Aggiungi question",
  defaultState: "Stato predefinito",
  taskTypes: "Attività Types",
  jobTypes: "Tipi di lavoro",
  ifAnswer: "Se risposta",
  is: "è",
  isNot: "non è",
  then: "poi",
  enterText: "Inserisci text",
  enterNumber: "Inserisci numero",
  selectOption: "Seleziona option",
  isLesserThan: "è minore di",
  isGreaterThan: "è maggiore di",
  selected: "selezionato",
  notSelected: "non selezionato",
  if: "If",
  requireEvidence: "Richiedi prova",
  askQuestion: "Fai una domanda",
  chooseTheEvidenceThatllBeRequiredWhenThisAnswerIsSelected:
    "Scegli le prove che saranno richieste quando questa risposta viene selezionata.",
  youShouldAddAtLeastOneOption: "Devi aggiungere almeno un'opzione.",
  youShouldAddAtLeastTwoOptions: "Devi aggiungere almeno due opzioni.",
  allOptionsShouldHaveAName: "Tutte le opzioni devono avere un nome.",
  methodOfPreparation: "Metodo di preparazione",
  itemCharacteristics: "Articolo Characteristics",
  highRiskHighValueChecklist: "Checklist alto rischio/alto valore",
  proGearChecklist: "Checklist Pro-Gear",
  isHighRisk: "È alto rischio",
  notHighRisk: "Non alto rischio",
  isProGear: "È Pro-Gear",
  notProGear: "Non Pro-Gear",
  meChecklistNotDone: "Checklist M&E non completata",
  unsavedItem: "Unsaved articolo, salva to applica tutti filters correctly",
  youHaveUnsavedChanges: "Hai modifiche non salvate.",
  doYouWantToSaveBeforeLeaving: "Vuoi salvare prima di uscire",
  timezoneIssue: "Problema fuso orario",
  allQuestionsMustHaveATitleAndAllLogicsFieldsMustBeFilled:
    "Tutte le domande devono avere un titolo e tutti i campi logici devono essere compilati.",
  areYouSureYouWantToDeleteThisLogic: "Sei sicuro di voler eliminare questa logica",
  deleteLogic: "Elimina Logic",
  atLeastOneOptionIsRequired: "È richiesta almeno un'opzione",
  atLeastTwoOptionsAreRequired: "Sono richieste almeno due opzioni",
  templateNameAlreadyExists: "Il nome del modello esiste già!",
  userUploaded: "Utente uploads",
  systemGenerated: "Caricamenti di sistema",
  uploadFiles: "Carica file",
  orDragAndDropHere: "o trascina e rilascia i file qui",
  maxFileSizeLimit: "Limite dimensione file massimo 25 MB. Formati accettati:",
  quickOrder: "Quick Ordine",
  createQuickOrder: "Crea Quick Ordine",
  automaticSequenceUnavailableEnterReferenceManually:
    "La sequenza automatica non è disponibile. Inserire il riferimento manualmente.",
  enableQuickOrder: "Abilita ordine rapido",
  showOrderReportInManagement: "Mostra report ordini in Management",
  reportsAvailableForSharingViaOpsApp:
    "Report disponibili per la condivisione tramite Ops App",
  noReportsAvailableForSharingViaOpsApp:
    "Nessun report disponibile per la condivisione tramite Ops App",
  orderReport: "Report ordini",
  orderAlreadyExists: "L'ordine esiste già",
  searchOrAddCustomer: "Cerca or aggiungi cliente",
  aCustomerWithSameIdAlreadyExists: "Un cliente con lo stesso ID è già stato aggiunto",
  addANoteAsEvidence: "Aggiungi a note as evidence",
  addAPhotoAsEvidence: "Aggiungi a foto as evidence",
  displayInDispatchModule: "Visualizza nel modulo spedizione",
  leavingTheWarehouse: "In uscita dal magazzino",
  leads: "Prospect",
  estimates: "Stime",
  proposal: "Proposta",
  invoicing: "Fatturazione",
  creditNotes: "Note di credito",
  expenses: "Spese",
  claims: "Reclami",
  storageBoxUnit: "Stoccaggio Box & Unit",
  storageAccount: "Stoccaggio Account",
  finance: "Finanza",
  packageType: "Package tipo",
  methodType: "Method tipo",
  itemInstruction: "Articolo instruction",
  communicationCentre: "Centro comunicazioni",
  leadSoure: "Fonte prospect",
  help: "Aiuto",
  askDumont: "Chiedi a Dumont",
  dumontHelpDocumentation: "Aiuto e documentazione",
  dumontSendFeedback: "Invia Feedback",
  dumontContactSupport: "Contatto Support",
  dumontLearnHowToUseDumont: "Impara a usare Dumont",
  dumontHelpUsImproveDumont: "Aiutaci a migliorare Dumont",
  dumontGetHelpFromTeam: "Ricevi aiuto dal nostro team",
  dumontQuickActions: "Azioni rapide",
  dumontContactOurSupport: "Contatto our Support",
  dumontGetHelpWithIssues: "Ottieni aiuto per problemi e domande",
  dumontSendUsYourFeedback: "Inviaci il tuo feedback",
  dumontShareThoughtsAndSuggestions: "Condividi i tuoi pensieri e suggerimenti",
  dumontCommonQuestions: "Domande frequenti",
  dumontHowToCreateCustomAgent: "Come creo un agente personalizzato?",
  dumontHowToCreateCustomAgentAnswer: "Puoi creare agenti personalizzati dalla scheda Agenti in Dumont.",
  dumontWhatCanDumontHelp: "In cosa può aiutare Dumont?",
  dumontWhatCanDumontHelpAnswer:
    "Dumont può aiutare con preventivi, operazioni, magazzinaggio e domande logistiche generali.",
  dumontHowToAccessChatHistory: "Come accedo alla cronologia delle chat?",
  dumontHowToAccessChatHistoryAnswer:
    "Apri la scheda Cronologia nella barra laterale per vedere e cercare le conversazioni passate.",
  dumontCanCustomizeAgentCapabilities: "Posso personalizzare le capacità dell'agente?",
  dumontResources: "Risorse",
  dumontKnowledgeBase: "Base di conoscenze",
  dumontCompleteGuidesAndTutorials: "Guide e tutorial completi",
  dumontSelectAnOption: "Seleziona un'opzione",
  dumontFeedbackHelpsImprove: "Il tuo feedback ci aiuta a migliorare Dumont",
  dumontIssueType: "Issue tipo",
  dumontSubject: "Oggetto",
  dumontBriefDescriptionOfIssue: "Breve descrizione del problema",
  dumontMessage: "Messaggio",
  dumontPleaseDescribeIssueDetail: "Descrivi il tuo problema in dettaglio",
  dumontIncludeErrorMessages: "Includi eventuali messaggi di errore se applicabile",
  dumontGotIt: "Capito",
  dumontCancel: "Annulla",
  dumontSendFeedbackButton: "Invia feedback",
  dumontSendMessage: "Invia message",
  dumontSupportRequestSentSuccessfully: "La tua richiesta di supporto è stata inviata con successo",
  dumontFeedbackSentSuccessfully: "Il tuo feedback è stato inviato con successo",
  dumontSearchPlaceholder: "Cerca...",
  dumontNavigation: "Navigazione",
  dumontNewChat: "Nuovo chat",
  dumontChats: "Chat",
  dumontNoChatsFound: "Nessuna chat trovata",
  dumontNoRecentChats: "Nessuna chat recente",
  dumontAgents: "Agenti",
  dumontNoAgentsFound: "Nessun agente trovato",
  dumontReturnToShipeezi: "Torna a Shipeezi",
  dumontHelp: "Aiuto",
  dumontWelcomeMessage:
    "Ciao, {{userName}}! Sono Dumont, il tuo assistente IA. Come posso aiutarti oggi?",
  dumontWelcomeMessageBusiness:
    "Ciao, {{userName}}! Sono Dumont, l'assistente commerciale. Sono specializzato in vendite e preventivi. Come posso assisterti?",
  dumontWelcomeMessageOperations:
    "Ciao, {{userName}}! Sono Dumont, l'assistente operazioni. Posso aiutarti con spedizioni, consegne e operazioni. Di cosa hai bisogno?",
  dumontWelcomeMessageWarehousing:
    "Ciao, {{userName}}! Sono Dumont, l'assistente magazzino. Posso aiutarti con inventario e operazioni di magazzino. Come posso aiutarti?",
  dumontDispatchQuickActions: "Azioni rapide",
  dumontHistory: "Cronologia",
  dumontConversationHistory: "Conversation cronologia",
  dumontNoConversationsFound: "Nessuna conversazione trovata",
  dumontNoConversationHistory: "Ancora nessuna cronologia conversazione",
  dumontTryDifferentSearchTerm: "Try a different cerca term",
  dumontStartNewConversation: "Inizia una nuova conversazione per vederla qui",
  dumontFileTooLarge: "Il file è troppo grande. La dimensione massima è 10MB.",
  dumontUnsupportedFileType: "Tipo di file non supportato. Seleziona file TXT, PDF o DOC/DOCX.",
  dumontDocumentProcessing:
    "L'elaborazione PDF/DOC sarà disponibile a breve. Per ora utilizza file TXT.",
  dumontFileProcessingError: "Errore nell'elaborazione del file. Riprova.",
  dumontAskDumont: "Chiedi a Dumont",
  dumontAskDumontAnything: "Chiedi qualsiasi cosa a Dumont",
  dumontUpload: "Carica",
  dumontUsesAI: "Dumont usa l'IA. Le risposte potrebbero non essere sempre accurate.",
  dumontCopyConversation: "Copia conversation",
  dumontExportChat: "Esporta chat",
  dumontClearConversation: "Cancella conversazione",
  dumontLoadingAgents: "Caricamento agents...",
  dumontAgentsTitle: "Agenti",
  dumontCreateAgent: "Crea agente",
  dumontSearchAgents: "Cerca agents",
  dumontNoAgentsAvailable: "No agents disponibile",
  dumontAgentsAvailableSoon: "Gli agenti saranno disponibili a breve",
  featureLocked: "Funzionalità bloccata",
  accountNotHaveAccess: "Il tuo account non ha accesso a questa funzionalità al momento.",
  reachSupportTeam: "Contatta il nostro team di supporto",
  forDetails: " for dettagli.",
  titleFeatureRequestSupport: "Richiedi accesso a questa funzionalità",
  sendRequestSupport: "Invia request to Support",
  itLooksLikeYouDontHaveAcessThisFeatureYet:
    "Sembra che tu non abbia ancora accesso a questa funzionalità. Se desideri utilizzarla, invia una richiesta al nostro team di supporto.",
  feature: "Funzionalità",
  pleaseDescribeYouIntendUseFeature: "Descrivi come intendi utilizzare questa funzionalità",
  yourMessageShouldLeast50Characters: "Il tuo messaggio deve essere di almeno 50 caratteri.",
  minCharacters: "Il tuo messaggio deve essere di almeno {{count}} caratteri.",
  maxCharacters: "Il tuo messaggio non deve superare {{count}} caratteri",
  yourRequestHasBeenSentOurSupportTeam: "La tua richiesta è stata inviata al nostro team di supporto",
  TermsConditions: "Termini e condizioni",
  Iso14451: "ISO14451-1:2016",
  Iso17451: "ISO17451 - 1:2016",
  dumontConversationHistory: "Conversation Cronologia",
  dumontNoConversationHistory: "No conversation cronologia",
  dumontStartNewConversation: "Inizia una nuova conversazione per vederla qui",
  dumontAgentsTitle: "Agenti Dumont",
  dumontCreateAgent: "Crea agente",
  dumontSearchAgents: "Cerca agents...",
  dumontComingSoon: "Prossimamente...",
  dumontBusinessAssistant: "Assistente commerciale",
  dumontBusinessAssistantDesc: "Specializzato in vendite e preventivi",
  dumontOperationsAssistant: "Assistente operazioni",
  dumontOperationsAssistantDesc: "Tutti i tuoi esperti operativi",
  dumontWarehousingAssistant: "Assistente magazzino",
  dumontWarehousingAssistantDesc: "Inventario and magazzino operations expert",
  dumontAskDumont: "Chiedi a Dumont...",
  dumontUsesAI: "Dumont usa l'intelligenza artificiale. Controlla le risposte.",
  dumontLearnHowToUseDumont: "Impara a usare Dumont in modo efficace",
  dumontContactOurSupport: "Contatto our support",
  dumontGetHelpWithIssues: "Ottieni aiuto per qualsiasi problema o domanda",
  dumontHowToCreateCustomAgentAnswer:
    'Per creare un agente personalizzato, vai alla sezione Agenti e clicca sul pulsante "Crea Nuovo Agente". Puoi quindi configurare le capacità e le impostazioni dell\'agente in base alle tue esigenze.',
  dumontWhatCanDumontHelp: "In cosa può aiutarmi Dumont?",
  dumontWhatCanDumontHelpAnswer:
    "Dumont è il tuo assistente IA specializzato in logistica e traslochi. Posso aiutarti con la pianificazione delle spedizioni, la gestione degli ordini, l'ottimizzazione dei percorsi e rispondere alle domande sulle tue operazioni.",
  dumontHowToAccessChatHistoryAnswer:
    "Clicca sull'icona Cronologia nella barra laterale per visualizzare tutte le conversazioni passate con Dumont. Puoi cercare nella cronologia e riprendere qualsiasi conversazione precedente.",
  dumontCanCustomizeAgentCapabilitiesAnswer:
    "Sì! Ogni agente può essere personalizzato per adattarsi al tuo flusso di lavoro specifico. Puoi regolare le loro capacità, impostare parametri specifici e configurare le fonti dati a cui hanno accesso.",
  dumontFeedbackType: "Feedback Tipo",
  dumontYourFeedback: "Il tuo feedback",
  dumontTellUsWhatYouThink: "Dicci cosa ne pensi...",
  dumontSendFeedbackButton: "Invia Feedback",
  dumontIssueType: "Issue Tipo",
  dumontBriefDescriptionOfIssue: "Breve descrizione del tuo problema",
  dumontPleaseDescribeIssueDetail: "Descrivi il tuo problema in dettaglio...",
  dumontIncludeErrorMessages: "Includi eventuali messaggi di errore o passaggi per riprodurre il problema",
  dumontSendMessage: "Invia Message",
  dumontSupportRequestSentSuccessfully:
    "La tua richiesta di supporto è stata inviata con successo. Il nostro team risponderà entro 24 ore.",
  dumontFeedbackSentSuccessfully:
    "Il tuo feedback è stato inviato con successo. Apprezziamo il tuo contributo!",
  dumontPleaseSelectTextFile: "Seleziona un file di testo (.txt)",
  dumontDocumentAttached: "Documento attached",
  dumontRemoveDocument: "Rimuovi documento",
  dumontDefaultResponse:
    "Grazie per averci contattato! Sto analizzando la tua richiesta e fornirò la soluzione migliore.",
  dumontSales: "Sales",
  dumontOperations: "Operazioni",
  dumontLogistics: "Logistica",
  thisLinkIsNotValidPleaseCheckIfYouHaveAccessedTheCorrectLink:
    "Questo link non è valido. Verifica di aver aperto il link corretto.",
  youCanSafelyCloseThisWindowNowIfYouNeedAnyFurtherAssistanceFeelFreeToReachOutHaveAGreatDay:
    "Ora puoi chiudere questa finestra in sicurezza. Se hai bisogno di ulteriore assistenza, non esitare a contattarci. Buona giornata!",
  anErrorOccurredWhileProcessingYourRequestPleaseTryAgainOrContactSupport:
    "Si è verificato un errore durante l'elaborazione della richiesta. Riprova o contatta il supporto.",
  anErrorOccurredWhileProcessingYourRejectionPleaseTryAgainOrContactSupport:
    "Si è verificato un errore durante l'elaborazione del rifiuto. Riprova o contatta il supporto.",
  anErrorOccurredWhileTryingToConnectTheCompaniesPleaseTryAgainLater:
    "Si è verificato un errore nel tentativo di connettere le aziende. Riprova più tardi.",
  thisInvitationLinkIsInvalidOrHasAlreadyExpiredPleaseContactUsToReceiveANewInvitation:
    "Questo link di invito non è valido o è già scaduto. Contattaci per ricevere un nuovo invito.",
  networkSettingsBannerMessage:
    "Scegli i campi dati dalla sezione sottostante che desideri vengano visualizzati all'agente della rete all'accettazione dell'attività.",
  thisInstructionWillBeVisibleInTheEmailAndTaskView:
    "Questa istruzione sarà visibile nella vista Email e Attività.",
  chooseTheEvidenceThatllBeRequiredWhenThisAnswerIsSelected:
    "Scegli le prove che saranno richieste quando questa risposta viene selezionata.",
  allQuestionsMustHaveATitleAndAllLogicsFieldsMustBeFilled:
    "Tutte le domande devono avere un titolo e tutti i campi logici devono essere compilati.",
  // Dumont Dispatch Prompts
  dumontDispatchShowTodayOrders: "Mostra today's dispatch ordini",
  dumontDispatchShowTodayOrdersDesc: "Ottieni un riepilogo di tutti gli ordini programmati per la spedizione oggi",
  dumontDispatchFindCustomer: "Trova ordini per nome cliente",
  dumontDispatchFindCustomerDesc: "Cerca for specific ordini using cliente information",
  dumontDispatchTrackStatus: "Traccia stato ordine",
  dumontDispatchTrackStatusDesc: "Verifica lo stato corrente degli ordini nel sistema",
  dumontDispatchOptimizeRoutes: "Optimize consegna routes",
  dumontDispatchOptimizeRoutesDesc: "Ottieni suggerimenti per gli itinerari di consegna più efficienti",
  dumontDispatchQuickActions: "Azioni rapide per Spedizione",
  dumontWelcomeMessage:
    "Ciao {{userName}}, sono Dumont, il tuo assistente IA specializzato in logistica e traslochi. Progettato per semplificare flussi di lavoro complessi, imparo continuamente per fornire un supporto più rapido, intelligente e preciso per la tua azienda.",
  dumontWelcomeMessageBusiness:
    "Ciao {{userName}}, sono Dumont, l'assistente commerciale! 💼 Sono specializzato in vendite e preventivi. Posso aiutarti a creare preventivi di trasporto accurati, gestire le relazioni con i clienti e chiudere affari più velocemente. Come posso assisterti oggi?",
  dumontWelcomeMessageOperations:
    "Ciao {{userName}}, sono Dumont, l'assistente operazioni! 📊 Sono il tuo esperto operativo. Posso aiutarti a tracciare le spedizioni, monitorare le consegne, gestire i lavori e garantire operazioni logistiche fluide. Di cosa hai bisogno?",
  dumontWelcomeMessageWarehousing:
    "Ciao {{userName}}, sono Dumont, l'assistente magazzino! 🏭 Sono specializzato in inventario e operazioni di magazzino. Posso aiutarti a gestire i livelli di stock, tracciare l'inventario, coordinare lo stoccaggio e ottimizzare l'efficienza del magazzino. Come posso aiutarti?",
  // Dumont Fullscreen Sidebar
  dumontSearchPlaceholder: "Cerca chats, agents, cronologia...",
  dumontNewChat: "Nuovo Chat",
  dumontWhatCanIHelpYouWith: "In cosa posso aiutarti?",
  dumontOptimizeLogisticsOperations: "Ottimizza le mie operazioni logistiche",
  dumontOptimizeLogisticsOperationsDesc:
    "Ottieni raccomandazioni personalizzate per migliorare l'efficienza e ridurre i costi",
  dumontTrackShipmentStatus: "Track spedizione stato",
  dumontTrackShipmentStatusDesc: "Ottieni aggiornamenti in tempo reale sulle tue spedizioni e stime di consegna",
  dumontCalculateShippingCosts: "Calculate shipping costi",
  dumontCalculateShippingCostsDesc:
    "Stima i costi per diversi metodi di spedizione e destinazioni",
  dumontFindWarehouseLocations: "Find magazzino locations",
  dumontFindWarehouseLocationsDesc:
    "Scopri le posizioni ottimali dei magazzini per la tua rete di distribuzione",
  dumontManageInventoryLevels: "Gestisci inventario levels",
  dumontManageInventoryLevelsDesc: "Ottieni informazioni sull'ottimizzazione dell'inventario e gestione delle scorte",
  dumontScheduleDeliveries: "Programma deliveries",
  dumontScheduleDeliveriesDesc: "Plan and optimize consegna routes for maximum efficiency",
  dumontHowCanIHelpYou: "Come posso aiutarti?",
  invalidFileType: "Non valido file tipo",
  uploadFailed: "Carica failed",
  tooManyFiles: "Troppi file",
  filesExceedSizeLimit: "File exceed dimensione limit",
  allFilesUploadedSuccessfully: "Tutti file caricato con successo",
  moreBranches: "Più filiali",
  maximum10FilesPerUpload: "Maximum 10 file per carica.",
  generate: "Genera",
  onCSVWeHaveFoundSomeErrors:
    "Nel csv <strong>{{csvFileName}}</strong>, abbiamo trovato alcuni errori. Devi correggere quelle righe per procedere:",
  weReSecurelyLoadingYourDataIntoShipeeziSCertifiedFramework:
    "Stiamo caricando i tuoi dati in modo sicuro nel framework certificato di Shipeezi.",
  weFoundSomeIssuesInYourCSV:
    "Abbiamo trovato dei problemi nel tuo \u00ab {{csvFileName}} \u00bb. Correggi queste righe prima di continuare:",
  needHelp: "Serve aiuto?",
  forTheCorrectFormat: "per il formato corretto.",
  noScreenshotsCaptured: "Nessuna schermata catturata",
  noParticipantsAvailable: "No participants disponibile",
  companySlug: "Azienda slug",
  aUniqueIDUsedToIdentifyThisOrganization: "Un ID univoco utilizzato per identificare questa organizzazione",
  thisSubdomainIsNotAvailablePleaseChooseADifferentOne:
    "Questo sottodominio non è disponibile. Scegline uno diverso.",
  maximum10FilesPerUpload: "Maximum 10 file per carica.",
  fileIsTooBig: "Il file è troppo grande. La dimensione massima è 25 MB",
  multiFactorAuthentication: "Autenticazione multifattore",
  mfaMultiFactorAuthentication: "Autenticazione multifattore",
  configureMfaSettingsPerGroup: "Configure MFA impostazioni per gruppo",
  mfaSettings: "MFA Impostazioni",
  enableMfa: "Abilita MFA",
  mfaEnabled: "MFA Abilitato",
  mfaDisabled: "MFA Disabilitato",
  authenticationMethod: "Metodo di autenticazione",
  selectMethod: "Seleziona method",
  environments: "Ambienti",
  enabledEnvironments: "Abilitato environments",
  web: "Web",
  operationsApp: "App Operazioni",
  salesApp: "App Vendite",
  savingMfaSettings: "Salvataggio MFA impostazioni...",
  mfaSettingsUpdated: "MFA impostazioni aggiornato con successo",
  errorUpdatingMfaSettings: "Error aggiornamento MFA impostazioni",
  noGroupsFound: "Nessun gruppo trovato",
  mfaVerificationTitle: "Inserisci verification codice",
  mfaVerificationDescription: "Un codice di verifica è stato inviato a:",
  mfaVerificationCode: "Verification codice",
  verify: "Verifica",
  resendCode: "Resend codice",
  resendViaEmail: "Reinvia via email",
  resendViaSms: "Reinvia via SMS",
  mfaCodeResent: "Verification codice resent con successo",
  errorResendingCode: "Errore nell'invio del codice. Riprova.",
  invalidCode: "Codice non valido. Riprova.",
  codeExpired: "Codice expired",
  expiresIn: "Scade tra",
  email: "Email",
  sms: "SMS",
  smsRequiresPhoneNumber: "SMS Requires Telefono Numero",
  activeLoginSessions: "Attivo Login Sessions",
  operating_system: "Sistema operativo",
  application: "Applicazione",
  shipeezi_platform: "Piattaforma Shipeezi",
  ip_address: "IP Indirizzo",
  last_active_date: "Last Attivo",
  maximum10FilesPerUpload: "Maximum 10 file per carica.",
  youHaveToSelectAtLeastOnePlatform: "Devi selezionare almeno una piattaforma",
  prohibitSimultaneousLogin: "Impedisci accesso simultaneo",
  prohibitSimultaneousLoginDescription:
    "Impedisci agli utenti di accedere su più dispositivi o piattaforme contemporaneamente",
  applyToPlatforms: "Applica to platforms",
  selectEquipmentType: "Seleziona attrezzatura tipo",
  infoMessageEquipmentTypeFilterTitle: "Questo filtro è facoltativo.",
  infoMessageEquipmentTypeFilterNoSelection: "No selection → rapporto includes tutti attrezzatura types.",
  infoMessageEquipmentTypeFilterSpecificType:
    "Tipo specifico selezionato → il rapporto include solo le attività con quel tipo.",
  infoMessageEquipmentTypeFilterNoTasks:
    "Nessuna attività per il tipo selezionato → il rapporto non mostra risultati.",
  navigation: "NAVIGAZIONE",
  defaultTemplate: "Default Modello",
  originFile: "File origine",
  templateContent: "Modello Content",
  onboardingTrigger: "Onboarding",
  signupTrigger: "Registrazione",
  offboarding: "Disiscrizione",
  sendViaVideoSurveyLink: "Invia tramite link video sopralluogo",
  sendANewInvitationToTheScheduleVideoSurvey: "Invia un nuovo invito al video sopralluogo programmato",
  thereIsNoActiveVideoSurvey: "Non c'è nessun video sopralluogo attivo.",
  videoSurveyLinkSentToCustomer: "Video survey link sent to cliente",
  videoSurveyLinkSendFailed: "Video survey link invia failed",
  plainText: "Testo semplice",
  header: "Intestazione",
  copyrightText: "Testo copyright",
  shipeeziBranding: "Branding Shipeezi",
  scheduleSend: "Programma invia",
  sendDate: "Invia data",
  sendTime: "Invia time",
  selectAnUser: "Seleziona un utente",
  currentShipByDate: "Current Ship By Data",
  originalShipByDate: "Original Ship By Data",
  branding: "Branding",
  legal: "Legale",
  localization: "Localizzazione",
  unitSystem: "Sistema di unità",
  servicesAndTariffs: "Servizi e tariffe",
  dumontYou: "Tu",
  dumontSending: "Invio…",
  dumontTypeAMessage: "Tipo a message...",
  dumontThankYou: "Grazie!",
  dumontConnectionError: "Si è verificato un problema nel contattare Ask Dumont. Riprova più tardi.",
  dumontUnableToConnect: "Impossibile connettersi ad Ask Dumont.",
  dumontNoMessagesToCopy: "No messages to copia",
  dumontConversationCopied: "Conversation copiato to clipboard",
  dumontFailedToCopyConversation: "Failed to copia conversation",
  dumontNoMessagesToExport: "No messages to esporta",
  dumontChatExportedSuccessfully: "Chat exported con successo",
  dumontFailedToExportChat: "Failed to esporta chat",
  dumontNoMessagesToClear: "Nessun messaggio da cancellare",
  dumontConversationCleared: "Conversazione cancellata",
  dumontOpenInNewWindow: "Apri Dumont AI in a nuovo window",
  dumontCloseShortcut: "Click or press ⌘K to chiudi Dumont AI",
  wouldYouLikeToSendAnInviteToAgentName: "Vuoi inviare un invito a {{agentName}} per entrare nella tua rete Shipeezi?",
  selectAtLeastOneItem: "Seleziona almeno un elemento",
  shipmentNotFound: "Spedizione non trovata",
  expensesRecalculatedSuccessfully: "Spese ricalcolate con successo",
  reconnecting: "Riconnessione in corso",
  pleaseSelectAFile: "Per favore, seleziona un file!",
  commentsSavedSuccessfully: "Commenti salvati con successo",
  couldNotSaveComments: "Impossibile salvare i commenti",
  anErrorOccurred: "Si è verificato un errore",
  unknownError: "Errore sconosciuto",
  newNotification: "Nuova Notifica",
  externalAgentAssignmentInfo:
    "Sei assegnato a un agente esterno, che riceverà un invito via e-mail per accettare o rifiutare l'assegnazione. Se non c'è risposta, il sistema invierà e-mail di promemoria per tre giorni. Se l'agente non risponde entro tale periodo, l'attività verrà annullata automaticamente.",
  page: "pagina",
  originCriterion: "Criterio di Origine",
  originCriterionMustBeWOrP: "Il Criterio di Origine deve essere 'W' o 'P'",
  uploadPDF: "Carica PDF",
  addManualItems: "Aggiungi articoli manuali",
  editManualItems: "Modifica articoli manuali",
  editInventory: "Modifica inventario",
  describeEachBingoItem: "Inserisci una descrizione per ogni articolo qui sotto. Usa la paginazione quando aggiungi molti articoli.",
  createInventory: "Crea inventario",
  editInventoryManualTitle: "Modifica inventario (articoli manuali)",
  customerSurvey: "Sondaggio Cliente (Uscita)",
  statementOfAsp: "Dichiarazione dei Servizi Accessori Effettuati",
  downloadCsv: "Scarica CSV",
  associateShipmentToOrder: "Associa spedizione all'ordine",
  shipmentSavedAsDraft: "Spedizione salvata come bozza",
  shipmentCreationFailedAtIndex: "Impossibile creare la spedizione {{current}} di {{total}}. Le spedizioni precedenti potrebbero essere state salvate. Controlla l'ordine o aggiungi le spedizioni rimanenti manualmente.",
  scacCodePlaceholder: "Cerca o inserisci codice SCAC",
  grade: "Grado",
  gradePlaceholder: "es: A, B, C",
  scacInformation: "Informazioni SCAC",
  scacDescription: "Descrizione SCAC",
  claimsPhone: "Telefono Reclami",
  claimsEmail: "E-mail Reclami",
  itemIsTv: "L'articolo è un TV",
  screenSize: "Dimensione dello schermo",
  screenType: "Tipo di schermo",
  remoteControl: "Telecomando",
  powerCord: "Cavo di alimentazione",
  tvBaseStand: "Base/supporto TV",
  baseStandHardware: "Ferramenta base/supporto",
  tv: "TV",
  vehicle: "Veicolo",
  serialNumberVin: "Numero di serie / VIN",
  odometerMiles: "Chilometraggio contachilometri",
  km: "KM",
  accessoriesIncluded: "Accessori inclusi",
  gasTankEmpty: "Serbatoio carburante vuoto",
  fuelSystemPurged: "Sistema di alimentazione spurgo",
  batteryDisconnected: "Batteria scollegata",
  preApprovals: "Pre-approvazioni",
  noPreApprovals: "Nessuna pre-approvazione",
  approvalItem: "Elemento di Approvazione",
  goShareId: "ID Go Share",
  count: "Conteggio",
  storageInTransitOriginSit: "Stoccaggio in Transito (SIT Origine)",
  sitInDate: "Data ingresso SIT",
  sitOutDate: "Data uscita SIT",
  sitOutDateMustBeAfterSitInDate: "La data di uscita SIT deve essere successiva alla data di ingresso SIT.",
  sitNumber: "Numero SIT",
  baseCode: "Codice base",
  baseDescription: "Descrizione base",
  areaCode: "Codice area",
  areaDescription: "Descrizione area",
  zipCode: "Codice postale",
  itemIsVehicle: "L'articolo è un Veicolo",
  vehicleType: "Tipo di Veicolo",
  motorcycle: "Motocicletta",
  car: "Auto",
  boat: "Barca",
  startingNumber: "Numero Iniziale",
  decreaseStartingNumber: "Diminuisci numero iniziale",
  increaseStartingNumber: "Aumenta numero iniziale",
  editDescriptionForItem: "Modifica descrizione dell'articolo",
  itemDescriptionDefaultPlaceholder: "Si applica a tutti gli articoli di questo inventario",
  defaultManualInventoryItemDescription: "Vedi Inventario",
  customerSignature: "Firma del cliente",
  removalistName: "Nome del traslocatore",
  removalistSignature: "Firma del traslocatore",
  removeFile: "Rimuovi file",
  removeInventoryPdf: "Rimuovi PDF dell'inventario",
  removeInventoryPdfConfirmation: "Il PDF dell'inventario verrà rimosso da questo ordine. Gli articoli già aggiunti non verranno eliminati. Continuare?",
  viewInventory: "Visualizza Inventario",
  noDocumentsHaveBeenAddedYet: "Nessun documento è stato ancora aggiunto",
  askEnzo: "Chiedi a Enzo",
  enzoHelpDocumentation: "Aiuto e Documentazione",
  enzoSendFeedback: "Invia Feedback",
  enzoContactSupport: "Contatta il Supporto",
  enzoLearnHowToUseEnzo: "Impara a usare Enzo in modo efficace",
  enzoHelpUsImproveEnzo: "Aiutaci a migliorare Enzo",
  enzoGetHelpFromTeam: "Ottieni aiuto dal nostro team",
  enzoQuickActions: "Azioni Rapide",
  enzoContactOurSupport: "Contatta il nostro supporto",
  enzoGetHelpWithIssues: "Ottieni aiuto per qualsiasi problema o domanda",
  enzoSendUsYourFeedback: "Inviaci il tuo feedback",
  enzoShareThoughtsAndSuggestions: "Condividi le tue opinioni e suggerimenti",
  enzoCommonQuestions: "Domande Frequenti",
  enzoHowToCreateCustomAgent: "Come creo un agente personalizzato?",
  enzoHowToCreateCustomAgentAnswer: "Per creare un agente personalizzato, vai alla sezione Agenti e clicca sul pulsante « Crea Nuovo Agente ». Puoi poi configurare le capacità e le impostazioni dell'agente secondo le tue esigenze.",
  enzoWhatCanEnzoHelp: "In cosa può aiutarmi Enzo?",
  enzoWhatCanEnzoHelpAnswer: "Enzo è il tuo assistente IA specializzato in logistica e traslochi. Posso aiutarti nella pianificazione delle spedizioni, gestione degli ordini, ottimizzazione dei percorsi e rispondere alle domande sulle tue operazioni.",
  enzoHowToAccessChatHistory: "Come accedo alla cronologia delle conversazioni?",
  enzoHowToAccessChatHistoryAnswer: "Clicca sull'icona Cronologia nella barra laterale per vedere tutte le tue conversazioni passate con Enzo. Puoi cercare nella cronologia e riprendere qualsiasi conversazione precedente.",
  enzoCanCustomizeAgentCapabilities: "Posso personalizzare le capacità degli agenti?",
  enzoResources: "Risorse",
  enzoKnowledgeBase: "Base di Conoscenza",
  enzoCompleteGuidesAndTutorials: "Guide e tutorial completi",
  enzoSelectAnOption: "Seleziona un'opzione",
  enzoFeedbackHelpsImprove: "Il tuo feedback ci aiuta a migliorare Enzo",
  enzoIssueType: "Tipo di Problema",
  enzoSubject: "Oggetto",
  enzoBriefDescriptionOfIssue: "Breve descrizione del problema",
  enzoMessage: "Messaggio",
  enzoPleaseDescribeIssueDetail: "Descrivi il tuo problema in dettaglio...",
  enzoIncludeErrorMessages: "Includi messaggi di errore o passaggi per riprodurre il problema",
  enzoGotIt: "Capito",
  enzoCancel: "Annulla",
  enzoSendFeedbackButton: "Invia Feedback",
  enzoSendMessage: "Invia Messaggio",
  enzoSupportRequestSentSuccessfully: "La tua richiesta di supporto è stata inviata con successo. Il nostro team risponderà entro 24 ore.",
  enzoFeedbackSentSuccessfully: "Il tuo feedback è stato inviato con successo. Apprezziamo il tuo contributo!",
  enzoSearchPlaceholder: "Cerca conversazioni, agenti, cronologia...",
  enzoNavigation: "Navigazione",
  enzoNewChat: "Nuova Conversazione",
  enzoChats: "Conversazioni",
  enzoNoChatsFound: "Nessuna conversazione trovata",
  enzoNoRecentChats: "Nessuna conversazione recente",
  enzoAgents: "Agenti",
  enzoNoAgentsFound: "Nessun agente trovato",
  enzoReturnToShipeezi: "Torna a Shipeezi",
  enzoHelp: "Aiuto",
  enzoWelcomeMessage: "Ciao, {{userName}}, sono Enzo, il tuo assistente IA specializzato in logistica e traslochi. Progettato per semplificare flussi di lavoro complessi, imparo continuamente per offrire un supporto più rapido, intelligente e preciso alla tua attività.",
  enzoWelcomeMessageBusiness: "Ciao, {{userName}}, sono Enzo Assistente Commerciale! 💼 Sono specializzato in vendite e preventivi. Posso aiutarti a creare preventivi di trasporto precisi, gestire le relazioni con i clienti e chiudere affari più velocemente. Come posso aiutarti oggi?",
  enzoWelcomeMessageOperations: "Ciao, {{userName}}, sono Enzo Assistente Operazioni! 📊 Sono il tuo esperto in operazioni. Posso aiutarti a tracciare spedizioni, monitorare consegne, gestire lavori e garantire operazioni logistiche fluide. Di cosa hai bisogno?",
  enzoWelcomeMessageWarehousing: "Ciao, {{userName}}, sono Enzo Assistente Magazzino! 🏭 Sono specializzato in inventario e operazioni di magazzino. Posso aiutarti a gestire i livelli di stock, tracciare l'inventario, coordinare lo stoccaggio e ottimizzare l'efficienza del magazzino. Come posso aiutare?",
  enzoDispatchQuickActions: "Azioni rapide per la Spedizione",
  enzoHistory: "Cronologia",
  enzoConversationHistory: "Cronologia delle Conversazioni",
  enzoNoConversationsFound: "Nessuna conversazione trovata",
  enzoNoConversationHistory: "Nessuna cronologia delle conversazioni",
  enzoTryDifferentSearchTerm: "Prova con un termine di ricerca diverso",
  enzoStartNewConversation: "Inizia una nuova conversazione per vederla qui",
  enzoFileTooLarge: "Il file è troppo grande. La dimensione massima è 10MB.",
  enzoUnsupportedFileType: "Tipo di file non supportato. Seleziona file TXT, PDF o DOC/DOCX.",
  enzoDocumentProcessing: "L'elaborazione di PDF/DOC sarà disponibile a breve. Per ora usa file TXT.",
  enzoFileProcessingError: "Errore nell'elaborazione del file. Riprova.",
  enzoAskEnzo: "Chiedi a Enzo...",
  enzoAskEnzoAnything: "Chiedi qualsiasi cosa a Enzo",
  enzoUpload: "Carica",
  enzoUsesAI: "Enzo utilizza l'Intelligenza Artificiale. Verifica le risposte.",
  enzoCopyConversation: "Copia conversazione",
  enzoExportChat: "Esporta conversazione",
  enzoClearConversation: "Cancella conversazione",
  enzoLoadingAgents: "Caricamento agenti...",
  enzoAgentsTitle: "Agenti Enzo",
  enzoCreateAgent: "Crea Agente",
  enzoSearchAgents: "Cerca agenti...",
  enzoNoAgentsAvailable: "Nessun agente disponibile",
  enzoAgentsAvailableSoon: "Gli agenti saranno disponibili a breve",
  enzoComingSoon: "Prossimamente...",
  enzoBusinessAssistant: "Assistente Commerciale",
  enzoBusinessAssistantDesc: "Specializzato in vendite e preventivi",
  enzoOperationsAssistant: "Assistente Operazioni",
  enzoOperationsAssistantDesc: "Il tuo esperto in operazioni",
  enzoWarehousingAssistant: "Assistente Magazzino",
  enzoWarehousingAssistantDesc: "Esperto in inventario e operazioni di magazzino",
  enzoCanCustomizeAgentCapabilitiesAnswer: "Sì! Ogni agente può essere personalizzato per adattarsi al tuo flusso di lavoro specifico. Puoi regolare le sue capacità, impostare parametri specifici e configurare a quali fonti di dati ha accesso.",
  enzoFeedbackType: "Tipo di Feedback",
  enzoYourFeedback: "Il Tuo Feedback",
  enzoTellUsWhatYouThink: "Dicci cosa ne pensi...",
  enzoPleaseSelectTextFile: "Seleziona un file di testo (.txt)",
  enzoDocumentAttached: "Documento allegato",
  enzoRemoveDocument: "Rimuovi documento",
  enzoDefaultResponse: "Grazie per averci contattato! Sto analizzando la tua richiesta e fornirò la migliore soluzione.",
  enzoSales: "Vendite",
  enzoOperations: "Operazioni",
  enzoLogistics: "Logistica",
  enzoDispatchShowTodayOrders: "Mostra gli ordini di spedizione di oggi",
  enzoDispatchShowTodayOrdersDesc: "Ottieni un riepilogo di tutti gli ordini programmati per la spedizione oggi",
  enzoDispatchFindCustomer: "Cerca ordini per nome cliente",
  enzoDispatchFindCustomerDesc: "Cerca ordini specifici usando le informazioni del cliente",
  enzoDispatchTrackStatus: "Traccia lo stato dell'ordine",
  enzoDispatchTrackStatusDesc: "Verifica lo stato attuale degli ordini nel sistema",
  enzoDispatchOptimizeRoutes: "Ottimizza i percorsi di consegna",
  enzoDispatchOptimizeRoutesDesc: "Ottieni suggerimenti per i percorsi di consegna più efficienti",
  enzoWhatCanIHelpYouWith: "In cosa posso aiutarti?",
  enzoOptimizeLogisticsOperations: "Ottimizza le mie operazioni logistiche",
  enzoOptimizeLogisticsOperationsDesc: "Ottieni raccomandazioni personalizzate per migliorare l'efficienza e ridurre i costi",
  enzoTrackShipmentStatus: "Traccia lo stato della spedizione",
  enzoTrackShipmentStatusDesc: "Ottieni aggiornamenti in tempo reale sulle tue spedizioni e stime di consegna",
  enzoCalculateShippingCosts: "Calcola i costi di spedizione",
  enzoCalculateShippingCostsDesc: "Stima i costi per diversi metodi di spedizione e destinazioni",
  enzoFindWarehouseLocations: "Trova ubicazioni di magazzino",
  enzoFindWarehouseLocationsDesc: "Scopri le ubicazioni di magazzino ottimali per la tua rete di distribuzione",
  enzoManageInventoryLevels: "Gestisci i livelli di inventario",
  enzoManageInventoryLevelsDesc: "Ottieni informazioni sull'ottimizzazione dell'inventario e la gestione delle scorte",
  enzoScheduleDeliveries: "Programma le consegne",
  enzoScheduleDeliveriesDesc: "Pianifica e ottimizza i percorsi di consegna per la massima efficienza",
  enzoHowCanIHelpYou: "Come posso aiutarti?",
  fileSizeIsTooLarge: "Il file è più grande di 2MB",
  propertyDamageReport: "Rapporto danni alla proprietà",
  optional: "Facoltativo",
  photoRequiredAtUpliftCompletion: "Foto richiesta al completamento del ritiro",
  customerPhoneNumber: "Numero di telefono del cliente",
  alternativePhone: "Telefono alternativo",
  alternativeEmail: "E-mail alternativa",
  mailingAddress: "Indirizzo postale",
  customerFields: "Campi del cliente",
  requireCustomerInformationFields: "Richiedi campi informazioni cliente",
  customerFieldsWillBeRequired: "I campi del cliente saranno obbligatori",
  selectMadatory: "Seleziona obbligatorio",
  military: "Militare",
  templateType: "Tipo di modello",
  assignedTemplate: "Modello assegnato",
  packingList: "Lista di imballaggio",
  billOfLading: "Polizza di carico",
  inventoryReport: "Rapporto di inventario",
  shippingManifest: "Manifesto di spedizione",
  deliveryReceipt: "Ricevuta di consegna",
  customsDeclaration: "Dichiarazione doganale",
  saveTemplates: "Salva modelli",
  shipeeziDefault2: "Predefinito Shipeezi",
  clientCustomTemplate: "Modello Personalizzato del Cliente",
  customTemplate: "Modello Personalizzato",
  reportTemplates: "Modelli di Report",
  defineWhichTemplateEachReportUses: "Definisci quale modello utilizza ogni report. I modelli vengono salvati per azienda e sono visibili solo per gli account Militari. Identifica se ogni report utilizza il modello predefinito Shipeezi o un modello personalizzato del cliente.",
  accessToThisSectionIsRestrictedByPermissionLevel: "L'accesso a questa sezione è limitato per livello di permesso. Le modifiche vengono salvate per azienda e nascoste agli account Commerciali.",
  customerPortalAddress: "Indirizzo del Portale Clienti",
  definesLinkYourCustomerWillUse: "Definisce il link che i tuoi clienti useranno per tracciare gli ordini e visualizzare i dettagli delle spedizioni",
  dateFormat: "Formato data",
  timeFormat: "Formato ora",
  accountPreferences: "Preferenze dell'account",
  addPreApprovalItem: "Aggiungi elemento di pre-approvazione",
  removePreApprovalItem: "Rimuovi elemento",
  pleaseFillAllPreApprovalFields: "Compila la descrizione della pre-approvazione per ogni riga.",
  unitOfMeasure: "Unità di Misura (UdM)",
  boxes: "Scatole",
  pairs: "Paia",
  sets: "Set",
  pallets: "Pallet",
  customerLogo: "Logo del Cliente",
  removeShipmentFromOrder: "Rimuovi Spedizione dall'Ordine",
  thisShipmentHasNoOtherOrdersAssociated: "Questa spedizione non ha altri ordini associati. Cosa vuoi fare?",
  revertToDraft: "Ripristina a Bozza",
  leaveAsDraft: "Lascia come Bozza",
  cancelShipment: "Annulla Spedizione",
  MB: "MB",
  "Search...": "Cerca...",
  activate: "attiva",
  inactivate: "disattiva",
  cancelButton: "Annulla",
  cereLifeLocalAmount: "Importo locale CereLife",
  commercial: "Commerciale",
  confirmDelete: "Elimina",
  confirmation: "Conferma",
  containerId: "ID contenitore",
  createANewPort: "Crea un nuovo porto",
  customerLastName: "Cognome cliente",
  customerPhone: "Telefono cliente",
  dateCannotBeInThePast: "La data non può essere nel passato",
  decimalPlaces: "Decimali",
  deleteData: "Elimina dati",
  deletePlaceholderTask: "Elimina attività segnaposto",
  editPort: "Modifica porto",
  emailIsInvalid: "Email non valida",
  errorFetchingTriggers: "Errore nel recupero dei trigger",
  errorLoadingTemplates: "Errore nel caricamento dei modelli",
  errorReadingFile: "Errore nella lettura del file",
  errorUpdatingTemplate: "Errore nell'aggiornamento del modello",
  errorUploadingFile: "Errore nel caricamento del file",
  errorValidatingTemplateName: "Errore nella validazione del nome del modello",
  inAMoment: "tra un momento",
  invalidDateTime: "Data e ora non valide",
  invalidTimeFormat: "Formato ora non valido",
  inviteAgent: "Invita agente",
  invoicedAmount: "Importo fatturato",
  iso174511Description:
    "Usa l'elenco inventario predefinito Shipeezi certificato ISO17451-1:2016. Puoi aggiornarlo o espanderlo in qualsiasi momento.",
  itShouldBeAtLeastOneBranch: "Deve esserci almeno una filiale",
  itShouldHaveLeastOneBranch: "Devi avere almeno una filiale",
  "label.item.packaging": "Imballaggio articolo",
  last: "Ultimo",
  loadingLocations: "Caricamento ubicazioni...",
  militaryReportsDescription: "Configura i modelli di report per gli account militari.",
  noInformationToBeShwon: "Nessuna informazione da mostrare",
  noLinkedAutomationsFound: "Nessuna automazione collegata trovata",
  noReports: "Nessun report",
  only: "Solo",
  operationFailed: "Operazione non riuscita",
  origins: "Origini",
  picture: "Immagine",
  pictures: "Immagini",
  pushCharacterLimitExceeded: "Limite caratteri notifica push superato",
  scheduledTimeCannotBeInThePast: "L'orario programmato non può essere nel passato",
  seconds: "secondi",
  selectAContainerNumber: "Seleziona un numero di contenitore",
  selectAtLeastOneTarget: "Seleziona almeno un obiettivo",
  selectOptions: "Seleziona opzioni",
  sending: "Invio in corso",
  shipeeziDefaultTemplate: "Modello predefinito Shipeezi",
  shipmentInformation: "Informazioni spedizione",
  smsCharacterLimitExceeded: "Limite caratteri SMS superato",
  someFilesFailedToUpload: "Impossibile caricare alcuni file",
  taskUnpublishedCannotBeEdited: "Le attività non pubblicate non possono essere modificate",
  theLimitOfLinesIs: "Il limite di righe è",
  thisCustomerDoesNotHaveAnEmailToSendInvitation: "Questo cliente non ha un'email per inviare l'invito",
  thisFieldIsNumber: "Questo campo deve essere un numero",
  uploadCategories: "Categorie di caricamento",
  uploadCategoriesDescription: "Carica l'elenco delle categorie per iniziare.",
  uploadCentreDescription:
    "Qui puoi caricare i tuoi file (inventario, personale, elenchi di servizi) o iniziare con l'elenco predefinito Shipeezi. Puoi aggiornarlo in qualsiasi momento.",
  useShipeeziSDefaultListDescription:
    "Inizia rapidamente con il nostro elenco preconfigurato, basato sullo standard globale ISO17451-1:2016. Puoi aggiornarlo o espanderlo in qualsiasi momento.",
  url: "URL",
  v: "V",
  youCannotInviteInactiveCustomers: "Non puoi invitare clienti inattivi",
  youDontHavePermissionToAccessShipmentData: "Non hai il permesso di accedere ai dati della spedizione",
  youHaveToAddAtLeastOneOrder: "Devi aggiungere almeno un ordine",
  youMustEnterAAgentId: "Devi inserire un ID agente",
  youMustHaveAtLeastOneContact: "Devi avere almeno un contatto",
  youMustHaveAtLeastOnePrimaryContact: "Devi avere almeno un contatto principale",
  yourPasswordMustBeAtLeast6CharactersLong: "La password deve contenere almeno 6 caratteri",
  memberCode: "Codice membro",
  uploadOwnListDescription: "Importa i tuoi dati per personalizzare Shipeezi fin dall'inizio.",
  downloadCsvTemplate: "Scarica modello CSV",
};
